(function() {
  'use strict';
  angular .module('irricrops')
  .controller('newtimelineCtrl', timelineCtrl);

  timelineCtrl.$inject = ["$scope", "$http", "$stateParams", "$mdDialog",'focus','cuartelDialog','$mdBottomSheet','VinedoRes',
  "$mdToast", "$timeout", "urls", "$filter",'CONSTANTES','EquipoRes','newTimelineUtils', 'dialogMultiInput',"menu",
  "CuartelRes","Config", "newTimelineFactory", "temporadaFac", "$q", "VinedoFac", "File", "global", "selectionToolbar", "fertilizacionRes"];

  /* @ngInject */
  function timelineCtrl($scope, $http, $stateParams, $mdDialog,focus,cuartelDialog, $mdBottomSheet, VinedoRes,
    $mdToast, $timeout, urls, $filter, CONSTANTES,EquipoRes,utils, dialogMultiInput,menu,
    CuartelRes, Config, tlFac, temporadaFac, $q, VinedoFac, File, global, selectionToolbar, fertilizacionRes){

    var vm                     = this;
    //var dias                 = [];
    var inicioSemana           = moment().startOf('isoWeek');
    var fechaInicio            = angular.copy(inicioSemana).subtract(3, "weeks");
    var fechaTermino           = angular.copy(inicioSemana).add(2, "weeks").subtract(1, "day");
    //var fechaInicioAux       = angular.copy(fechaInicio);
    var diffDays         = _.floor(fechaTermino.diff(fechaInicio, 'hours') / 24);
    var r                = 30;                                                   //ancho dia
    var et_semanales     = [];
    var temperaturasHora = [];
    var diaLimiteWarning = 2;
    var _timeout         = [];


    vm.semaforo = {
      yellow : 50,
      red    : 25
    };

    var el                     = $(".timeline2");
    var $tlc                   = el.find('.tl-container');
    var $hoverCursor           = el.find('.hover-cursor');
    var $dayDetail             = el.find('.tl-container #timeline2-detail-day');
    var $sidebar               = el.find('nav');
    var $sidebarExtended       = el.find('.sidebar-extended');
    var $sidebarRight          = el.find('.sidebar-right');
    var $headerRight           = el.find('.header-sidebar-right');
    var $header                = el.find('header');
    var $canvas                = $("<canvas/>")

    //var leftOffset           = 200; //TODO hacer dinamico
    var topOffset              = 0;
    var hideBackdropCallback   = null;
    var diasProgramacion       = 7;
    var cantidadSectores       = 0;

    vm.usaMM                   = Config.vinedo.usaMM || false ;
    vm.vinedo_id               = $stateParams.id;
    vm.vina                    = null;

    menu.getSidebarProm().then(function(){
      vm.vina = global.getVinaByVinedoId($stateParams.id);
    })

    vm.vinedo_nombre           = "";

    vm.config                  = Config;
    vm.espacio                 = {}; //espacio visual para programacion de riego
    vm.buttonTogglePosition    = 0; // Altura de boton que muestra/oculta detalles en el sidebar

    vm.equipos                 = [];
    vm.casetas                 = [];
    vm.lastPosition            = diffDays * r;
    vm.diasSeleccionados       = [];
    vm.visibleSidebarRight     = false;
    vm.visibleSidebarDetails   = false;
    vm.showedHeaderInputs      = false;
    vm.hoy                     = moment().hours(0).utc();
    vm.generalLoading          = true;
    vm.completeLoading         = true;
    vm.diaHover                = null;
    vm.diasHeader              = [];
    vm.diasMesHeader           = [];
    vm.temporadas              = [];
    vm.temporadaSelectedWindow = null;
    vm.temporadaFertSelected   = null;
    vm.showedWindowEstado      = false;
    vm.showedWindowEtapasFert      = false;
    vm.showedWindow            = false;
    vm.estadoNuevo             = null;
    vm.newScholander           = 0;
    vm.inputTempRiego          = 0;
    vm.inputHumedadRiego       = 0;
    vm.newPorometro            = 0;
    vm.r                       = r;
    vm.isMobile                = false;
    vm.mobileEditableMode      = false;
    vm.temporadaActiva         = null;

    vm.variedades              = [];
    vm.calidades               = [];
    vm.editable                = Config.user["editar-timeline"] || false;
    vm.canvasWidth             = 0
    vm.equipoSelected          = null;
    vm.casetaSelected          = null;
    vm.variedadSelected        = null;
    vm.etx                     = 0;

    vm.sectoresSensor          = [];
    vm.sectoresCalicata        = [];
    //vm.profundidadesInput      = [];

    vm.profundidade    = [];
    vm.calicataAlturas = [];

    vm.litrosFertiriego        = 0;


    vm.loadingXlsMai    = false;
    vm.loadingEtCsv     = false;
    vm.loadingTempCsv   = false;
    vm.loadingPrecipCsv = false;
    vm.uploading        = false;

    vm.inputTempRiego    = 0;
    vm.inputHumedadRiego = 0;

    vm.mensajeInput = "";
    vm.mensajeInputDirty = false;



    vm.fabMobile = {
      isOpen            : false,
      count             : 0,
      selectedDirection : 'left'
    };


    vm.tiposFertilizacion = [
      {
        id: 1,
        label: "unidad total"
      },
      {
        id: 2,
        label: "unidad/ha"
      },
      {
        id: 3,
        label: "Gr/ltrs"
      },
    ];

    //se usa configuracion para preseleccionar tipo de fertilizacion, no restringe
    if(vm.config.vinedo['fertGramosPorLitro']){
      vm.tipoFertilizacionSelected = vm.tiposFertilizacion[2];
    }else if(vm.config.vinedo['fertUnidadPorHa']){
      vm.tipoFertilizacionSelected = vm.tiposFertilizacion[1];
    }else{
      vm.tipoFertilizacionSelected = vm.tiposFertilizacion[0];
    }




    vm.positionArrow = function(){
      //posicionamiento de botones de carga de dias
      $timeout(function(){
        var $h = $(".header-sidebar-extended");
        var left = parseInt($h.width()) + parseInt($h.css("left"));
        var diff = $(".timeline2").width() - left - $(".load-more-days.after").width() - 30;
        $(".load-more-days.after").css({
          left: diff
        });

        $(".load-more-days").css({
          marginLeft: left
        });
      }, 10);

    }



    var detectScroll = function () {
      var $hoy = $(".hoy");
      if($hoy.length > 0 ){
        $tlc.scrollLeft($(".hoy").parent().parent().position().left - 150);
      }else{
        $timeout(function () {
         detectScroll();
        }, 100);
      }
      vm.positionArrow();
    };
    detectScroll();




    Date.prototype.cleanHour= function(){
      var D = this;
      return moment(D).hours(0).minute(0).seconds(0).toDate();
    }

    el.scrollLeft(0);

    vm.tabs = [
      {
        id: 1,
        nombre: "Riego",
        tag:'riego',
        class:"tab-riego"
      },
      {
        id: 2,
        nombre: "Scholander",
        tag: 'scholander',
        class: "tab-scholander",
        config: "conScholander"
      },
      {
        id: 3,
        nombre: "Calicata",
        tag: 'porometro',
        class: "tab-porometro",
        config: "conPorometro"
      },


      {
        id: 4,
        nombre: "Programación",
        tag: 'programacion',
        class: "tab-programacion",
        permission: "editar-equipo-programacion"
      },
      {
        id: 5,
        nombre: "Sensores",
        tag: 'sensores',
        class: "tab-sensores",
        config: 'has-sensor-en-planilla'
        //permission: "editar-equipo-programacion"
      },

      {
        id: 7,
        nombre: "Calicata Prof",
        tag: 'calicata',
        class: "tab-calicata",
        config: 'conCalicata'
        //permission: "editar-equipo-programacion"
      },
      /*{
        id: 5,
        nombre: "Fenología",
        tag : 'fenologia',
        class: "tab-fenologia"
      },
      {
        id: 6,
        nombre: "Crecimiento Fruto",
        tag: 'crecimiento',
        class: "tab-crecimiento",
        //config: "gramaje"
      },
      */

    ];


    vm.cons = {
      TAB_RIEGO        : vm.tabs[0],
      TAB_SCHOLANDER   : vm.tabs[1],
      TAB_POROMETRIA   : vm.tabs[2],
      TAB_PROGRAMACION : vm.tabs[3],
      TAB_SENSOR       : vm.tabs[4],
      TAB_CALICATA     : vm.tabs[5],
      //TAB_FENOLOGIA    : vm.tabs[4],
      //TAB_CRECIMIENTO  : vm.tabs[4],
    };



    vm.selectedTab = vm.tabs[0];


    vm.selectTab = function(tab) {
      vm.selectedTab = tab;
      drawBoard({
        width: diffDays * r + r,
        height: calcularTotalSectores() * r,
        square:{
          width: r,
          height: r
        }
      });
    }

    vm.userPermission = function (tab) {
      if(tab.permission === undefined){
        return true;
      }
      return Config.user[tab.permission] || false;
    }
    vm.tabHasConfig = function (tab) {
      if(tab.config === undefined){
        return true;
      }
      return Config.vinedo[tab.config] || false;
    }



















    //----------------------------
    // sensores ------------------
    //----------------------------


    vm.getSectoresSensor = function(params){
      return VinedoRes.getSensores(params);
      /*
      {
        vinedo_id : $stateParams.id,
        fecha_inicio : fechaInicio.format("DD-MM-YYYY"),
        fecha_fin    : fechaTermino.format("DD-MM-YYYY"),
        periodo   : vm.temporadaActiva.periodo,
        //con_sensores: false
      });
      */
    }


    vm.getSectorSensor = function(params){
      return CuartelRes.getSensores(params);
    }






    vm.guardarMultiInputSensores = function(){
      var promises = [];
      _.forEach(vm.diasSeleccionados, function(cuartelDia) {
        promises.push(vm.guardarSensores(cuartelDia.dia));
      });
      $q.all(promises)
        .then(function(res){

          _.forEach(vm.diasSeleccionados, function(cuartelDia) {
            //console.log("regenera sector server");
            regenerarSectorServer(cuartelDia.sector);
          });


          $mdToast.show(
            $mdToast.simple()
            .content("Dato guardado satisfactoriamente")
            .position(CONSTANTES.TOAST_POSITION)
            .hideDelay(3000)
          );
          limpiarMultiInput();
        }, function(res_error){
          console.error(res_error);
          vm.guardarMensaje();
          limpiarMultiInput();
        });
    }





    vm.guardarSensores = function(dia){
      var promises = [];
      var datos    = [];
      vm.profundidades.forEach(function(prof){
        //if(!prof.value) prof.value = null;
        datos.push({
          sensor_id : prof.id,
          cantidad  : parseFloat(prof.value) || null,
          fecha     : dia.fecha
        })
      });

      return $http.post(urls.BASE+"/sensor/dato", {datos: datos});
    }




    function getSectorSensorBySector(cuartel, momentDate) {
      var cuarteles                = [];
      var cuartelesIds             = [];
      var sectorSensorSeleccionado = null;
      angular.forEach(vm.sectoresSensor, function(sectorSensor) {
        angular.forEach(sectorSensor.cuarteles, function(cuartelSS) {
          if(cuartelSS && cuartel.id == cuartelSS.id){
            cuartelesIds = _.map(sectorSensor.cuarteles, "id");
            _.each(sectorSensor.cuarteles, function(cuartelSS){
              cuarteles.push(utils.getSectorById(vm.equipos, cuartelSS.id));
            });
            sectorSensorSeleccionado = sectorSensor;
          }
        })
      });
      if(sectorSensorSeleccionado && sectorSensorSeleccionado.profundidades){
        vm.profundidades = sectorSensorSeleccionado.profundidades.map(function(prof, indexProf){
          var value = null;
          if(momentDate){
            var datoSensor = _.find(sectorSensorSeleccionado.datos, function(d){
              return moment.unix(d[0]).isSame(momentDate, "day");
            })
            if(datoSensor && datoSensor[indexProf + 1]){
              value = datoSensor[indexProf + 1];
            }
          }
          return {
            prof  : prof[0],
            id    : prof[1],
            value :value
          }
        });
      }
      return {
                cuarteles    : cuarteles,
                cuartelesIds : cuartelesIds,
                sectorSensor : sectorSensorSeleccionado
            };
    }





    vm.getEquipoBySector = function(sector){
      return _.find(vm.equipos, function(eq){
        return _.find(eq.sector_riego, {id: sector.id});
      })
    }











    //----------------------------
    // calicatas ------------------
    //----------------------------





    vm.getSectoresCalicata = function(params){
      return VinedoRes.getCalicatas(params);
    }


    vm.getSectorCalicata = function(params){
      return CuartelRes.getCalicatas(params);
    }






    vm.guardarMultiInputCalicata = function(){
      var promises = [];
      _.forEach(vm.diasSeleccionados, function(cuartelDia) {
        promises.push(vm.guardarCalicatas(cuartelDia.dia));
      });
      $q.all(promises)
        .then(function(res){

          _.forEach(vm.diasSeleccionados, function(cuartelDia) {
            //console.log("regenera sector server");
            regenerarSectorServer(cuartelDia.sector);
          });


          $mdToast.show(
            $mdToast.simple()
            .content("Dato guardado satisfactoriamente")
            .position(CONSTANTES.TOAST_POSITION)
            .hideDelay(3000)
          );
          limpiarMultiInput();
        }, function(res_error){
          console.error(res_error);
          vm.guardarMensaje();
          limpiarMultiInput();
        });
    }





    vm.guardarCalicatas = function(dia){
      var promises = [];
      var datos    = [];
      vm.calicataAlturas.forEach(function(altura){
        //if(!prof.value) prof.value = null;
        datos.push({
          altura_id : altura.id,
          cantidad  : parseFloat(altura.value) || null,
          conductividad: parseFloat(altura.conductividad) || null,
          fecha     : dia.fecha
        })
      });

      return $http.post(urls.BASE+"/calicata/dato", {datos: datos});
    }





    function getSectorCalicataBySector(cuartel, momentDate) {

      var cuarteles                  = [];
      var cuartelesIds               = [];
      var sectorCalicataSeleccionado = null;

      angular.forEach(vm.sectoresCalicata, function(sectorCalicata) {
        angular.forEach(sectorCalicata.cuarteles, function(cuartelSS) {
          if(cuartelSS && cuartel.id == cuartelSS.id){
            cuartelesIds = _.map(sectorCalicata.cuarteles, "id");
            _.each(sectorCalicata.cuarteles, function(cuartelSS){
              cuarteles.push(utils.getSectorById(vm.equipos, cuartelSS.id));
            });
            sectorCalicataSeleccionado = sectorCalicata;
          }
        })
      });

      if(sectorCalicataSeleccionado && sectorCalicataSeleccionado.profundidades){
        vm.calicataAlturas = sectorCalicataSeleccionado.profundidades.map(function(altura , indexProf){

          //TODO revisar parseo de sectores calicata

          var value         = null;
          var conductividad = null;

          if(momentDate){
            var datoCalicata = _.find( sectorCalicataSeleccionado.datos, function(d){
              return moment.unix(d[0]).isSame(momentDate, "day");
            })
            if(datoCalicata && datoCalicata [indexProf + 1]){
              value = datoCalicata[indexProf + 1][0];
              conductividad = datoCalicata[indexProf + 1][1];
            }
          }

          return {
            altura        : altura[0],
            id            : altura[1],
            value         : value,
            conductividad : conductividad
          }
        });
      }

      return {
                cuarteles    : cuarteles,
                cuartelesIds : cuartelesIds,
                sectorCalicata: sectorCalicataSeleccionado
            };
    }


































    //----------------------------
    // fertilizacion -------------
    //----------------------------

    /*
    TODO: totales de elementos por etapas/sector
    */

    //variables usadas para la UI
    vm.fertilizacionApi = {
      showedWindow : false
    };

    vm.sumElements      = [];

    //variables para la vista
    vm.fertArray            = [];  //array de fertilizacion, para un sector , TODO revisar
    vm.fertSectores         = [];  //sectores
    vm.fertEtapas           = [];  //etapas
    vm.fertSectorTitles     = [];  //titulos en el sidebar ampliado del sector
    vm.fertProductos        = [];  //lista de productos
    vm.fertProgramas        = [];  //lista de programas
    vm.fertInputProductos   = [];
    vm.fertProgramaSelected = null;


    // variables de cada tab, se asignan a la vista segun necesidad
    var fertArrayPrograma        = [];
    var fertSectoresPrograma     = [];
    var fertEtapasPrograma       = [];
    var fertSectorTitlesPrograma = [];

    var fertArrayAnalisis        = [];
    var fertSectoresAnalisis     = [];
    var fertEtapasAnalisis       = [];
    var fertSectorTitlesAnalisis = [];

    vm.showAllFert = false;


    //productos, para multiInput
    /*
    vm.fertInputProd = [
      {
        value:null,
        sugestion:123,
        name:"Producto Nº"+_.random(1, 1000),
        subfix:"Kg",
        steps:4,
        readyStep: 2
      },
      {
        value:null,
        sugestion:123,
        name:"Producto Nº"+_.random(1, 1000),
        subfix:"Kg",
        steps:4,
        readyStep: 2
      },
      {
        value:null,
        sugestion:123,
        name:"Producto Nº"+_.random(1, 1000),
        subfix:"Kg",
        steps:4,
        readyStep: 2
      },
    ];
    */

    // productos adicionales, para multiInput
    /*
    vm.fertInputOther = [
      {
        value:null,
        name:"Producto Nº"+_.random(1, 1000),
        subfix:"Kg",
        steps:4,
        readyStep: 2
      },
      {
        value:null,
        name:"Producto Nº"+_.random(1, 1000),
        subfix:"Kg",
        steps:4,
        readyStep: 2
      },
      {
        value:null,
        name:"Producto Nº"+_.random(1, 1000),
        subfix:"Kg",
        steps:4,
        readyStep: 2
      },
    ];
    */


    fertSectorTitlesPrograma = [
      {
        name: "Unidades por Ha",
      },
      {
        name: "Cant. Aplic."
      }
    ];

    var prepareAplicacionInput = function(productos){
      //TODO separar entre sugeridos y el resto
      //TODO pasos y pasos listos
      var inputProductos = [];
      _.forEach(productos, function(prod){
        inputProductos.push(_.merge(_.cloneDeep(prod),{
          value:  prod.gramos_litro || "",
          sugestion: "00",
          //steps: 4,
          //readyStep: 2
        }));
      });
      return inputProductos;
    }

    //deprecated
    vm.getFertilizacion = function(){
      //cargar fertilizacion
      if(vm.temporadaFertSelected == null){
        vm.temporadaFertSelected= temporadaFac.getActiva();
      }
      fertilizacionRes.getVinedo({
        vinedo_id: vm.vinedo_id,
        periodo: vm.temporadaFertSelected.periodo,
      }, function(res){
        fertilizacionRes.getElementos({
          vinedo_id: vm.vinedo_id
        }, function(res){
          vm.fertElementos = res.data;
        })
        vm.fertProgramas = _.sortBy(res.data.programas, "nombre");
        _.forEach(vm.fertProgramas, function(programa){
          programa.loading    = false;
          programa.edit       = false;
          programa.editable   = true;
          programa.nombreEdit = programa.nombre;
          _.forEach(programa.sectores, function(sector){
            sector.etapas.sort(function compare(a, b) {
              var dateA = new Date(a.fecha_inicio);
              var dateB = new Date(b.fecha_inicio);
              return dateA - dateB;
            });
          });
        });

        _.forEach(res.data.productos, function(p){
          p.elementos = _.map(p.elementos, function(e){
            e.concentracion_porcentual = parseFloat(e.concentracion) * 100; // paso de decimal a porcentual
            return e;
          });
        })

        vm.fertProductos      = _.sortBy(res.data.productos, "nombre");
        vm.fertInputProductos   = prepareAplicacionInput(vm.fertProductos);
        var programa          = vm.fertProgramas[0];

        if(vm.fertProgramaSelected){
          programa = _.find(vm.fertProgramas, {id: vm.fertProgramaSelected.id});
        }
        vm.selectProgramaFert(programa, res.data.productos);
      })

    }



    //Muestra Popover de fertilizacion
    // DEPRECATED
    vm.showPopoverFertilizacion = function(event){
      //vm.fertilizacionApi.equipo       = equipo;
      //vm.fertilizacionApi.sector       = sector
      vm.fertilizacionApi.showedWindow = true;
      //vm.fertilizacionApi.x = null;
      //vm.fertilizacionApi.y = null;

      vm.showBackdrop(function() {
        vm.fertilizacionApi.showedWindow = false;
      });
      $timeout(function(){
        vm.redrawTableFert();
      }, 100);
    }


    var isSameEtapa = function(e1, e2){
      // TODO: mejorar
      return e1.nombre == e2.nombre;
    }

    var getElementsByProductId = function(id, cantidad, real){
      var prod = _(vm.fertProductos).find({"id":id});
      if(prod === null) return null;

      var elementos = prod.elementos;
      return _.map(elementos, function(elemento){
        return _.merge(_.clone(elemento), {
          real       : real ? _.round(elemento.concentracion * real, 2) : 0,
          programado : _.round(elemento.concentracion * cantidad, 2),
          cantidad   : cantidad,
          unidad: prod.unidad
        })
      });
    }

    var getElementsByProductName = function(name, cantidad, real){
      var prod = _(vm.fertProductos).find({"nombre":name});
      if(!prod) return null;

      var elementos = prod.elementos;
      return _.map(elementos, function(elemento){
        return _.merge(_.clone(elemento), {
          real       : real ? _.round(elemento.concentracion * real, 2) : 0,
          programado : _.round(elemento.concentracion * cantidad, 2),
          cantidad   : cantidad,
          unidad: prod.unidad
        })
      });
    }

    /**
    * hace merge de array con array de elementos,
    * estructura minima:
    * [       ---> primera dimension
    * {
    * cantidad:Integer,
    * elementos:[
    * {
    * real: Integer,
    * }
    * ]
    * }
    * ]
    */
    var mergeElementos = function(items){
      return _(items)
      //aplasta los datos en un array de todos los elementos (incluyendo duplicados)
      .flatMap(function(item, index){
        return _.map(item.elementos, function(elemento){
          //agrega la cantidad a cada elemento
          return _.merge(_.clone(elemento), {cantidad: item.cantidad})
        })
      })
      .groupBy('id')
      //por cada grupo, asigna datos basicos del elemento,
      //y agrega la suma de reales y de la cantidad total
      .map(function(elementos){
        return _.merge(_.clone(_.first(elementos)), {
          programado : _.round(_.sumBy(elementos, 'programado'), 2),
          real       : _.round(_.sumBy(elementos, 'real'), 2),
          cantidad   : _.round(_.sumBy(elementos, 'cantidad'), 2),
        })
      })
      .value();
    }



    var getTotalProducts = function(prog){
      // tl.fertProgramaSelected
      //      .sectores[""0""]
      //      .etapas[""0""]
      //      .programa[""0""]      .cantidad
      return _(prog.sectores).flatMap(function(sector){
        return _.flatMap(sector.etapas, function(etapa){
          return _.flatMap(etapa.programa, function(prog){
            var producto = _.find(vm.fertProductos, { id : prog.producto_id });
            return _.merge(_.clone(producto),{
              cantidad : prog.cantidad,
              real     : prog.real.total_mediciones,
            })
          })
        })
      })
      .groupBy("id")
      .map(function(productos, id){
        return {
          //real     : _.round(_.sumBy(elementos, 'real'), 2),
          id          : id,
          nombre      : _.first(productos).nombre,
          abreviacion : _.first(productos).abreviacion,
          unidad      : _.first(productos).unidad,
          cantidad    : _.round(_.sumBy(productos, 'cantidad'), 2),
          real        : _.round(_.sumBy(productos, 'real'), 2),
        }
      })
      .value()
    }




    vm.hidePopoverFertilizacion = function() {
      vm.fertilizacionApi.showedWindow = false;
      vm.hideBackdrop();
    };



    var getArrayIdsSectores = function(){
      return vm.fertProgramaSelected.sectores.map(function(sector){
        return sector.id;
      });
    }


    vm.getAditionalProducts = function(etapa){
      var a = _.filter(vm.fertProductos, function(p) {
        return !(_.findIndex(etapa.productos, {producto_id:p.id}) > -1);
      });
      return a;
    }

    // show Details
    vm.showDetails = function(item){
      item.showDetails = !item.showDetails;
    }




    //________CRUD________________

    vm.savePrograma = function(prog){
      prog.loading = true;
      return fertilizacionRes.postPrograma({
        id                : prog.id,
        vinedo_id         : vm.vinedo_id,
        nombre            : prog.nombre,
        fecha_inicio      : prog.fecha_inicio,
        fecha_fin         : prog.fecha_fin,
        fecha_inicio      : vm.temporadaFertSelected.inicio,
        fecha_fin         : vm.temporadaFertSelected.fin,
        sectores_riego_id : _.map(prog.sectores, function(s){
          return s.id;
        })
      }, function(res){
        prog.loading = false;
        vm.editPrograma(prog, false);
        reloadFertTotales();
      }).$promise
    }
    vm.editPrograma = function(prog, edit){
      $timeout(function(){
        edit = (edit === undefined) ? true : edit;
        prog.edit = edit;
        if(edit){

        }else{

        }
      })
    }

    vm.addPrograma = function(){
      showSelectSectores().then(function(res) {

        var nombre       = "programa nuevo";
        var fecha_inicio = vm.temporadaFertSelected.inicio;
        var fecha_fin    = vm.temporadaFertSelected.fin;
        var sectores     = res.sectores;

        return fertilizacionRes.postPrograma({
          vinedo_id         : vm.vinedo_id,
          nombre            : nombre,
          fecha_inicio      : fecha_inicio,
          fecha_fin         : fecha_fin,
          sectores_riego_id : _.map(sectores, function(s){
            return s.id;
          }),
        },function(res){
          vm.getFertilizacion();
        });
      }, function(error) {
      });
    }



    vm.deletePrograma = function(prog){
      return fertilizacionRes.deleteProgram({
        id : vm.fertProgramaSelected.id
      }, function(res){
        _.remove(vm.fertProgramas, function(programa){
          return programa.id == prog.id;
        });
        reloadFertTotales();
      })
    }



    vm.showAllDetails = function(show){
      vm.showAllFert = show || true;
    }


    vm.editEtapa = function(etapa, edit){
      etapa.edit = edit || !etapa.edit;
      vm.showAllDetails(edit);
      vm.editSectoresByEtapaName(etapa, edit);
    }

    // DELETE
    vm.deleteEtapa = function(etapa, ev) {
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm()
      .title('¿Realmente quiere eliminar esta etapa?')
      .textContent('No se puede recuperar luego de confirmar su eliminacion')
      .ariaLabel('DELETE ITEM')
      .targetEvent(ev)
      .ok('Eliminar')
      .cancel('Cancelar');

      $mdDialog.show(confirm).then(function() {
        var promises = [];
        _.forEach(vm.fertProgramaSelected.sectores, function(sector){
          _.forEach(sector.etapas, function(etapaSector){
            if(isSameEtapa(etapaSector, etapa)){ //--> misma etapa, no misma id
              promises.push(fertilizacionRes.deleteEtapaPrograma({ // por sector
                id: etapaSector.id
              }).$promise);
            }
          });
        });

        $q.all(promises).then(function(res){

          var index = vm.fertProgramaSelected.etapas.indexOf(etapa);
          vm.fertProgramaSelected.etapas.splice(index, 1);
          reloadFertTotales();

          $mdToast.show(
            $mdToast.simple()
            .position("top right")
            .textContent(etapa.nombre+' - Eliminado')
            .hideDelay(3000))
            /*.then(function() {
            $log.log('Toast dismissed.');
          }).catch(function() {
          $log.log('Toast failed or was forced to close early by another toast.');
        });*/
      });



    }, function() {
      // cancel delete
    });

  };


  ////DEPRECATED
  vm.addFertProduct = function(ev){
    $mdDialog.show({
      controller  : ["$scope", "$mdDialog", "elementos", "onSave",
             function($scope, $mdDialog, elementos, onSave) {
        $scope.elementos     = elementos;
        $scope.searchElement = "";
        $scope.loadingSave = false;
        $scope.unidades      = [
          {
            id          : 1,
            nombre      : "Kilogramo",
            abreviacion : "Kg",
          },
          {
            id          : 2,
            nombre      : "Litros",
            abreviacion : "ltrs",
          },
          {
            id          : 3,
            nombre      : "Milimetros",
            abreviacion : "mm",
          },
        ];

        $scope.newProd = {
          nombre      : "",
          abreviacion : "",
          unidad      : $scope.unidades[0],
          elementos: []
        }

        $scope.addElement = function() {
          $scope.productoEdit.elementos.push({
            elemento      : null,
            simbologia : "",//usado para hacerlo editable, en el caso de elementos nuevos
            concentracion: null,
            searchElement : "",
            isNewElement  : true,
          })
        }

        $scope.addElement();

        /**
        * Create filter function for a query string
        */
        function createFilterFor(query) {
          var lowercaseQuery = query.toLowerCase();
          return function filterFn(elemento) {
            return (elemento.nombre.toLowerCase().indexOf(lowercaseQuery) === 0);
          };

        }
        $scope.querySearch = function(query) {
          var results = query ? $scope.elementos.filter(createFilterFor(query)) : $scope.elementos;
          return results;
        }

        $scope.changeElementInput = function(elem){
          elem.isNewElement = true;
        }

        $scope.selectElement = function(elem){
          if(elem.elemento){
            elem.simbologia = elem.elemento.simbologia;
            elem.isNewElement = false;
          }
        }

        $scope.removeElement = function(index){
          return $scope.productoEdit.elementos.splice(index, 1);
        }

        $scope.enableCrearElemento = function(elem){
          elem.isNewElement = true;
        }

        $scope.hide = function() {
          $mdDialog.hide();
        };

        $scope.cancel = function() {
          $mdDialog.cancel();
        };

        $scope.save = function(){
          //TODO verificar inputs antes de cerrar
          onSave($scope.productoEdit).then(function(res){
            $scope.loadingSave = true;
          });
          $mdDialog.hide();

        }

        /*
        $scope.answer = function(answer) {
          $mdDialog.hide(answer);
        };
        */
      }], // ---------------------------------------------------------------------------------
      templateUrl         : 'dialogAddProduct.tmpl.html',
      parent              : angular.element(document.body),
      targetEvent         : ev,
      clickOutsideToClose : true,
      locals              : {
        elementos: vm.fertElementos,
        onSave : function(prod){
          //console.dir(prod);
          var promises = [];

          _.forEach(prod.elementos, function(elemento){
            var data = {
              vinedo_id  : vm.vinedo_id,
              nombre     : elemento.searchElement,
              simbologia : elemento.simbologia
            }
            if(elemento.elemento !== null && elemento.elemento.id !== undefined){
              data.id = elemento.elemento.id;
            }
            var p = fertilizacionRes.postElement(data).$promise
            p.then(function(res){
              elemento.id = res.id;
              if(element.isNewElement){
                vm.fertElementos.push(data);
              }
            })
            promises.push(p);
          });

          return $q.all(promises).then(function(resArray){
            //console.dir(resArray);
            //console.dir(prod);
            //console.log("saveProduct");
            var elementos  = _.map(prod.elementos, function(elemento){
                return {
                  id: elemento.id,
                  concentracion: elemento.concentracion,
                }
            });

            fertilizacionRes.postProducto({
              nombre      : prod.nombre,
              abreviacion : prod.abreviacion,
              vinedo_id   : vm.vinedo_id,
              unidad      : prod.unidad.abreviacion,
              elementos   : elementos,
            }, function(resProd){
              vm.fertProductos.push(prod);
            });

          });

        }
      }
    })
    .then(function(answer) {
      $scope.status = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });
  }























    // etapas fertilizacion WINDOW

    vm.etapasFertAplicarA = function(nombre,sector, item){
      sector.loadingAplicar = true;
      var sectores           = buscarSectores(nombre,sector, item);
      var temporada          = vm.temporadaSelectedWindow;
      if (_.isArray(sectores) && sectores.length > 0) {
        etapasFertConfirmarAplicar(sector, sectores, temporada);
      }
      //este caso sucede cuando debe seleccionar los sectores
      //si tiene la funcion "then", entonces es una promesa de mdDialog
      //espera la promesa para obtener los sectores seleccionados
      if(typeof sectores.then === 'function'){
        sectores.then(function(res) {
          if(res.sectores.length > 0){
            etapasFertConfirmarAplicar(sector, res.sectores, temporada);
          }else{
            sector.loadingAplicar = false
          }
        }, function(error) {
          sector.loadingAplicar = false
        });
      }
    }


    vm.deleteEtapas = function(sectores, temporada){
        var promises = [];
        var ids      = [];
        //borrar estados a sobreescribir
        angular.forEach(sectores, function(sector) {
          angular.forEach(sector.sectorFert.etapas_sector_riego, function(estado) {
            if (isEstadoTemporada(estado, temporada)) {
              ids.push(estado.id);
            }
          });
        });

      if (_.isArray(ids) && ids.length > 0) {
          var p = $http({
            method  : "DELETE",
            url     : urls.BASE + "/fertilizacion/etapa",
            data    : angular.element.param({etapas_id:ids}),
            headers : {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
          });
          promises.push(p);
        }
        return $q.all(promises);
    }

    vm.getCopyEtapas = function (sector, temporada) {
      var estadosNuevos = [];
      angular.forEach(sector.sectorFert.etapas_sector_riego, function (etapa) {
        if (isEstadoTemporada(etapa, temporada)) {
          angular.forEach(sectores, function (sector) {
            var fecha_inicio = new moment.unix(etapa.fecha_inicio).toDate().cleanHour();
            var fecha_fin = new moment.unix(etapa.fecha_fin).toDate().cleanHour();
            var estadoN = {
              id: 0,
              sector_riego_id: sector.id,
              nombre: etapa.nombre,
              fecha_inicio: moment(etapa.fecha_inicio_date).format("YYYY-MM-DD"),
              fecha_fin: moment(etapa.fecha_fin_date).format("YYYY-MM-DD"),
            };
            estadosNuevos.push(estadoN);
          });
        }
      });
    }


    var etapasFertConfirmarAplicar = function(sector, sectores, temporada) {
      var confirm = $mdDialog.confirm()
      .title('¿Seguro que quieres aplicar esas etapas de fertilización a los sectores seleccionados?')
      .textContent('Esto sobreescribira las etapas de fertilización de la temporada de '+temporada.periodo+' para los sectores seleccionados')
      .ariaLabel('aria label')
      //.targetEvent(ev)
      .ok('Aplicar')
      .cancel('Cancelar');

      var successFn = function() {

        var deletePromise= vm.deleteEtapas(sectores, temporada);
        var estadosNuevos = vm.getCopyEtapas(sector, temporada);

        deletePromise.then(function() {
          vm.sectorWindowEtapasFert = angular.copy(sector);
          vm.sectorWindowEtapasFertEdit = angular.copy(sector);
          vm.guardarEtapasFertLote(estadosNuevos);
          vm.sectorWindowEtapasFertEdit.loadingAplicar = false;
        });


      };

      $mdDialog.show(confirm).then(successFn,function(){

      });
    }



    vm.guardarEtapasFertLote = function (estados) {
      if (estados == undefined || estados.length == 0) {
        return;
      }

      var successFn = function (res) {
        vm.getEtapasFert();
      } //END success

      $http({
        method: "POST",
        url: urls.BASE + "/fertilizacion/etapa",
        data: angular.element.param({ etapas: estados }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then(function (res) {
        successFn(res);
      }, function (resError) {
        console.error(resError);
      });

    }

    vm.copiarEtapasFertTemporada = function(temporadaOrigen, temporadaDestino){
      if(temporadaOrigen != temporadaDestino && temporadaOrigen.periodo != temporadaDestino.periodo){

        var mio        = moment(temporadaOrigen.inicio);
        var mid        = moment(temporadaDestino.inicio);
        var diff       = mid.diff(mio, "years");
        var sector     = vm.sectorWindowEtapasFertEdit;
        var etapas     = vm.getEtapasFertPeriodo(temporadaOrigen, sector);
        var etapas_new = _.map(etapas, function(etapa){

          var e = _.cloneDeep(etapa);
          e.fecha_inicio_date  = moment(e.fecha_inicio_date).add(diff, "year").toDate();
          e.fecha_fin_date     = moment(e.fecha_fin_date).add(diff, "year").toDate();
          delete e.id;
          return e;
        })
        vm.saveEtapasFert(etapas_new).then(function(res){
          vm.getEtapasFert().then(function(){
            var s = utils.getSectorById(vm.equipos, sector.id);
            var e = vm.equipoWindowEtapasFert;
            vm.showPopoverEtapasFert(s, e, null);
          });
        });
     }
    }

    vm.copiarEstadosAEtapasFertTemporada= function(temporadaOrigen, temporadaDestino){
      if(temporadaOrigen && temporadaDestino){

        var mio           = moment(temporadaOrigen.inicio);
        var mid           = moment(temporadaDestino.inicio)
        var diff          = mid.diff(mio, "years");
        var sector        = vm.sectorWindowEtapasFertEdit;
        var estados       = vm.getEstadosPeriodo(temporadaOrigen, sector);
        var estadosNuevos = [];

        sector.loadingCopiando = true;
        angular.forEach(estados, function (estado) {

          var d = {
            sector_riego_id  : sector.id,
            nombre           : estado.nombre,
            fecha_inicio_date: moment.unix(estado.fecha_inicio).add(diff, "years").toDate().cleanHour(),
            fecha_fin_date   : estado.fecha_fin == null ? null                                         : moment.unix(estado.fecha_fin).add(diff, "years").toDate().cleanHour(),
            sector           : sector
          }

          estadosNuevos.push(d);
        });

        vm.saveEtapasFert(estadosNuevos).then(function(res){
          vm.getEtapasFert().then(function(){
            sector.loadingCopiando = false;
            var s = utils.getSectorById(vm.equipos, sector.id);
            var e = vm.equipoWindowEtapasFert;
            vm.showPopoverEtapasFert(s, e, null);
          });
        });
      }
    }


    vm.temporadaHasEtapasFert = function(temporada){
      if(vm.sectorWindowEtapasFertEdit){
        var estados = vm.getEtapasFertPeriodo(temporada, vm.sectorWindowEtapasFertEdit);
        return estados.length > 0;
      }
    }

    vm.hasEtapasFert = function(sector){
      var howMany = 0;
      if (sector.sectorFert && sector.sectorFert.etapas_sector_riego) {
        angular.forEach(sector.sectorFert.etapas_sector_riego, function (etapa) {
          if (vm.verificarPeriodo(etapa, vm.temporadaSelectedWindow)) {
            howMany++;
          }
        });
      }
      return howMany;
    };

    vm.editEtapaFert = function(etapa){
      etapa.editObj = _.cloneDeep(etapa);
      etapa.editObj.isEditObj = true;
      etapa.isEditObj = false;
      etapa.edit = true;
    }


    vm.howManySelectedEtapasFert = function(sector){
      if(sector){
        var filtered = _.filter(sector.sectorFert.etapas_sector_riego, {checked: true});
        if(filtered){
          return filtered.length;
        }
      }
      return 0;
    };


    vm.deleteSelectedEtapasFert = function(event, sector){
      if(confirm("¿Desea eliminar estas etapas?")){
        var ids = _.map(_.filter(sector.sectorFert.etapas_sector_riego, {checked: true}), "id");
        var prom = $http({
          method  : "DELETE",
          url     : urls.BASE + "/fertilizacion/etapa",
          data    : angular.element.param({etapas_id:ids}),
          headers : {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        });
        prom.then(function(res){
          sector.sectorFert.etapas_sector_riego = _.filter(sector.sectorFert.etapas_sector_riego, {checked: false});
          vm.getEtapasFert();
        })
      }
    }


    vm.deleteEtapaFert = function(etapa, index){
      if(confirm("¿desea eliminar esta etapa?")){
        etapa.loading = true;
        var prom = $http({
          method  : "DELETE",
          url     : urls.BASE + "/fertilizacion/etapa",
          data    : angular.element.param({etapas_id:[etapa.id]}),
          headers : {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        });
        prom.then(function(res){
          etapa.loading = false ;
          vm.sectorWindowEtapasFertEdit.sectorFert.etapas_sector_riego.splice(index, 1);
          vm.getEtapasFert();
        })
      }
    }

    vm.saveEtapaFert = function(etapa){
      return vm.saveEtapasFert([etapa]);
    }

    vm.saveEtapasFert = function(etapas){
      var etapaParamsArray = [];
      _.each(etapas, function(etapa){
        etapa.loading = true;
        etapa.editObj = etapa.editObj || _.clone(etapa);
        var etapaParams = {
          id                : etapa.id || 0,
          nombre            : etapa.editObj.nombre,
          fecha_inicio      : moment(etapa.editObj.fecha_inicio_date).format("YYYY-MM-DD"),
          fecha_fin         : moment(etapa.editObj.fecha_fin_date).format("YYYY-MM-DD"),
          sector_riego_id   : etapa.sector.id,
        };
        etapaParamsArray.push(etapaParams);
      })

      /*
        para pasar array por parametro en una peticion post,
        se deben parametrizar los Datos.
      */

      var data = {etapas:etapaParamsArray};

      var prom = $http({
        method  : "POST",
        url     : urls.BASE + "/fertilizacion/etapa",
        data    : angular.element.param(data),
        headers : {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      })

      prom.then(function (res) {

        _.each(etapas, function (etapa) {
          if (etapa.isNew && res.data.etapas.length == 1) {
            etapa.id = res.data.etapas[0].id;
          }

          etapa.isNew = false;
          etapa.edit = false;
          etapa.loading = false;
          etapa.editObj.fecha_inicio = moment(etapa.editObj.fecha_inicio_date).unix();
          etapa.editObj.fecha_fin = moment(etapa.editObj.fecha_fin_date).unix();
          etapa.fecha_inicio_date = etapa.editObj.fecha_inicio_date;
          etapa.fecha_fin_date = etapa.editObj.fecha_fin_date;
          etapa.fecha_inicio = etapa.editObj.fecha_inicio;
          etapa.fecha_fin = etapa.editObj.fecha_fin;
          etapa.nombre = etapa.editObj.nombre;
          delete etapa.editObj;

        });
      });

      return prom;
    }


    vm.cancelEtapasFert = function(etapa, index){
      //TODO recobrar datos originales
      //si el estado es nuevo, eliminarlo
      etapa.edit = false;
      if(etapa.isNew){
        //elimina la etapa, si es nueva
        vm.sectorWindowEtapasFertEdit.sectorFert.etapas_sector_riego.splice(index, 1);
      }else{
        etapa.editObj = _.clone(etapa);
      }
    }


    vm.agregarEtapaFert = function(sector){

      var etapa = {
        id:                null,
        nombre:            "",
        isNew:             true,
        edit:              true,
        loading:           false,
        checked:           false,
        sector:            sector,
        fecha_inicio_date: moment("2020-06-01").startOf("day").toDate(),
        fecha_fin_date:    moment("2020-06-30").startOf("day").add(1, "day").toDate(),
      };
      etapa.editObj = _.cloneDeep(etapa);

      $timeout(function(){
        sector.sectorFert.etapas_sector_riego.push(etapa);
      })
    }


    vm.showPopoverEtapasFert = function(sector, equipo) {

      _.map(sector.sectorFert.etapas_sector_riego, function(etapa){
        etapa.isNew             = false;
        etapa.edit              = false;
        etapa.checked           = false;
        etapa.sector            = sector;
        etapa.fecha_inicio_date = moment.unix(etapa.fecha_inicio).toDate();
        etapa.fecha_fin_date    = moment.unix(etapa.fecha_fin).subtract(1,"hours").toDate();//subtract: patch
        return etapa;
      });

      vm.equipoWindowEtapasFert     = equipo;
      vm.sectorWindowEtapasFert     = sector;
      vm.sectorWindowEtapasFertEdit = sector;

      vm.showBackdrop(function() {
        vm.showedWindowEtapasFert = false;
      });
      vm.showedWindowEtapasFert  = true;
    };



    vm.getEtapasFertPeriodo = function(temporada, sector){
      var etapas = [];
      angular.forEach(sector.sectorFert.etapas_sector_riego, function (etapa) {
        if(vm.verificarPeriodo({
          dateInicio: etapa.fecha_inicio_date,
        }, temporada)){
          etapas.push(etapa);
        }
      });
      return etapas ;
    }



    vm.getEtapasFert = function(){

      //vm.etapasFert = [];

      var prom      = fertilizacionRes.getEtapas({
          vinedo_id : $stateParams.id,
      }).$promise;

      prom.then(function(response){

        // for(var i = 0; i < response.data.sectores.length; i++){
        //   var sector = angular.copy(response.data.sectores[i]);
        //   vm.etapasFert.push(sector);
        // }

      _.forEach(vm.equipos, function(equipo){
        _.forEach(equipo.sector_riego, function(sector){
          sector.sectorFert = _.find(response.data.sectores, {id_sector_riego: sector.id});
        })
      })

      });
      return prom;
    }




    // END etapas fertilizacion


















  //refactorizacion de addFertProduct
  vm.showProgramaFertDialog = function(ev){
    $mdDialog.show({
      controllerAs        : 'pf',
      templateUrl         : 'components/vinedo/newtimeline/programaFert/programaFert.tmpl.html',
      parent              : angular.element(document.body),
      targetEvent         : ev,
      clickOutsideToClose : true,
      controller: "programaFertCtrl"
    })
  };

  vm.showProgramaFertWireframe = function(ev){
    $mdDialog.show({
      controllerAs        : 'pf',
      templateUrl         : 'components/vinedo/newtimeline/programaFertTable/programaFertTable.tmpl.html',
      parent              : angular.element(document.body),
      targetEvent         : ev,
      clickOutsideToClose : true,
      controller: "programaFertTableCtrl"
    })
  };










  //refactorizacion de addFertProduct
  vm.addFertProductTL = function(ev){
    $mdDialog.show({
      controllerAs:'tld',
      controller  : ["$scope", "$mdDialog", "elementos", "productos","onSave",
             function($scope, $mdDialog, elementos, productos, onSave) {
               var vm = this;
        vm.elementos            = elementos;
        vm.productos            = productos;
        vm.searchElement        = "";
        vm.productoEdit         = null;
        vm.productoEditOriginal = null;
        vm.loadingSave          = false;
        vm.unidades             = [
          {
            id          : 1,
            nombre      : "Kilogramo",
            abreviacion : "Kg",
          },
          {
            id          : 2,
            nombre      : "Litros",
            abreviacion : "ltrs",
          },
          {
            id          : 3,
            nombre      : "Milimetros",
            abreviacion : "mm",
          },
        ];

        vm.newProd = {
          nombre      : "",
          abreviacion : "",
          unidad      :vm.unidades[0],
          elementos   : [],
          isNew : true
        }

        vm.addProduct = function(){
          var p = _.clone(vm.newProd);
          p.id = _.random(1, 9999999999);
          vm.productos.push(p);
          vm.selectProduct(p);
        }

        vm.deleteProducto = function(producto){
          if(confirm("¿Realmente desea eliminar este producto?")){
            if(producto.isNew){
              //eliminar producto de la lista
              _.remove(vm.productos, {
                id: producto.id
              });
            }else{

              fertilizacionRes.deleteProducto({
                id: producto.id
              }).$promise.then(function(res){
                //console.log("deleted");
                //eliminar producto de la lista
                _.remove(vm.productos, {
                  id: producto.id
                });
              });

            }
          }
        }

        vm.addElement = function() {
          vm.productoEdit.elementos.push({
            elemento      : null,
            orden: 1,
            nombre        : "",
            simbologia    : "",  //usado para hacerlo editable, en el caso de elementos nuevos
            concentracion : null,
            concentracion_porcentual : null,
            searchElement : "",  //para separar elementos de su campo de busqueda
            isNewElement  : true,
          })
        }

        vm.selectProduct = function(producto){
          if(producto == null) return;
          $timeout(function(){
            vm.productoEdit = _.cloneDeep(producto);
            vm.productoEditOriginal = producto;

            vm.productoEdit.elementos = vm.productoEdit.elementos.map(function(el){
              var finded = _.find(vm.elementos, {simbologia: el.simbologia});
              return {
                elemento      : finded,
                nombre        : el.nombre,
                orden         : el.orden,
                simbologia    : el.simbologia,
                searchElement : el.nombre,
                concentracion : el.concentracion,
                concentracion_porcentual : el.concentracion_porcentual,
                isNewElement  : false,
              };
            });

          });
        }



        vm.selectProduct(_.first(vm.productos));



        //vm.addElement();

        /**
        * Create filter function for a query string
        */
        function createFilterFor(query) {
          var lowercaseQuery = query.toLowerCase();
          return function filterFn(elemento) {
            return (elemento.nombre.toLowerCase().indexOf(lowercaseQuery) === 0);
          };
        }

        vm.querySearch = function(query) {
          return query ? vm.elementos.filter(createFilterFor(query)) : vm.elementos;
        }

        vm.changeElementInput = function(elem){
          elem.isNewElement = true;
        }

        vm.selectElement = function(elem, fertElem){
            elem.isNewElement = false;
            elem.simbologia = fertElem.simbologia;
        }

        vm.removeElement = function(index){
          return vm.productoEdit.elementos.splice(index, 1);
        }

        vm.enableCrearElemento = function(elem){
          //elem.isNewElement = true;
        }

        vm.hide = function() {
          $mdDialog.hide();
        };

        vm.cancel = function() {
          $mdDialog.cancel();
        };






               //para duplicar datos, solo para dev
        vm.saveTo = function(){
          //TODO verificar inputs antes de cerrar
          vm.loadingSave = true;
          var vinedos_id = [216, 217];


          _.forEach(vm.productos, function(p){
            var a = _.cloneDeep(p);
            a.id = undefined;
            a.elementos = _.map(a.elementos, function(e){
              e.id = undefined;
              e.elemento = undefined;
              e.searchElement = e.nombre;
              return e
            });

            _.forEach(vinedos_id, function(vinedo_id){
              onSave(a, vinedo_id).then(function(res){
                vm.loadingSave = false;
              }, function(resError){
                vm.loadingSave = false;
              });
            })
          });

          /*

          vm.productoEdit.isNew                = false;
          vm.productoEditOriginal.isNew        = false;
          vm.productoEditOriginal.nombre       = vm.productoEdit.nombre;
          vm.productoEditOriginal.abreviacion  = vm.productoEdit.abreviacion ;
          vm.productoEditOriginal.gramos_litro = vm.productoEdit.gramos_litro;
          vm.productoEditOriginal.elementos    = _.map(vm.productoEdit.elementos, function(elemento){
            return {
              id            : elemento.id,
              orden         : elemento.orden,
              concentracion : elemento.concentracion_porcentual / 100, // paso de porcentual a decimal
              concentracion_porcentual : elemento.concentracion_porcentual,
              nombre        : elemento.nombre,
              simbologia    : elemento.simbologia,
              gramos_litro  : elemento.gramos_litro,
            }
          });
          */

          //$mdDialog.hide();
        }




        vm.save = function(){
          //TODO verificar inputs antes de cerrar
          vm.loadingSave = true;
          onSave(vm.productoEdit).then(function(res){
            vm.loadingSave = false;
          }, function(resError){
            vm.loadingSave = false;
          });

          vm.productoEdit.isNew                = false;
          vm.productoEditOriginal.isNew        = false;
          vm.productoEditOriginal.nombre       = vm.productoEdit.nombre;
          vm.productoEditOriginal.abreviacion  = vm.productoEdit.abreviacion ;
          vm.productoEditOriginal.gramos_litro = vm.productoEdit.gramos_litro;
          vm.productoEditOriginal.elementos    = _.map(vm.productoEdit.elementos, function(elemento){
            return {
              id            : elemento.id,
              orden         : elemento.orden,
              concentracion : elemento.concentracion_porcentual / 100, // paso de porcentual a decimal
              concentracion_porcentual : elemento.concentracion_porcentual,
              nombre        : elemento.nombre,
              simbologia    : elemento.simbologia,
              gramos_litro  : elemento.gramos_litro,
            }
          });
          //$mdDialog.hide();

        }


        /*
        vm.answer = function(answer) {
          $mdDialog.hide(answer);
        };
        */
      }], // ---------------------------------------------------------------------------------
      templateUrl         : 'dialogAddProductTL.tmpl.html',
      parent              : angular.element(document.body),
      targetEvent         : ev,
      clickOutsideToClose : true,
      locals              : {
        elementos : vm.fertElementos,
        productos : vm.fertProductos,
        onSave    : function(prod, vinedo_id){
          //console.dir(prod);
          var promises = [];

          var vinedo_id = vinedo_id ||  vm.vinedo_id;

          _.forEach(prod.elementos, function(elemento){
            var data = {
              vinedo_id    : vinedo_id,
              nombre       : elemento.searchElement,
              simbologia   : elemento.simbologia
            }
            if(elemento.elemento && elemento.elemento.id ){
              data.id = elemento.elemento.id;
              data.orden = elemento.elemento.orden;
            }
            var p = fertilizacionRes.postElement(data).$promise
            p.then(function(res){
              elemento.id = res.id;
              if(elemento.isNewElement){
                vm.fertElementos.push(data);
              }
            })
            promises.push(p);
          });

          var prom = $q.all(promises)
          prom.then(function(resArray){

            //console.dir(resArray);
            //console.dir(prod);
            //console.log("saveProduct");

            var elementos  = _.map(prod.elementos, function(elemento){
              var concentracion_porcentual = elemento.concentracion_porcentual; // paso de porcentual a decimal, antes de guardar

              // concentracion_porcentual formateando comas
              if(typeof concentracion_porcentual == "string"){
                concentracion_porcentual = concentracion_porcentual.replace(",", ".");
                elemento.concentracion_porcentual = concentracion_porcentual;
              }

              elemento.concentracion = parseFloat(concentracion_porcentual) / 100;

                return {
                  id: elemento.id,
                  concentracion: elemento.concentracion,
                }
            });



            fertilizacionRes.postProducto({
              id           : prod.id || null,
              nombre       : prod.nombre,
              abreviacion  : prod.abreviacion,
              vinedo_id    : vinedo_id,
              unidad       : prod.unidad,
              gramos_litro : prod.gramos_litro || 0,
              elementos    : elementos,
            }).$promise.then(function(resProd){
              if(prod.id === undefined){
                prod.id = resProd.data.id;
              }
              var findProd = _.find(vm.fertProductos, {id: prod.id});
              if( findProd){
                findProd.elementos = prod.elementos;
              }else{
                vm.fertProductos.push(prod);
              }
              $mdToast.show(
                $mdToast.simple()
                .textContent("Producto Guardado")
                .position(CONSTANTES.TOAST_POSITION)
              );
            },function(resError){
              $mdToast.show(
                $mdToast.simple()
                .textContent("Problemas al guardar Producto")
                .position(CONSTANTES.TOAST_POSITION)
              );
            });



            },function(resError){
              $mdToast.show(
                $mdToast.simple()
                .textContent("Problemas al guardar Producto y elementos")
                .position(CONSTANTES.TOAST_POSITION)
              );
            });

            return prom;

        }
      }
    })
    .then(function(answer) {
    }, function() {
    });
  }














  String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
  }

  //refactorizacion de addFertProduct
  vm.showAnalisisFert = function(ev){
    $mdDialog.show({
      controllerAs:'af',
      controller  : ["$scope", "$mdDialog", "equipos","temporadas","temporadaSelected","toXls",
                        function($scope, $mdDialog, equipos, temporadas, temporadaSelected, toXls) {

                          var vm               = this;
                          vm.loading           = true;
                          vm.tableData         = [];
                          vm.tableDataEquipos  = [];
                          vm.temporadas        = temporadas;
                          vm.temporadaSelected = temporadaSelected;
                          vm.porHa             = true;
                          vm.vars              = null;
                          vm.elementos         = [];
                          vm.totales           = {};


                          vm.tabs = [
                            {
                              label   : "Elementos",
                              content : "table"
                            },
                            {
                              label   : "Productos",
                              content : "table"
                            },
                          ];


                          vm.tiemposTabs = [
                            {
                              label:   "Mensual",
                              mensual: true,
                              id_table : "ini_unix"
                            },
                            {
                              label: "Etapas",
                              etapas : true,
                              id_table : "nombre"
                            },
                          ];

                          vm.selectedTiemposTab = vm.tiemposTabs[0];
                          vm.selectedTab        = vm.tabs[0];


                          vm.loadData = function(){
                            vm.loading          = true;
                            vm.tableData        = [];
                            vm.tableDataEquipos = [];
                            var tableData       = [];

                            vm.vars = {
                              /*
                              nav : [
                                {label : "Total",       var : "total"},
                                {label : "Total / ha",  var : "totalHA"}
                              ],
                              */
                              elementos : [],
                              productos : [],
                              mensual   : [],
                              etapas    : [],
                            };

                            vm.totales = {
                              productos : {},
                              elementos : {},
                              mensual   : {},
                              etapas    : {},
                              totales   : {
                                total   : 0,
                                totalHA : 0
                              }
                            };






                            var prom     = $http({
                              url    : urls.BASE + "/fertilizacion/estadistica",
                              params : {
                                mensual   : vm.selectedTiemposTab.mensual,
                                etapas    : vm.selectedTiemposTab.etapas,
                                vinedo_id : $stateParams.id,
                                periodo   : vm.temporadaSelected.periodo,
                              }
                            }).then(function(res){

                              var tableDataLocal = res.data.data;
                              vm.loading         = false;
                              var tipoEtapa      = vm.selectedTiemposTab.mensual ? "mensual" : "etapas";

                              /*
                              //calcula la cantidad_ha
                              _.forEach(tableDataLocal.sectores, function(sector){
                                _.forEach(sector.productos, function(prod){
                                  _.forEach(prod.elementos , function(el){
                                    el.cantidad_ha = el.cantidad / sector.ha;
                                  });
                                });
                              });
                              */

                              var elementos = _.flatMap(tableDataLocal.productos, function(p){
                                return p.elementos;
                              })

                              _.forEach(tableDataLocal.sectores, function(sector){

                                var equipoObj = null;
                                var sectorObj = null;
                                _.forEach(equipos, function(equipo){
                                  if(sectorObj) return;

                                  sectorObj = _.find(equipo.sector_riego, {id:sector.id});
                                  if(sectorObj){
                                    equipoObj = equipo;
                                  }
                                });

                                if(sectorObj == undefined) return;

                                //data representa una fila de la tabla
                                var data = {
                                  nombre    : sectorObj.nombre,
                                  equipo    : equipoObj,
                                  //unidad  : sector.unidad,
                                  ha        : sectorObj ? sectorObj.ha : 0,
                                  total     : 0,                           //sector.total,
                                  totalHA   : 0,                           //sector.totalHA,
                                  elementos : {},
                                  productos : {},
                                  etapas    : [],
                                  mensual   : [],
                                };


                                _.forEach(sector.productos, function(prod){






                                    // Invierte array sector->productos->mes->elementos
                                    // por
                                    // sector->mes->productos->elementos
                                    // sector->mes->elementos

                                    _.forEach(prod[tipoEtapa], function(mes){
                                      sector[tipoEtapa] = sector[tipoEtapa]|| [];

                                      var sector_mes = _.find(sector[tipoEtapa], {id_table : mes[vm.selectedTiemposTab.id_table]});
                                      //var sumaElementosMes = [];

                                      //si no existe sector_mes, lo inicializa
                                      if(!sector_mes){
                                        sector_mes = _.cloneDeep(mes);
                                        sector_mes.id_table = mes[vm.selectedTiemposTab.id_table];
                                        //delete sector_mes.elementos;
                                        delete sector_mes.total;
                                        delete sector_mes.totalHA;
                                        sector[tipoEtapa].push(sector_mes);
                                      }else{
                                        var sumaElementosMes = sector_mes.elementos;
                                        _.each(mes.elementos, function (elemento) {
                                          var sum_elemento = _.find(sumaElementosMes, {simbologia: elemento.simbologia});
                                          if(sum_elemento){
                                            sum_elemento.cantidad += elemento.cantidad;
                                          }else{
                                            sum_elemento        = _.clone(elemento);
                                            sumaElementosMes.push(sum_elemento);
                                          }
                                          sum_elemento.unidad = prod.unidad;
                                        });
                                      }

                                      /*if(!sector_mes.elementos){
                                      sector_mes.elementos = [];
                                    }*/

                                    sector_mes.productos    = sector_mes.productos || [];
                                    var sector_mes_producto = _.find(sector_mes.productos, {id:prod.id});

                                    if(!sector_mes_producto){
                                      sector_mes_producto = _.cloneDeep(prod);

                                      //son datos que corresponden al producto, pero total, no al mes correspondiente
                                      //delete sector_mes_producto.elementos;
                                      sector_mes_producto.elementos = mes.elementos;
                                      sector_mes_producto.total     = mes.total;
                                      delete sector_mes_producto[tipoEtapa];

                                      sector_mes.productos.push(sector_mes_producto);
                                    }else{
                                      sector_mes_producto.total += mes.total;
                                    }

                                    //totales mes para productos
                                    if(vm.totales[tipoEtapa][mes[vm.selectedTiemposTab.id_table]] == undefined){
                                      vm.totales[tipoEtapa][mes[vm.selectedTiemposTab.id_table]] = {
                                        productos  : {},
                                      };
                                    }

                                    if(vm.totales[tipoEtapa][mes[vm.selectedTiemposTab.id_table]].productos[prod.id] == undefined){
                                      vm.totales[tipoEtapa][mes[vm.selectedTiemposTab.id_table]].productos[prod.id] = 0;
                                    }
                                    vm.totales[tipoEtapa][mes[vm.selectedTiemposTab.id_table]].productos[prod.id] += mes.total;

                                  });// end foreach prod[tipoEtapa]









                                  var unidad = prod.unidad; //_.get(_.find(tableDataLocal.productos, {id: prod.id}), 'unidad')

                                  if(data.productos[prod.id] == undefined){
                                    data.productos[prod.id] = 0;
                                  }

                                  if(vm.totales.productos[prod.id] == undefined){
                                    vm.totales.productos[prod.id] = 0;
                                  }

                                  data.productos[prod.id]       += prod.total;
                                  data.total                    += prod.total;
                                  data.totalHA                  += prod.totalHA;

                                  vm.totales.productos[prod.id] += prod.total;
                                  //vm.totales.totales.total      += prod.total;
                                  //vm.totales.totales.totalHA    += prod.totalHA;

                                  //Si es que no esta en vm.vars.productos
                                  //agrega el producto a la lista global de productos
                                  if(!_.find(vm.vars.productos, {var: prod.id})){
                                    var abr = prod.abreviacion; //_.get(_.find(tableDataLocal.productos, {id: prod.id}), 'abreviacion')
                                    var orden = _.get(_.find(elementos, {id: el.id}), 'orden');
                                    vm.vars.productos.push({
                                      label  : prod.nombre,
                                      var    : prod.id,
                                      abr    : abr,
                                      unidad : unidad,
                                      orden  : orden || -1,
                                      width  : 2
                                    });
                                  }



                                  //crea totales de elementos y header para tabla
                                  _.forEach(prod.elementos, function(el){

                                    if(data.elementos[el.nombre] == undefined){
                                      data.elementos[el.nombre] = 0;
                                    }
                                    data.elementos[el.nombre] += el.cantidad;

                                    if(vm.totales.elementos[el.nombre] == undefined){
                                      vm.totales.elementos[el.nombre] = 0;
                                    }
                                    vm.totales.elementos[el.nombre] += el.cantidad;;

                                    if(!_.find(vm.vars.elementos, {label: el.nombre})){
                                      var orden = _.get(_.find(elementos, {id: el.id}), 'orden');
                                      vm.vars.elementos.push({
                                        label  : el.nombre,
                                        var    : el.nombre,
                                        abr    : el.simbologia,
                                        abrVar : el.simbologia,
                                        unidad : unidad,
                                        orden  : orden || -1,
                                        width  : 1
                                      });
                                    }
                                  });



                                });//END foreach sector.productos




                                //formatea sector.mensual , productos y elementos
                                _.forEach(sector[tipoEtapa], function(m){
                                  m.productos = _.keyBy(m.productos, function(p){return p.id});
                                  m.elementos = _.keyBy(m.elementos , function(e){return e.nombre});
                                })



                                data[tipoEtapa] = sector[tipoEtapa];

                                //genera vm.vars.mensual
                                _.forEach(sector[tipoEtapa], function(sector_mes){

                                  //calcula los totales_ha para productos y elementos
                                  _.forEach(sector_mes.productos, function(p){
                                    p.total_ha_mes = p.total > 0 ?  p.total / data.ha : 0;
                                    p.width = 2;
                                  })

                                  _.forEach(sector_mes.elementos, function(p){
                                    p.cantidad_ha = p.cantidad > 0 ?  p.cantidad / data.ha : 0;
                                    p.width = 2;
                                  })

                                  if(!_.find(vm.vars[tipoEtapa], {id_table: sector_mes[vm.selectedTiemposTab.id_table]})){
                                    var m       = _.cloneDeep(sector_mes);
                                    m.elementos = vm.vars.elementos;///para header
                                    m.label     = sector_mes.nombre || moment(m.ini).format("MMMM").capitalize();
                                    vm.vars[tipoEtapa].push(m);
                                  }
                                })



                                tableData.push(data);

                              });
                              //_.forEach(tableDataLocal.sectores, function(sector){

                              //agrega etapas faltantes a sectores
                              _.forEach(tableData, function(sector){
                                var etapas = _.cloneDeep(sector[tipoEtapa]);
                                etapas = etapas || [];
                                _.forEach(vm.vars[tipoEtapa], function(etapa_vars){
                                  if(!_.find(etapas, {id_table: etapa_vars[vm.selectedTiemposTab.id_table]})){
                                    //rellena datoa de sector, para tabla
                                    etapas.push({
                                      meta     : "EMPTY",
                                      elementos: [],
                                      fin      : etapa_vars.fin,
                                      ini      : etapa_vars.ini,
                                      ini_unix : etapa_vars.ini_unix,
                                      fin_unix : etapa_vars.fin_unix,
                                      label    : etapa_vars.label || etapa_vars.nombre || "ERROR UNDEF"
                                    });
                                  }
                                })
                                sector[tipoEtapa] = _.orderBy(etapas, "ini_unix");
                              })

                              vm.vars[tipoEtapa]    = _.orderBy(vm.vars[tipoEtapa], "ini_unix");
                              vm.vars[tipoEtapa]    = filtrarEtapas(vm.vars, tableData, tipoEtapa);
                              vm.totales[tipoEtapa] = _.values(vm.totales[tipoEtapa]);
                              vm.tableData          = tableData;
                              vm.tableDataEquipos   = _.values(_.reduce(tableData, function(accumulator, sector){
                                                          if(accumulator[sector.equipo.id] == undefined){
                                                            accumulator[sector.equipo.id]               = _.cloneDeep(sector.equipo);
                                                            delete accumulator[sector.equipo.id].sector_riego;
                                                            accumulator[sector.equipo.id].show          = true;
                                                            accumulator[sector.equipo.id].sectoresRiego = [];
                                                          }
                                                          accumulator[sector.equipo.id].sectoresRiego.push(sector);
                                                          return accumulator
                                                        }, {}));








                            }, function(resError){
                              console.error(resError);
                            });


                          }





                            //filtra las etapas sin datos, ya sean meses o etapas de fertilizacion
                            function filtrarEtapas(vars, tableDataOriginal, tipoEtapa){
                              var tableData = _.cloneDeep(tableDataOriginal);
                              var varsFiltered = _.map(vars[tipoEtapa], function(varEtapa, indexVarEtapa){


                                varEtapa.sumaTotal = _.reduce(tableData, function(accumulator, sector){
                                  return accumulator + _.sumBy(_.values(   sector[tipoEtapa][indexVarEtapa].productos    ), function( prod ){ return prod.total });
                                }, 0);

                                varEtapa.show = varEtapa.sumaTotal  > 0;
                                return varEtapa;
                              })
                              /*
                              return {
                                vars      : varsFiltered ,
                                tableData : tableData
                              };
                              */
                              return varsFiltered;
                            }




                          vm.close = function() {
                            $mdDialog.hide();
                          };


                          vm.loadData();
                          //END LOAD DATA

                          vm.changeTiemposTab = function(tiempo){
                            vm.selectedTiemposTab = tiempo
                            vm.loadData();
                          }








                          var analisisToXls = function(data, props, fileName){

                            var fileName   = fileName || "archivo";
                            var workbook   = XLSX.utils.book_new();
                            var xlsDefault = {wpx:100};
                            var headers    = props.headers;

                            _.forEach(headers, function(header){

                              var headerXls = _.map(header.headerVars, h => h.label);

                              var rowsTop    = header.rowsTop || [];

                              var dataAoA = _.map(data, function(d){
                                return _.map(header.headerVars, function(h){
                                  var r = _.get(d, h.var);
                                  if(h.isNumber){
                                    if(props.porHa && d.ha){
                                      r /= d.ha;
                                    }
                                    r = (h.round ? _.round(r, h.round) : r);
                                    r = (r == 0 ? '' : r );
                                  }
                                  return r;
                                });
                              });

                              dataAoA.unshift(headerXls);
                              dataAoA = rowsTop.concat(dataAoA);

                              var sheet = XLSX.utils.aoa_to_sheet(dataAoA);

                              sheet["!cols"] = _.map(header.headerVars, h => h.xls || xlsDefault);
                              XLSX.utils.book_append_sheet(workbook,sheet,header.name || "default name");
                            });

                            XLSX.writeFile(workbook, `${fileName}.xlsx`);
                          }









                          vm.downloadXls = function(){

                            var props = {
                              porHa : vm.porHa,
                              headers:[],
                            };

                            _.forEach(["elementos", "productos"], function(tipoDato){


                              var cantidadName = (tipoDato == 'elementos' ? 'cantidad': 'total');
                              var tipoEtapa    = vm.selectedTiemposTab.mensual ? 'mensual' : 'etapas';
                              var rowsTop      = [""];
                              var header       = [
                                {
                                  label    : "Sector",
                                  var      : "nombre",
                                  isNumber : false
                                },
                              ];

                              _.forEach(vm.vars[tipoEtapa], function(etapa, indexMes){

                                if(etapa.show){

                                  var label     = etapa.label;
                                  var elementos = _.orderBy(etapa[tipoDato], "orden");
                                  var row       = [etapa.label];

                                  _.forEach(elementos, function(elemento, indexElemento){

                                    var varName = elemento.var || elemento.id;

                                    if(elementos.length > row.length){
                                      row.push("");
                                    }

                                    header.push({
                                      label    : elemento.abr || elemento.nombre,
                                      //opcional si es total o por ha
                                      var      : "mensual["+indexMes+"]."+tipoDato+"['"+varName+"']."+cantidadName,
                                      isNumber : true,
                                      round    : 3,
                                    });

                                  });


                                  rowsTop = rowsTop.concat(row);
                                }

                              });

                              props.headers.push({
                                name       : tipoDato,
                                headerVars : header,
                                rowsTop    : [rowsTop]
                                });

                            });

                            analisisToXls(vm.tableData, props, "analisis fertilizacion");

                          }












                        }], // ---------------------------------------------------------------------------------
      templateUrl         : 'dialogAnalisisFert.tmpl.html',
      parent              : angular.element(document.body),
      targetEvent         : ev,
      clickOutsideToClose : true,
      locals:{
        equipos:           vm.equipos,
        temporadas:        vm.temporadas,
        temporadaSelected: vm.temporadaActiva,
        toXls: vm.toXls
      }
    })
    .then(function(answer) {
    }, function() {
    });
  }










































  /**
  ----------------------------
  ----------------------------
  posible codigo deprecado
  */

  vm.addFertSector = function(){
    showSelectSectores({
      sectoresDisabled : vm.fertProgramaSelected.sectores,
      msjDisabled      : "Este sector ya tiene programa de fertilización"
    }).then(function(res) {
      if(res.sectores.length > 0){
        var newSectores = [];

        _.forEach(res.sectores, function(sector){
          newSectores.push({
            components  : [],      //para totales de sector
            edit        : true,
            editable    : true,
            ha          : sector.ha,
            id          : sector.id,
            nombre      : sector.nombre,
            nombreEdit  : sector.nombre,
            showDetails : false,
            new         : true,
            etapas      : _.map(vm.fertProgramaSelected.etapas, function(etapa){
              return {
                fecha_inicio : etapa.fecha_inicio,
                fecha_fin    : etapa.fecha_fin,
                nombre       : etapa.nombre,
                progreso     : 0,
                programa     : _.map(etapa.productos, function(prod){
                  return {
                    producto_id: prod.id,
                    cantidad:0
                  }
                }),
              }
            }),      //etapas actuales
          });
        });

        fertilizacionRes.postPrograma({
          id: vm.fertProgramaSelected.id,
          nombre          : vm.fertProgramaSelected.nombre,
          fecha_inicio    : vm.temporadaFertSelected.inicio,
          fecha_fin       : vm.temporadaFertSelected.fin,
          vinedo_id       : vm.vinedo_id,
          sectores_riego_id : _.map(_.concat(vm.fertProgramaSelected.sectores, newSectores), function(sector){
            return sector.id;
          }),
        }, function(res){
          var promises = [];
          _.forEach(newSectores, function(newSector){
            var p = vm.saveSector(newSector);
            p.then(function(){
              vm.fertProgramaSelected.sectores.push(newSector);
            });
            promises.push(p);
          });
          $q.all(promises).then(function(){
            reloadFertTotales();
          });
        });


      }
      //TODO saveSector
    }, function(error) {
    });

  }
  //ADD
  //deprecated
  vm.addFertEtapa = function(){
    var e = {
      //id: res.data.id,
      id               : null,
      actual           : true,//definir segun fechas
      dateable         : true,
      dias             : 0,// por definir, variable sin usar aun
      edit             : true,
      editable         : true,
      fecha_fin        : moment(vm.temporadaFertSelected.inicio).add(7, "days").format("DD/MM/YYYY"),
      fecha_finEdit    : moment(vm.temporadaFertSelected.inicio).add(7, "days").format("DD/MM/YYYY"),
      fecha_inicio     : vm.temporadaFertSelected.inicio,
      fecha_inicioEdit : vm.temporadaFertSelected.inicio,
      nombre           : "",
      nombreEdit       : "",
      productos        : [],//productos que se usan en la etapa, usado en header de etapa
      programa         : [],//programa de fertilizacion, obtenido desde sector
      progreso         : 0,
      real             : [],//no se usa, se copia dentro de programa[], donde se usa en sectores
    }
    e.aditionalProducts = vm.getAditionalProducts(e);
    vm.saveEtapa(e).then(function(res){//la respuesta sera un array de respuesta de promises, de cada sector al que se le agrego etapa
      e.id = res.id;
      vm.fertProgramaSelected.etapas.push(e);

      _.forEach(vm.fertProgramaSelected.sectores, function(sector){
        sector.etapas.push(_.cloneDeep(e));
      });

      vm.editEtapa(e, true);
      vm.redrawTableFert();
      //TODO mover scroll horizontal al fila

    });

  }
  vm.saveEtapa = function(etapa, fromView){
    var promises = [];
    _.forEach(vm.fertProgramaSelected.sectores, function(sector){
      var p = vm.saveSector(sector, etapa, false)
      promises.push(p);
    });
    var allProm = $q.all(promises);

    allProm.then(function(){
      if(fromView){
        etapa.nombre       = etapa.nombreEdit;
        etapa.fecha_inicio = etapa.fecha_inicioEdit;
        etapa.fecha_fin    = etapa.fecha_finEdit;
        vm.editEtapa(etapa, false);
      }
      vm.redrawTableFert();
      reloadFertTotales();
    })
    return allProm;
  }


  vm.cancelEditEtapa = function(item){
    vm.editEtapa( item, false );
    item.nombreEdit       = item.nombre;
    item.fecha_inicioEdit = item.fecha_inicio;
    item.fecha_finEdit    = item.fecha_fin;
  }

  vm.checkFertEtapaDates = function(etapa){
    etapa.errorDates = !moment(etapa.fecha_inicioEdit).isBefore(etapa.fecha_finEdit);
  }

  vm.addProduct = function(etapa, prod){
    //console.log("addProduct");
    _.remove(etapa.aditionalProducts,prod);
    etapa.productos.push(prod);
    _.forEach(vm.fertProgramaSelected.sectores, function(sector){
      _.forEach(sector.etapas, function(etapaSector){
        if(isSameEtapa(etapaSector, etapa)){
          etapaSector.programa.push({
            producto_id : prod.id,
            cantidad    : 1,
            real        : {}
          });
        }
      });
    })
    //vm.redrawTableFert();
    reloadFertTotales();
  }

  vm.removeProduct = function(etapa, prod, ev){

    var confirm = $mdDialog.confirm()
    .title('¿Realmente quiere quitar este producto?')
    .textContent('el producto no se eliminara de la plataforma, solo se quitara de la etapa')
    .ariaLabel('DELETE ITEM')
    .targetEvent(ev)
    .ok('Quitar')
    .cancel('Cancelar');

    $mdDialog.show(confirm).then(function() {
      _.remove(etapa.productos,{id: prod.id});
      etapa.aditionalProducts.push(prod);
      _.forEach(vm.fertProgramaSelected.sectores, function(sector){
        _.forEach(sector.etapas, function(etapaSector){
          if(isSameEtapa(etapaSector, etapa)){
            _.remove(etapaSector.programa, function(prog){
              return prog.producto_id == prod.id;
            });
          }
        });
      });
    reloadFertTotales();
    }, function() {
      // cancel delete
    });
  }



  // EDIT sector
  vm.editSector = function(sector){
    sector.edit = true;
  }

  vm.cancelEditSector = function(sector){
    sector.edit = false
  }

  vm.removeSector = function(sector, ev){

    var confirm = $mdDialog.confirm()
    .title('¿Realmente quiere quitar este sector del programa de fertilización?')
    .textContent('el sector no se eliminara de la plataforma, solo se quitara del programa de fertilización')
    .ariaLabel('DELETE ITEM')
    .targetEvent(ev)
    .ok('Quitar')
    .cancel('Cancelar');

    $mdDialog.show(confirm).then(function() {

      var sectores = _.clone(vm.fertProgramaSelected.sectores);
      _.remove(sectores, function(s) {
        return s.id == sector.id;
      });

      fertilizacionRes.postPrograma({
        id                : vm.fertProgramaSelected.id,
        nombre            : vm.fertProgramaSelected.nombre,
        fecha_inicio      : vm.temporadaFertSelected.inicio,
        fecha_fin         : vm.temporadaFertSelected.fin,
        vinedo_id         : vm.vinedo_id,
        sectores_riego_id : _.map(sectores, function(sector){
          return sector.id;
        }),
      }, function(res){

        var promises = [];
        _.forEach(sector.etapas, function(etapa){
          promises.push(fertilizacionRes.deleteEtapaPrograma({
            id: etapa.id
          }).$promise)
        });

        $q.all(promises).then(function(){
          _.remove(vm.fertProgramaSelected.sectores, function(s) {
            return s.id == sector.id;
          });
          reloadFertTotales();
        });

      });

    }, function() {
      // cancel delete
    });
  }

  vm.saveSector = function(sector, etapaSelected, fromView){
    var promises = [];
    _.forEach(sector.etapas, function(etapa){
      //si no hay etapaSelected, se aplica a todas las etapas
      if (etapaSelected == null || etapa.nombre == etapaSelected.nombre) {
        promises.push(fertilizacionRes.postEtapaPrograma({
          id              : etapa.id,
          nombre          : etapaSelected ? etapaSelected.nombreEdit : etapa.nombre,
          fecha_inicio    : etapaSelected ? etapaSelected.fecha_inicioEdit : etapa.fecha_inicio,
          fecha_fin       : etapaSelected ? etapaSelected.fecha_finEdit : etapa.fecha_fin,
          sector_riego_id : [sector.id],
          productos       : _.map(etapa.programa, function(p){
            return {
              id       : p.producto_id,
              unidades : p.cantidad,
              cantidad_mediciones: p.cantidad_mediciones
            }
          }),
        }, function(res){ //then
          if(etapa.id == undefined && res.id){
            etapa.id = parseInt(res.id);
          }
          //en el caso de que la etapa en el header haya sido
          //editada, cambia el nombre de las otras etapas
          if(etapaSelected){
            etapa.nombre       = etapaSelected.nombreEdit
            etapa.fecha_inicio = etapaSelected.fecha_inicioEdit
            etapa.fecha_fin    = etapaSelected.fecha_finEdit
          }
          if (fromView) {
            sector.edit = false;
            vm.redrawTableFert();
            reloadFertTotales();
          }
        }).$promise);
      }
    });
    return $q.all(promises);
  }

  vm.editSectoresByEtapaName = function(etapa, edit){
    _.forEach(vm.fertProgramaSelected.sectores ,function(sector){
      _.forEach(sector.etapas, function(etapaSector){
        if(isSameEtapa(etapaSector, etapa)){
          etapaSector.edit = edit;
        }
      })
    })
  }

  /**
  posible codigo deprecado
  ----------------------------
  ----------------------------
  */


















  //----- scroll

  var onResize = function(){
    //se inicia denuevo, ya que el nodo cambia, se debe cargar nuevamente
    var $tableF = $(".irritable-fert");
    var w = $tableF.width();
    $timeout(function(){
      $tableF.find(".sidebar-right").css({ left: w });
      $tableF.find(".icon-cell").css({ left: w });
    }, 10);
  };

  vm.onLoadSR = function(){
    $timeout(function(){
      vm.redrawTableFert();
    }, 10);
  };

  vm.redrawTableFert = function(){
    onResize();
  }

  $(window).resize(function(){
    vm.redrawTableFert();
  });
  $(".irritable-fert").scroll(function(){
    vm.redrawTableFert();
  });

  //----- end scroll








  //fertilizacion window

  //data analisis
  var analisisSector = {
    //name: "2016-17",
    //nameEdit : "2016-2017",
    name:"",
    nameEdit: "",
    start : new Date("2018-9-24"),
    end   : new Date("2018-11-25"),
    editable: false,
    components: [ //components
      {
        name      : "N",
        proportion: 0.12,
        num: 3
      },
      {
        name      : "P",
        proportion: 0.12,
        num: 3
      },
      {
        name      : "K",
        proportion: 0.12,
        num: 3
      },
    ],
  }
  var analisisSectorNames = [
    "2015-2016",
    "foliar",
    "2016-2017",
    "Suelo",
    "foliar",
    "2017-2018",
    "foliar",
    "2018-2019",
    "foliar",
    "Suelo",
    "2019-2020",
  ]

  for (var i = 0; i < 30; i++) {
    var sector = {
      name: "Sector a - "+i,
      edit: false,
      editable: false,
      fert:[],//TOOD cambiar nombre
    }
    for (var j = 0; j < 10; j++) {
      sector.fert.push(analisisSector);
      if(i == 0){
        fertEtapasAnalisis.push(_.merge(analisisSector, {
          name: analisisSectorNames[j],
          nameEdit: analisisSectorNames[j],
          edit: false,
          editable: false,
          dateable: false,
          elementsArray: null
        }));
      }
    }
    fertSectoresAnalisis.push(sector);
  }
  fertSectorTitlesAnalisis = analisisSector.components;






  //deprecated
  vm.selectProgramaFert = function(prog, productos){
    if(prog == vm.fertProgramaSelected) return;

    if(prog){ //programa
      vm.preparePrograma(prog);
      vm.prepareProductos(prog, productos);
      vm.fertProgramaSelected = prog;
      //vm.tabFertSelected  = tab
      vm.showAllFert      = false;
      //vm.fertArray        = fertArrayPrograma;
      //vm.fertSectores     = fertSectoresPrograma;
      //vm.fertEtapas       = fertEtapasPrograma;
      vm.fertSectorTitles = fertSectorTitlesPrograma;
    }else{//analisis
      vm.fertProgramaSelected = null;
      //vm.tabFertSelected  = null;
      vm.showAllFert      = true;
      //vm.fertArray        = fertArrayAnalisis;
      //vm.fertSectores     = fertSectoresAnalisis;
      //vm.fertEtapas       = fertEtapasAnalisis;
      vm.fertSectorTitles = fertSectorTitlesAnalisis;
    }
    vm.redrawTableFert();
    reloadFertTotales(prog);
  }






  /** agrega informacion a productos de cada etapa
   * deprecated
  */
  vm.prepareProductos = function(prog, productos){
    _.forEach(prog.etapas, function(etapa){
      _.forEach(etapa.productos, function(el){
        var completeElement = _.find(productos, ["id", el.producto_id]);
        _.merge(el, completeElement);
      })
    });
  }




  /** prepara programas
  - agrega variables editables
  -
  deprecated
  */
  vm.preparePrograma = function(prog){

    var etapas = [];

    prog.edit       = false;
    prog.editable   = true;
    prog.nombreEdit = prog.nombre;

    _.forEach(prog.sectores, function(sector, index){

      sector.nombreEdit  = sector.nombre;
      sector.edit        = false;
      sector.editable    = true;
      sector.showDetails = false;
      sector.components  = [];
      sector.elementos   = [];

      _.forEach(sector.etapas, function(etapa){

        if(index == 0){ //copia etapas, para agregar en array de etapas, para header
          if(!_.find(etapas, ['id',etapa.id])){
            var e               = _.clone(etapa);
            e.nombreEdit        = e.nombre;
            e.edit              = false;
            e.dateable          = true;
            e.editable          = true;
            e.fecha_inicio      = moment(e.fecha_inicio).toDate();
            e.fecha_fin         = moment(e.fecha_fin).toDate();
            e.fecha_inicioEdit  = e.fecha_inicio;
            e.fecha_finEdit     = e.fecha_fin;
            e.productos         = _.cloneDeep(e.programa);        //solo usa algunos items, no se usara para guardar con peticiones post
            e.aditionalProducts = vm.getAditionalProducts(e);
            e.errorDates        = false;
            vm.checkFertEtapaDates(e);
            etapas.push(e);
          }
        }

        //mezcla etapa.programa con etapa.real dentro de los sectores de riego
        _.forEach(etapa.programa, function(prog){
          _.forEach(etapa.real, function(real){
            if(prog.producto_id == real.producto_id){
              prog.real = real;
            }
          });
        });
      });
    });
    prog.etapas = etapas;
    reloadFertTotales(prog);
  }



  var reloadFertTotales = function(prog){
    prog = prog === undefined ? prog : vm.fertProgramaSelected;

    if(prog === null || prog === undefined ) return;

    _.forEach(prog.sectores, function(sector, index){
      _.forEach(sector.etapas, function(etapa){
        _.forEach(etapa.programa, function(prog){
          var total_mediciones = 0;
          if(prog.real && prog.real.total_mediciones){
            total_mediciones = prog.real.total_mediciones;
          }
          prog.elementos = getElementsByProductId(prog.producto_id, prog.cantidad, total_mediciones);
        });
        etapa.elementos = mergeElementos(etapa.programa);
      });
      sector.elementos = mergeElementos(sector.etapas);
    });
    prog.elementos      = mergeElementos(prog.sectores);
    prog.totalProductos = getTotalProducts(prog);
  }









































    // -- RESIZE --
    var resizeFn = function() {
      if(global.responsiveIs("xs sm")){
        vm.isMobile = true;
        vm.fullHeight = $(document).height() - 110;
      }else{
        vm.fullHeight = $(document).height() - 150;
      }
      vm.positionArrow();
    };

    $(window).resize(resizeFn);
    $("#content").resize(resizeFn);
    resizeFn();
    // -- END RESIZE --

    //asumiremos que solo sera viñedo
    if (vm.view === "" || angular.isUndefined(vm.view)) {
      vm.view = 'vinedo'; //  si es equipo o vinedo
    }




    vm.calcularEspacioProgramacion = function() {
      var inicioMoment  = moment().add(1, "days");
      var terminoMoment = moment().add(diasProgramacion + 1, "days");
      var left          = inicioMoment.diff(fechaInicio, "days");

      vm.espacio.top = 0;

      if (terminoMoment.isAfter(fechaTermino)) {
        vm.espacio.display = "none";
        return;
      }

      vm.espacio.display = "block";

      vm.espacio.left   = _.round(left * r, 5);
      vm.espacio.width  = _.round(diasProgramacion * r, 5);
      vm.espacio.height = _.round(cantidadSectores * r, 5);
    }

    vm.getWidthHeader = function(){
      var headerAux = r;
      if(vm.diasHeader !== null){
        return vm.diasHeader.length * r + headerAux;
      }
      return 0;
    }



    vm.calcularEstimacionMM = function(cuartel){
      if(cuartel == null){
        return;
      }
      /*
      var postDays = false;
      var sumaEt = 0;
      var cantidadEt = 0;
      _.each(cuartel.dias, function(d){
        if(moment(cuartel.ultimo_riego.unix * 1000).isSame(moment(d.unix * 1000), "day")){
          postDays = true;
        }
        if(postDays && cantidadEt < cuartel.estimacion.dias){
          var eto = getEtoByUnix(d.unix * 1000);
          //console.log(moment(d.unix * 1000).format());
          if(eto === null){
            //console.log("sin et")
            eto = cuartel.kc.etx;
          }
          //console.log(sumaEt + "+" + eto + "=" + (sumaEt + eto) +" --> "+ cantidadEt);
          sumaEt += eto;
          cantidadEt ++;
        }
      });
      var etx = sumaEt / cantidadEt;
      console.log("new etx" + etx);
      console.log("old etx" + cuartel.kc.etx);
      console.log(" ------------------------------------------------------------- ")
      */
      var mm = _.round(cuartel.estimacion.dias * cuartel.kc.etx * cuartel.estimacion.reposicionEditable / 100, 1);
      return mm;
    }



    var getEtoByUnix = function(unix){
      var r = null;
      _.each(vm.diasHeader, function(dia){
        if(moment(unix).isSame(moment(dia.unix), "day")){
          if(_.isNumber(dia.eto)){
            r = dia.eto;
          }
        }
      });
      return r;
    }

    vm.quitFilters = function(){
      vm.equipoSelected = null;
      vm.casetaSelected = null;
      vm.variedadSelected  = null;
      vm.applyFilter();
    }

    vm.applyFilter = function(){
      vm.cancelarMultiInput();
      angular.forEach(vm.equipos, function(equipo) {
        equipo.visible = false;
        angular.forEach(equipo.sector_riego, function(sector) {
          sector.visible = false;

          if((vm.equipoSelected == null || equipo.id == vm.equipoSelected.id) &&
            (vm.casetaSelected == null || vm.casetaSelected.id == equipo.caseta_id)){
            sector.visible = true;
            equipo.visible = true;
          }

          if(sector.visible){
            var calidades = sector.resumen.calidades;
            if(!_.isArray(calidades)){
              calidades = [calidades];
            }
            if((vm.variedadSelected == null || _.find(calidades, {variedad_id : vm.variedadSelected.id}))){
              sector.visible = true;
            }else{
              sector.visible = false;
            }
          }

        });
      });




      drawBoard({
        width: diffDays * r + r,
        height: calcularTotalSectores() * r,
        square:{
          width: r,
          height: r
        }
      });
      vm.addTodayLine();
    }

    function calcularTotalSectores () {
      cantidadSectores = 0;
      angular.forEach(vm.equipos, function(equipo) {
        angular.forEach(equipo.sector_riego, function(sector) {
          if(sector.visible){
            cantidadSectores++;
          }
        });
      });
      return cantidadSectores;
    }

    function calcularPosicionToggleSidebarButton() {
      var offset = 75;
      if(vm.showedHeaderInputs){
        offset = 165;
      }
      var max = 165;
      var top = ((cantidadSectores-1) * r)/2 + offset;
      top = top > max ? max : top;
      vm.buttonTogglePosition = top;
      if(vm.buttonTogglePosition < 100){
        vm.buttonTogglePosition = 100;
      }
    }



    vm.showDialogSector = function(ev, sector) {
      cuartelDialog.showDialog(ev, sector.id);
    }


    vm.hidePopoverEstimacion = function() {
      vm.showedWindow = false;
      vm.hideBackdrop();
    };

    //Metodo heredado del timetable anterior
    vm.showPopoverEstimacion = function(cuartel, equipo, event) {
      vm.equipoWindow  = equipo;
      vm.cuartelWindow = cuartel;

      vm.showBackdrop(function() {
        vm.showedWindow = false;
      });

      //var tipo = vm.cuartelWindow.estimacion.tipo;

      // 1- 11 : estimacion en Dias {default}
      // 2- 12 : estimacion en mm
      // 2- 13 : estimacion en Horas


      //if (vm.cuartelWindow.proximo.tipo_calculo == 1) {
        //tipo = 11;
      //}else if (vm.cuartelWindow.proximo.tipo_calculo == 2) {
        //if(vm.config.vinedo.etimacionMM){
          //tipo = 12;
        //}
        //else tipo = 13
      //}

      vm.cuartelWindow.estimacion = {
        //reposicion : $filter('number')( $scope.cuartelWindow.kr * 100 , 0 ),
        reposicion         : _.round((cuartel.kc.teorico), 1),
        reposicionEditable : _.round((cuartel.kc.teorico), 1),
        dias               : vm.cuartelWindow.proximo.frecuencia,
        horas              : vm.cuartelWindow.proximo.horas,
        mm                 : vm.cuartelWindow.proximo.mm,
        tipo               : parseInt(vm.cuartelWindow.estimacion.tipo)
      };

      vm.showedWindow      = true;

      //opciones de posicion y tamaño de ventana
      var kh               = 30;
      var kw               = 33;
      var alturaWindow     = 305;
      var medioAnchoWindow = 300;
      var heightContent    = $("#content").height();
      var widthOffset      = 0;
      var target           = null;

      if (event.target.localName === "md-icon") {
        target = event.target.offsetParent;
      }else{
        target = event.target;
      }

      if (vm.visibleSidebarDetails) {
        widthOffset = medioAnchoWindow;
        $(".estimacion-cuartel-window").addClass("center-arrow");
      }else{
        $(".estimacion-cuartel-window").removeClass("center-arrow");
      }

      if ((target.getBoundingClientRect().top-kh) > (heightContent/2)) {
        $(".estimacion-cuartel-window").removeClass("top-arrow").addClass("bottom-arrow")
        .css({
          left : target.getBoundingClientRect().left - kw - widthOffset,
          top  : target.getBoundingClientRect().top - kh - alturaWindow + $("#content").scrollTop()
        });
      }else{
        $(".estimacion-cuartel-window").removeClass("bottom-arrow").addClass("top-arrow")
        .css({
          left : target.getBoundingClientRect().left - kw - widthOffset,
          top  : target.getBoundingClientRect().top - kh + $("#content").scrollTop()
        });
      }

    };



    vm.hasEstados = function(sector){
      var howMany = 0;
      angular.forEach(sector.estados, function (estado) {
        if(vm.verificarPeriodo(estado,vm.temporadaFertSelected)){
          howMany++;
        }
      });
      return howMany;
    };

    vm.hasMsj = function(dia){
      if(dia.mensaje.mensaje !== undefined){
        if(dia.mensaje.mensaje.replace(" ", "") !== ""){
          return true
        }
      }
      return false;
    };


    vm.hidePopoverEstado = function() {
      vm.showedWindowEstado = false;
      vm.hideBackdrop();
    };








    vm.showPopoverEstado = function(cuartel, equipo, event) {
      vm.equipoWindowEstado  = equipo;
      vm.sectorWindowEstado = cuartel;
      vm.sectorWindowEstadoEdit = angular.copy(cuartel);

      vm.showBackdrop(function() {
        vm.showedWindowEstado = false;
      });

      angular.forEach(vm.sectorWindowEstadoEdit.estados, function(estado) {

        estado.dateInicio = moment.unix(estado.fecha_inicio).toDate().cleanHour();

        if (estado.fecha_fin != null) {
          estado.dateTermino = moment.unix(estado.fecha_fin).toDate().cleanHour();
          estado.dateTerminoDirty = true;
        }else{
          estado.dateTermino = null;
          estado.dateTerminoDirty = false;
        }
      });

      vm.showedWindowEstado  = true;
      /*
      var kh               = 35;
      var kw               = 32;
      var alturaWindow     = 270;
      var medioAnchoWindow = 300;
      var heightContent    = $("#content").height();
      var widthOffset      = 0;
      var target           = null;

      if (event.target.localName === "md-icon") {
        target = event.target.offsetParent;
      }else{
        target = event.target;
      }

      if (vm.visibleSidebarDetails) {
        widthOffset = medioAnchoWindow;
        $(".estado-cuartel-window").addClass("center-arrow");
      }else{
        $(".estado-cuartel-window").removeClass("center-arrow");
      }

      if ((target.getBoundingClientRect().top-kh) > (heightContent/2)) {
        $(".estado-cuartel-window").removeClass("top-arrow").addClass("bottom-arrow")
        .css({
          left : target.getBoundingClientRect().left - kw - widthOffset,
          top  : target.getBoundingClientRect().top - kh - alturaWindow + $("#content").scrollTop()
        });
      }else{
        $(".estado-cuartel-window").removeClass("bottom-arrow").addClass("top-arrow")
        .css({
          left : target.getBoundingClientRect().left - kw - widthOffset,
          top  : target.getBoundingClientRect().top - kh + $("#content").scrollTop()
        });
      }
      */

    };

    var getPeriodoEstado = function(estado){
      var mi = moment(estado.dateInicio);
      var year = mi.year();
      var mx = moment(year+"-06-01")
      if(mx.isAfter(mi)){
        year = parseInt(year) - 1;
      }
      return year + "-" + (parseInt(year) + 1);
    };

    vm.verificarPeriodo = function(estado, temporada) {
      var mi = moment(temporada.inicio, "YYYY-MM-DD");
      var mf = moment(temporada.fin, "YYYY-MM-DD");
      if(estado.dateInicio === undefined){
        estado.dateInicio = moment.unix(estado.fecha_inicio).format("YYYY-MM-DD");
      }
      var me = moment(estado.dateInicio, "YYYY-MM-DD");
      if (me.isBetween(mi, mf, "()")) {
        return true;
      }
      return false;
    };



    vm.getEstadosPeriodo = function(temporada, sector){
      var estados = [];
      if (sector && sector.estados) {
        angular.forEach(sector.estados, function (estado) {
          if (vm.verificarPeriodo(estado, temporada)) {
            estados.push(estado);
          }
        });
      }
      return estados;
    }



    vm.getEstadoByDate = function(date, sector){
      var estadoReturn = null;
      if(date === null || date === undefined){
        date = new Date();
      }
      var m = moment(date);

      _.each(sector.estados, function(estado){
        var mi = moment.unix(estado.fecha_inicio);
        var mf = moment.unix(estado.fecha_fin);
        if(m.isBetween(mi, mf, 'day', '(]')){
          estadoReturn = estado;
        }
      });

      return estadoReturn;
    }

    vm.temporadaHasEstados = function(temporada, sector){
      if(sector){
        var estados = vm.getEstadosPeriodo(temporada, sector);
        return estados.length > 0;
      }
    }

    vm.howManySelectedEstados = function(sector){
      return vm.getSelectedEstados(sector).length;
    };

    vm.getSelectedEstados = function(sector){
      if(sector == undefined) return [];

      var estados = [];
      angular.forEach(sector.estados, function (estado) {
        if(estado.selected){
          estados.push(estado);
        }
      });
      return estados;
    }

    vm.cleanSelectedEstados = function(sector){
      angular.forEach(sector.estados, function (estado) {
        estado.selected = false;
      });
    };

    vm.deleteSelectedEstados = function(ev, sector){
      var estados = vm.getSelectedEstados(sector);

      var confirm = $mdDialog.confirm()
          .title('¿Realmente quieres borrar '+estados.length+' estados?')
          .textContent('La eliminacion es irreversible')
          .ariaLabel('Borrar Estados')
          .targetEvent(ev)
          .ok('Borrar')
          .cancel('Cancelar');

      var p = $mdDialog.show(confirm);

      p.then(function() {
        vm.generalLoading = true;
        var promises = [];

        //elimina uno por uno los estados
        angular.forEach(estados, function (estado) {
          var p = CuartelRes.deleteEstadosFenologicos({etapa_id: estado.id_estado}).$promise;
          p.then(function() {
            vm.deleteEstadoFenologicoView({cuartel:sector}, estado);
            if(sector.id == vm.sectorWindowEstadoEdit.id){
              vm.deleteEstadoFenologicoView({cuartel:vm.sectorWindowEstadoEdit}, estado);
              vm.deleteEstadoFenologicoView({cuartel:vm.sectorWindowEstado}, estado);
            }
          });
          promises.push(p);
        });

        //al eliminar todo
        $q.all(promises).then(function(){
          vm.generalLoading = false;

          $mdToast.show(
              $mdToast.simple()
                  .textContent("Estados Eliminados")
                  .position(CONSTANTES.TOAST_POSITION)
          );
        });


      }, function() {
        console.error("Problemas al borrar estado");
        vm.generalLoading = false;
      });
      return p;

    }






    vm.copiarEstadosTemporada = function(temporadaOrigen, temporadaDestino){
      if(temporadaOrigen != temporadaDestino && temporadaOrigen.periodo != temporadaDestino.periodo){
        var mio = moment(temporadaOrigen.inicio);
        var mid = moment(temporadaDestino.inicio)
        var diff = mid.diff(mio, "years");
        var estados = vm.getEstadosPeriodo(temporadaOrigen, vm.sectorWindowEstadoEdit);
        var estadosNuevos = [];
        var sector = vm.sectorWindowEstadoEdit;
        sector.loadingCopiando = true;
        angular.forEach(estados, function (estado) {

          var d = {
            sector_id               : sector.id,
            nombre_etapa            : estado.nombre,
            fecha_inicio            : moment.unix(estado.fecha_inicio).add(diff, "years").toDate().cleanHour(),
            fecha_fin               : estado.fecha_fin == null ? null : moment.unix(estado.fecha_fin).add(diff, "years").toDate().cleanHour(),
            porcentaje_recuperacion : estado.porcentaje_rec,
            porcentaje_rec          : estado.porcentaje_rec,
            ks                      : estado.ks,
            dtx_inf                 : estado.dtx_inf,
            dtx_sup                 : estado.dtx_sup,
            cantidad_riegos         : estado.cantidad_riegos
          }

          if(_.isNumber(estado.limite_scholander) && estado.limite_scholander > 0){
            d.limite_scholander = estado.limite_scholander;
          }

          estadosNuevos.push(d);
        });
        vm.guardarEstadosLote(estadosNuevos);
        sector.loadingCopiando = false;
      }
    }






    vm.agregarTerminoEstado = function(estado) {
      estado.dateTermino = moment(estado.dateInicio).add(1, "day").toDate().cleanHour();
      estado.fecha_fin = moment(estado.dateTermino).unix();
    }

    vm.abrirEstado = function(estado) {
      estado.dateTermino = null;
      estado.fecha_fin = null;
    }


    vm.guardarEstado = function(estado, cuartel, reloadCuartel) {
      //TODO validacion
      estado.editando = false;
      estado.loading = true;
      reloadCuartel = reloadCuartel || false;
      var sector = {
        etapa_id               : estado.id_estado,
        sector_id              : cuartel.id,
        nombre_etapa           : estado.nombre,
        fecha_inicio           : moment(estado.dateInicio).format("YYYY-MM-DD"),
        fecha_fin              : null,
        porcentaje_recuperacion: estado.porcentaje_rec,
        //limite_scholander: estado.limite_scholander
      }
      if(estado.ks){
        sector.ks = parseFloat(estado.ks);
      }

      if(estado.dtx_inf){
        sector.dtx_inf = parseFloat(estado.dtx_inf);
      }

      if(estado.dtx_sup){
        sector.dtx_sup = parseFloat(estado.dtx_sup);
      }

      if(estado.cantidad_riegos){
        sector.cantidad_riegos = parseInt(estado.cantidad_riegos);
      }

      // TODO: revisar limite_scholander para MAI
      if(estado.limite_scholander == 0 || estado.limite_scholander == "" || vm.config.vinedo.mai ){
        sector.limite_scholander = 1;
      }

      estado.limite_scholander = parseFloat(estado.limite_scholander)

      if(_.isNumber( estado.limite_scholander) && estado.limite_scholander > 0){
        sector.limite_scholander = estado.limite_scholander;
      }


      if (estado.dateTermino != null) {
        sector.fecha_fin = moment(estado.dateTermino).format("YYYY-MM-DD");
      }
      var data = {sectores:[sector]};

      var successFn = function() {
        estado.loading = false;
        var dataEstado = {
          id              : estado.id_estado,
          fecha_inicio    : moment(estado.dateInicio.cleanHour()).unix(),
          nombre          : estado.nombre,
          fecha_fin       : null,
          porcentaje_rec  : estado.porcentaje_rec,
        };
        if (estado.dateTermino != null) {
          dataEstado.fecha_fin = moment(estado.dateTermino.cleanHour()).unix();
        }

        if(estado.ks){
          dataEstado.ks = estado.ks;
        }
        if (estado.dtx_inf) {
          dataEstado.dtx_inf = estado.dtx_inf;
        }
        if (estado.dtx_sup) {
          dataEstado.dtx_sup = estado.dtx_sup;
        }
        if (estado.cantidad_riegos) {
          dataEstado.cantidad_riegos = estado.cantidad_riegos;
        }

        vm.editarEstadoCuartel({cuartel: cuartel}, dataEstado);
        vm.editarEstadoCuartel({cuartel: vm.sectorWindowEstadoEdit}, dataEstado);
        regenerarSectorServer(cuartel);
      }

      CuartelRes.postEstadosFenologicos(data).$promise
      .then(successFn, function(res) {
        estado.loading = false;
        $mdToast.show(
          $mdToast.simple()
          .textContent(res.data.msj)
          .position(CONSTANTES.TOAST_POSITION)
        );

        //PARCHE
        // TODO revisar problema de solapamiento en backend
        successFn(res);
      });
    }

    vm.editarEstadoCuartel = function(cuartelDia, estadoEditado) {
      var c = cuartelDia.sector;
      if (cuartelDia.sector === undefined && cuartelDia.cuartel !== undefined){
        c = cuartelDia.cuartel;
      }

      angular.forEach(c.estados, function(estado) {
        if (estadoEditado.id === estado.id_estado) {
          if (estadoEditado.nombre !== undefined) {
            estado.nombre = estadoEditado.nombre;
          }
          if (estadoEditado.fecha_inicio !== undefined) {
            estado.fecha_inicio = estadoEditado.fecha_inicio;
            estado.dateInicio = moment.unix(estadoEditado.fecha_inicio).toDate().cleanHour();
          }
          if (estadoEditado.porcentaje_rec !== undefined) {
            estado.porcentaje_rec = estadoEditado.porcentaje_rec ;
          }


          if(vm.config.vinedo.mai){
            if (estadoEditado.ks !== undefined) {
              estado.ks = estadoEditado.ks;
            }
            if (estadoEditado.dtx_inf !== undefined) {
              estado.dtx_inf = estadoEditado.dtx_inf;
            }
            if (estadoEditado.dtx_sup !== undefined) {
              estado.dtx_sup = estadoEditado.dtx_sup;
            }
            if (estadoEditado.cantidad_riegos !== undefined) {
              estado.cantidad_riegos = estadoEditado.cantidad_riegos;
            }
          }

          if (estadoEditado.limite_scholander!== undefined) {
            estado.limite_scholander= estadoEditado.limite_scholander;
          }
          if (estadoEditado.fecha_fin !== undefined) {
            estado.fecha_fin = estadoEditado.fecha_fin;
            estado.dateTermino = moment.unix(estadoEditado.fecha_fin).toDate().cleanHour();
          }
        }
      });
    }





    vm.estadoValido = function(estado, estados, esNuevo) {
      var valido = true;
      if (!vm.verificarNombreEstado(estado, estados, esNuevo)){
        valido = false;
      }
      if (!vm.verificarFechasEstado(estado, esNuevo)) {
        valido = false;
      }
      if (!vm.validarPorcentajeEstado(estado, esNuevo)) {
        valido = false;
      }
      return valido;
    };

    vm.verificarFechasEstado = function(estado, esNuevo){
      var valid = true;
      var mi = moment(estado.dateInicio);
      var mf = moment(estado.dateTermino);
      //if(estado.hasError == undefined){
        estado.hasError = {};
      //}
      //if(estado.error == undefined) {
        estado.error = {};
      //}
      //estado.hasError['estado.dateInicio']  = false;
      //estado.hasError['estado.dateTermino'] = false;
      //estado.error['estado.dateInicio']     = "";
      //estado.error['estado.dateTermino']    = "";

      if (estado.dateInicio == "" || estado.dateInicio == "" || !mi.isValid()) {
        valid = false;
        estado.hasError['estado.dateInicio'] = true;
        estado.error['estado.dateInicio'] = "Fecha inicio invalida";
      }
      if (mf.isValid()) {
        if (mf.isBefore(mi)) {
          valid = false;
          estado.hasError['estado.dateTermino'] = true;
          estado.error['estado.dateTermino'] = "Fecha termino invalida";
        }
      }
        mf.subtract(10, "month");
        if (mi.isBefore(mf)) {
          valid = false;
          estado.hasError['estado.dateTermino'] = true;
          estado.error['estado.dateTermino'] = "Fecha termino demasiado lejana";
        }

        if(esNuevo){
          if(!vm.verificarPeriodo(estado, vm.temporadaSelectedWindow)){
            var str = getPeriodoEstado(estado);
            estado.hasError['estado.dateTemporada'] = true;
            estado.error['estado.dateTemporada'] = "El nuevo estado aparecera en la temporada "+str;
          }
        }

      return valid;
    }


    vm.verificarNombreEstado = function(estado, estadosEdit, esNuevo){
      var valid = true;
      if(estado.hasError == undefined){
        estado.hasError = {};
      }
      if(estado.error == undefined) {
        estado.error = {};
      }
      var temporada = vm.temporadaSelectedWindow;

      estado.hasError['estado.nombre'] = false;
      estado.error['estado.nombre'] = "";

      //nombre vacio
      if(estado.nombre !== undefined && estado.nombre.replace(" ", "") === "" && !esNuevo){
        valid = false;
        estado.hasError['estado.nombre'] = true;
        estado.error['estado.nombre'] = "Nombre vacio";
      }

      angular.forEach(estadosEdit, function(estadoE){
        if(vm.verificarPeriodo(estado, temporada) && vm.verificarPeriodo(estadoE, temporada)){
          if(estado.nombre == estadoE.nombre && estado.id_estado !== estadoE.id_estado ){
            valid = false;
            estado.hasError['estado.nombre'] = true;
            estado.error['estado.nombre'] = "Nombre Repetido";
          }
        }
      });
      return valid;
    };



    vm.validarLimiteScholander = function(estado, esNuevo){
      var valid = true;
      if(estado.hasError == undefined){
        estado.hasError = {};
      }
      if(estado.error == undefined) {
        estado.error = {};
      }
      var temporada = vm.temporadaSelectedWindow;

      estado.hasError['estado.limite_scholander'] = false;
      estado.error['estado.limite_scholander'] = "";

      if(estado.limite_scholander < 0){
        valid = false;
        estado.hasError['estado.limite_scholander'] = true;
        estado.error['estado.limite_scholander'] = "limite debe ser mayor a 0";
      }
      return valid;
    };


    vm.validarPorcentajeEstado = function(estado, esNuevo){
      var valid = true;
      if(estado.hasError == undefined){
        estado.hasError = {};
      }
      if(estado.error == undefined) {
        estado.error = {};
      }
      var temporada = vm.temporadaSelectedWindow;

      estado.hasError['estado.porcentaje'] = false;
      estado.error['estado.porcentaje'] = "";

      if(estado.porcentaje_rec < 0){
        valid = false;
        estado.hasError['estado.porcentaje'] = true;
        estado.error['estado.porcentaje'] = "Reposición debe ser mayor a 0";
      }
      return valid;
    };


    vm.cancelarEdicionEstado = function(estado, cuartel) {
      angular.forEach(cuartel.estados, function(estadoC) {
        if(estadoC.id_estado == estado.id_estado){
          $timeout(function() {
            estado.id                      = estadoC.id;
            estado.id_estado               = estadoC.id_estado;
            estado.fecha_inicio            = estadoC.fecha_inicio;
            estado.nombre                  = estadoC.nombre;
            estado.fecha_fin               = estadoC.fecha_fin;
            estado.porcentaje_rec          = estadoC.porcentaje_rec;
            estado.limite_scholander       = estadoC.limite_scholander;
            estado.dateInicio              = moment.unix(estado.fecha_inicio).toDate().cleanHour();
            estado.dateTermino             = moment.unix(estado.fecha_fin).toDate().cleanHour();

            if(vm.config.vinedo.mai){
              estado.ks              = estadoC.ks;
              estado.dtx_inf         = estadoC.dtx_inf;
              estado.dtx_sup         = estadoC.dtx_sup;
              estado.cantidad_riegos = estadoC.cantidad_riegos;
            }

          });
        }
      });
      estado.editando = false;
    }

    vm.cancelarEdicionEstadoNuevo = function() {
      vm.estadoNuevo = null;
    }

    vm.lastDateEstado = function(temporada) {
      var estados = vm.getEstadosPeriodo(temporada, vm.sectorWindowEstadoEdit);
      var lastDate  = null;
      angular.forEach(estados, function (estado) {
        if(estado.dateTermino === undefined && estado.fecha_termino !== null){
          estado.dateTermino = moment.unix(estado.fecha_fin).toDate().cleanHour();
        }
        if(lastDate == null && estado.dateTermino !== null){
          lastDate = estado.dateTermino;
        }else if(moment(lastDate).isBefore(moment(estado.dateTermino))){
          lastDate = estado.dateTermino;
        }
      });
      return lastDate;
    }

    vm.agregarEstado = function() {
      //los estados nuevos inician con la fecha posterior al termino del ultimo estado de la temporada
      // si la temporada no tiene un ultimo estado, comienza con la fecha actual
      var dateI = vm.lastDateEstado(vm.temporadaSelectedWindow);

      if(dateI === null){
        dateI = new Date();
      }
      dateI = moment(dateI).add(1, "day").toDate().cleanHour();
      var dateT = moment(dateI).add(1, "day").toDate().cleanHour();

      vm.estadoNuevo = {
        dateInicio        : dateI,
        dateTermino       : dateT,
        dateTerminoDirty  : false,
        nombre            : "",
        editando          : true,
        porcentaje_rec    : 0,
        ks                : 0,
        dtx_inf           : 0,
        dtx_sup           : 0,
        cantidad_riegos   : 0,
        limite_scholander : 0
      }
    }

    vm.changeDateInicio = function(estado) {
      if (!estado.dateTerminoDirty) {
        var m              = moment(estado.dateInicio).add(1, "day");
        estado.dateTermino = m.toDate().cleanHour();
      }
    }


    vm.changeDateTermino = function(estado){
      estado.dateTerminoDirty = true;
    }

    vm.guardarEstadoNuevo = function(estadoNuevo) {

      var cuartel = vm.sectorWindowEstado;

                var successFn = function(res) {
                  var estados_creados = [];

                  if (res.data !== undefined  && res.data.estados_creados !== undefined) {
                    estados_creados = res.data.estados_creados;
                  }

                  if (res.estados_creados !== undefined) {
                    estados_creados = res.estados_creados;
                  }

                  var dataEstado = {
                    id             : estados_creados[0].etapa_id,
                    id_estado      : estados_creados[0].etapa_id,
                    fecha_inicio   : moment(estadoNuevo.dateInicio.cleanHour()).unix(),
                    dateInicio     : estadoNuevo.dateInicio, //para mostrar sin tener que abrir nuevamente el popover
                    nombre         : estadoNuevo.nombre,
                    fecha_fin      : null,
                    dateTermino    : null,
                    porcentaje_rec : estadoNuevo.porcentaje_rec,
                    //limite_scholander: estadoNuevo.limite_scholander
                  }

                  if(vm.config.vinedo.mai){
                    dataEstado.ks              = estadoNuevo.ks;
                    dataEstado.dtx_inf         = estadoNuevo.dtx_inf;
                    dataEstado.dtx_sup         = estadoNuevo.dtx_sup;
                    dataEstado.cantidad_riegos = estadoNuevo.cantidad_riegos;

                    if(estadoNuevo.ks){
                      dataEstado.ks = estadoNuevo.ks;
                    }
                    if ( estadoNuevo.dtx_inf) {
                      dataEstado.dtx_inf = estadoNuevo.dtx_inf;
                    }
                    if ( estadoNuevo.dtx_sup) {
                      dataEstado.dtx_sup = estadoNuevo.dtx_sup;
                    }
                    if ( estadoNuevo.cantidad_riegos) {
                      dataEstado.cantidad_riegos = estadoNuevo.cantidad_riegos;
                    }
                  }

                  estadoNuevo.limite_scholander = parseFloat(estadoNuevo.limite_scholander);

                  if(_.isNumber(estadoNuevo.limite_scholander) && estadoNuevo.limite_scholander > 0){
                    dataEstado.limite_scholander = estadoNuevo.limite_scholander;
                  }

                  if (estadoNuevo.dateTermino != null) {
                    dataEstado.fecha_fin = moment(estadoNuevo.dateTermino.cleanHour()).unix();
                    dataEstado.dateTermino = estadoNuevo.dateTermino;
                  }

                  vm.agregarEstadoCuartel({
                    cuartel:cuartel
                  }, dataEstado);

                  vm.sectorWindowEstadoEdit.estados.push(dataEstado);
                  vm.estadoNuevo = null;
                }


                var errorFn = function(res) {
                  successFn(res);
                  if (res.data.errors && res.data.msj != undefined) {
                    $mdToast.show(
                      $mdToast.simple()
                      .textContent(res.data.msj)
                      .position(CONSTANTES.TOAST_POSITION)
                    );
                  }
                  angular.forEach(res.data.sectores_errores, function(error) {
                    $mdToast.show(
                      $mdToast.simple()
                      .textContent(error.mensaje)
                      .position(CONSTANTES.TOAST_POSITION)
                    );
                  });
                }

      var di = moment(estadoNuevo.dateInicio).utc().hours(0).minute(0).seconds(0).toDate();
      var estado = {
        sector_id               : cuartel.id,
        nombre_etapa            : estadoNuevo.nombre,
        fecha_inicio            : estadoNuevo.dateInicio.cleanHour(),
        porcentaje_recuperacion : estadoNuevo.porcentaje_rec,
        porcentaje_rec          : estadoNuevo.porcentaje_rec,
        limite_scholander       : estadoNuevo.limite_scholander ? estadoNuevo.limite_scholander : 1,
        fecha_fin               : null,
        dateTermino             : null,
      };

      if(vm.config.vinedo.mai){
        estado.ks              = estadoNuevo.ks;
        estado.dtx_inf         = estadoNuevo.dtx_inf;
        estado.dtx_sup         = estadoNuevo.dtx_sup;
        estado.cantidad_riegos = estadoNuevo.cantidad_riegos;
      }

      if (estadoNuevo.dateTermino != null) {
        estado.fecha_fin = estadoNuevo.dateTermino.cleanHour()
      }

      var sectoresPeticion = [estado];

      CuartelRes.postEstadosFenologicos({
        sectores: sectoresPeticion
      }).$promise.then(successFn, errorFn);
    }



    vm.showdialogDeleteEstadoWindow = function(cuartel, estado, ev) {
      var cuartelDia = {
        cuartel: cuartel
      }
      var ce = vm.sectorWindowEstadoEdit;
      vm.showdialogDeleteEstado(cuartelDia, estado, ev).then(function() {
        angular.forEach(ce.estados, function(estadoOriginal, index) {
          if (estadoOriginal.id_estado == estado.id_estado) {
            ce.estados.splice(index, 1);
          }
        });
      });
    }

    vm.showdialogDeleteEstado = function(cuartelDia, estado, ev) {

      var confirm = $mdDialog.confirm()
      .title('¿Realmente quieres borrar el estado <<'+estado.nombre+'>> ??')
      .textContent('La eliminacion es irreversible')
      .ariaLabel('Borrar Estado')
      .targetEvent(ev)
      .ok('Borrar')
      .cancel('Cancelar');

      var p = $mdDialog.show(confirm);
      p.then(function() {
        vm.generalLoading = true;

        CuartelRes.deleteEstadosFenologicos({etapa_id: estado.id_estado}).$promise.then(function() {
          $mdToast.show(
            $mdToast.simple()
            .content("Estado Eliminado")
            .position(CONSTANTES.TOAST_POSITION)
            .hideDelay(3000)
          );
          vm.deleteEstadoFenologicoView(cuartelDia, estado);
          vm.generalLoading = false;
        });

      }, function() {
        console.error("Problemas al borrar estado");
        vm.generalLoading = false;
      });
      return p;
    };


    vm.deleteEstadoFenologicoView = function(cuartelDia, estadoEliminado) {
      var c = cuartelDia.cuartel;

      //termina estado actual no cerrado
      angular.forEach(c.estados, function(estado, index) {
        if (estadoEliminado.id_estado == estado.id_estado) {
          c.estados.splice(index, 1);
        }
      });

      //limpiar clases del cuartel
      /*
      $("#cuartel-"+c.id+" .fecha-cuartel").each(function(index, element) {
        for (var i = 1; i <= 4 ; i++) {
          $(element).removeClass("estado-"+i);
        }
      });

      angular.forEach(c.dias, function(dia) {
        if(dia.unix < vm.hoy_unix){
          angular.forEach(c.estados, function(estado, key) {
            var m1 = moment.unix(estado.fecha_inicio).subtract(1, "days");
            if(estado.fecha_fin!== null){
              var m2 = moment.unix(estado.fecha_fin).add(1, "days");
              if (moment.unix(dia.unix).isBetween(m1, m2)){
                //clasesDiaDiv +=" estado-"+(key%4 + 1);
                $("#"+c.id+"-"+dia.unix).addClass("estado-"+(key%4 + 1));
              }
            }else{
              if (moment.unix(dia.unix).isAfter(m1)){
                //clasesDiaDiv +=" estado-"+(key%4 + 1);
                $("#"+c.id+"-"+dia.unix).addClass("estado-"+(key%4 + 1));
              }
            }
          });
        }
      });
      vm.hideDetailFenologia();
      */
    }





    vm.hideDetailFenologia = function(){
      $("#detail-estado").css("display", "none");
    };

    vm.showDetailFenologia = function(){
      $("#detail-estado").css("display", "inline-block");
    };


    vm.aplicarA = function(nombre, cuartel, item) {
      cuartel.loadingAplicar = true;
      var sectores = buscarSectores(nombre, null, item);
      var temporada = vm.temporadaSelectedWindow;
      // Appending dialog to document.body to cover sidenav in docs app
      if (_.isArray(sectores) && sectores.length > 0) {
        confirmarAplicar(cuartel, sectores, temporada);
      }
      //este caso sucede cuando debe seleccionar los sectores
      //si tiene la funcion "then", entonces es una promesa de mdDialog
      //espera la promesa para obtener los sectores seleccionados
      if(typeof sectores.then === 'function'){
        sectores.then(function(res) {
          if(res.sectores.length > 0){
            confirmarAplicar(cuartel, res.sectores, temporada);
          }else{
            cuartel.loadingAplicar = false
          }
        }, function(error) {
          cuartel.loadingAplicar = false
        });
      }
    }



    var confirmarAplicar = function( cuartel, sectores, temporada){

      var successFn = function(params) {
        var promises = [];
        //borrar estados a sobreescribir
        angular.forEach(sectores, function(sector) {
          angular.forEach(sector.estados, function(estado) {
            if (isEstadoTemporada(estado, temporada) && sector.id != cuartel.id) {
              var p = CuartelRes.deleteEstadosFenologicos({etapa_id: estado.id_estado}).$promise;
              promises.push(p);
              p.then(function() {
                vm.deleteEstadoFenologicoView({cuartel:sector}, estado);
              });
            }
          });
        });

        //copiar estados
        var estadosNuevos = [];
        var etapas = [];
        angular.forEach(cuartel.estados, function(estado) {
          if (isEstadoTemporada(estado, temporada)) {
            angular.forEach(sectores, function(sector) {

              if(params.aplicarEtapas){
                etapas.push({
                  id             : 0,
                  nombre         : estado.nombre,
                  fecha_inicio   : moment.unix(estado.fecha_inicio).format("YYYY-MM-DD"),
                  fecha_fin      : moment.unix(estado.fecha_fin).format("YYYY-MM-DD"),
                  sector_riego_id: sector.id
                })
              }
              if(sector.id == cuartel.id){
                return;
              }


              var fecha_inicio = new moment.unix(estado.fecha_inicio).toDate().cleanHour();
              var fecha_fin    = new moment.unix(estado.fecha_fin).toDate().cleanHour();
              var estadoN = {
                sector_id              : sector.id,
                nombre_etapa           : estado.nombre,
                //fecha_inicio         : fecha_inicio,
                //fecha_fin            : fecha_fin,
                fecha_inicio           : moment.unix(estado.fecha_inicio).toDate().cleanHour(),
                fecha_fin               : estado.fecha_fin == null ? null : moment.unix(estado.fecha_fin).toDate().cleanHour(),
                porcentaje_recuperacion : estado.porcentaje_rec,
                porcentaje_rec          : estado.porcentaje_rec,
                ks                      : estado.ks,
                dtx_inf                 : estado.dtx_inf,
                dtx_sup                 : estado.dtx_sup,
                cantidad_riegos         : estado.cantidad_riegos,
              };
              if(estado.limite_scholander > 0){
                estadoN.limite_scholander = estado.limite_scholander;
              }
              estadosNuevos.push(estadoN);
            });
          }
        });


        $q.all(promises).then(function () {
          vm.guardarEstadosLote(estadosNuevos);
          if (params.aplicarEtapas) {
            vm.deleteEtapas(sectores, temporada)
              .then(function () {
                vm.guardarEtapasFertLote(etapas);
              });
          }
          cuartel.loadingAplicar = false;
        });


      };

        $mdDialog.show({
          controller: ['$mdDialog', function ($mdDialog) {
            var vm = this;
            vm.aplicarEtapas = false;

            vm.cancel = function () {
              $mdDialog.cancel();
            };

            vm.accept= function () {
              $mdDialog.hide({aplicarEtapas: vm.aplicarEtapas});
            };
          }],
                controllerAs        : "c",
                templateUrl         : 'components/vinedo/newtimeline/confirm/confirmAplicarA.tmpl.html',
          parent: angular.element(document.body),
          //targetEvent: ev,
          clickOutsideToClose:true,
        })
        .then( successFn, function() {

        });

    }



    vm.guardarEstadosLote = function(estados) {

      var successFn = function(res) {
        var estados_creados = [];
        if (res.data !== undefined  && res.data.estados_creados !== undefined) {
          estados_creados = res.data.estados_creados;
        }
        if (res.estados_creados !== undefined) {
          estados_creados = res.estados_creados;
        }

        angular.forEach(vm.equipos, function(equipo) {
          angular.forEach(equipo.sector_riego, function(cuartel) {
            var dataEstado = {};
            angular.forEach(estados, function(estadoNuevo) {
              angular.forEach(estados_creados, function(estado_creado) {
                if (cuartel.id == estadoNuevo.sector_id && estado_creado.sector_id == cuartel.id){
                  if (
                    //moment(estado_creado.etapa.fecha_inicio.date).isSame(estadoNuevo.fecha_inicio, "day") &&
                    //moment(estado_creado.etapa.fecha_fin.date).isSame(estadoNuevo.fecha_fin, "day") &&
                    estado_creado.etapa.nombre == estadoNuevo.nombre_etapa
                  ) {
                    dataEstado = {
                      id              : estado_creado.etapa_id,
                      id_estado       : estado_creado.etapa_id,
                      fecha_inicio    : new moment(estadoNuevo.fecha_inicio.cleanHour()).unix(),
                      dateInicio      : estadoNuevo.fecha_inicio.cleanHour(),
                      nombre          : estadoNuevo.nombre_etapa,
                      fecha_fin       : new moment(estadoNuevo.fecha_fin.cleanHour()).unix(),
                      dateTermino     : estadoNuevo.fecha_fin.cleanHour(),
                      porcentaje_rec  : estadoNuevo.porcentaje_rec,
                      ks              : estadoNuevo.ks,
                      dtx_inf         : estadoNuevo.dtx_inf,
                      dtx_sup         : estadoNuevo.dtx_sup,
                      cantidad_riegos : estadoNuevo.cantidad_riegos,
                    }

                    if(_.isNumber(estadoNuevo.limite_scholander) && estadoNuevo.limite_scholander > 0){
                      dataEstado.limite_scholander = estadoNuevo.limite_scholander;
                    }

                    vm.agregarEstadoCuartel({
                      cuartel:cuartel
                    }, dataEstado);

                    if(cuartel == vm.sectorWindowEstado){
                      //para cuando copias estados entre temporadas
                      vm.agregarEstadoCuartel({
                        cuartel: vm.sectorWindowEstadoEdit
                      }, dataEstado);
                    }

                  }
                }
              });
            });
          });
        });
      } //END success

      var errorFn = function(res) {
        if (res.data.errors && res.data.msj != undefined) {
          $mdToast.show(
            $mdToast.simple()
            .textContent(res.data.msj)
            .position(CONSTANTES.TOAST_POSITION)
          );
        }
        angular.forEach(res.data.sectores_errores, function(error) {
          $mdToast.show(
            $mdToast.simple()
            .textContent(error.mensaje)
            .position(CONSTANTES.TOAST_POSITION)
          );
        });
      }


      var p = CuartelRes.postEstadosFenologicos({
        sectores: estados
      }).$promise;

      p.then(successFn, function(res){
        successFn(res);
        errorFn(res);
      });


    }





    vm.agregarEstadoCuartel = function(cuartelDia, estadoNuevo) {
      var c = cuartelDia.cuartel;

      //termina estado actual no cerrado
      angular.forEach(c.estados, function(estado) {
        if(estado.fecha_fin == null){
          var mEstadoNuevo = moment.unix(estadoNuevo.fecha_inicio).subtract(1, "days");
          var mEstado = moment.unix(estado.fecha_inicio);
          if (mEstado.isBefore(mEstadoNuevo)) {
            estado.fecha_fin = mEstadoNuevo.unix();
          }
        }
      });

      if (c.estados === undefined) {
        c.estados = []
      }

      //console.log("agregarEstadoCuartel");
      c.estados.push(estadoNuevo);
    }




    var buscarSectores = function(nombre, cuartelAux, item, include) {
      var sectores = [];
      switch (nombre) {
        case "equipo":
          angular.forEach(item.sector_riego, function(cuartel) {
            if(cuartelAux == null || cuartel.id != cuartelAux.id){
              sectores.push(cuartel);
            }
          });
          break;
        case "variedad":
          angular.forEach(vm.equipos, function(equipo) {
            angular.forEach(equipo.sector_riego, function(cuartel) {
              angular.forEach(cuartel.resumen.calidades, function(calidad) {
                if(calidad.variedad_id == item.variedad_id && (cuartelAux == null || cuartel.id != cuartelAux.id)){
                  sectores.push(cuartel);
                }
              });
            });
          });
          break;
        case "vinedo":
          angular.forEach(vm.equipos, function(equipo) {
            angular.forEach(equipo.sector_riego, function(cuartel) {
              if(cuartelAux == null || cuartel.id != cuartelAux.id){
                sectores.push(cuartel);
              }
            });
          });
          break;
          case "seleccionar":
          default:
            sectores = showSelectSectores({
              sectoresDisabled : [cuartelAux],
              msjDisabled      : "Cuartel Actual"
            });
          }
      return sectores;
    }


            var DialogController = ["$scope", "$mdDialog", "equipos", "variedades", "calidades", "sectoresDisabled", "msjDisabled",
            function($scope, $mdDialog, equipos, variedades, calidades, sectoresDisabled, msjDisabled) {

              var vm                    = this;
              vm.equipos                = equipos;
              vm.variedades             = variedades;
              vm.calidades              = calidades;
              vm.showCalidad            = null;
              vm.showVariedad           = null;
              vm.variedadSelected       = null;
              vm.calidadSelected        = null;
              vm.sectoresDisabled       = sectoresDisabled;
              vm.msjDisabled            = msjDisabled;
              var sectoresSeleccionados = [];



              angular.forEach(vm.equipos, function (equipo) {
                angular.forEach(equipo.sector_riego, function (sector) {
                  sector.show = true;
                  sector.selected = false;
                });
              });

              vm.checkIsDisabled = function(sector){
                if(vm.sectoresDisabled){
                  if(_.find(vm.sectoresDisabled, {id:sector.id}) !== undefined){
                    return true;
                  }
                }
                return false;
              }




              vm.selectEquipo = function(equipo) {
                if (equipo.selected === undefined) {
                  equipo.selected = false;
                }
                equipo.selected = !equipo.selected;
                angular.forEach(equipo.sector_riego, function(sector) {
                  if(!vm.checkIsDisabled(sector)){
                    sector.selected = equipo.selected;
                  }
                });
              }





            vm.openMenu = function ($mdOpenMenu, ev) {
              $mdOpenMenu(ev);
            };



            function isSelectable(sector, variedadSelected, calidadSelected) {
              var variedadAll = false;
              var calidadAll = false;
              if(variedadSelected === null || variedadSelected === undefined){
                variedadAll = true;
              }
              if(calidadSelected === null || calidadSelected === undefined){
                calidadAll = true;
              }
              if(calidadAll && variedadAll){
                return true;
              }
              var ret = false;
              angular.forEach(sector.resumen.calidades, function (cal) {
                  if(variedadAll || cal.variedad_id === variedadSelected.id) {
                    if(calidadAll || cal.calidad_nombre === calidadSelected.nombre){
                      ret = true;
                    }
                  }
              });
              return ret;
            }







              vm.selectVariedadCalidad = function () {
                var showAll          = true;
                vm.showVariedad      = null;
                vm.showCalidad       = null;
                var variedadSelected = vm.variedadSelected;
                var calidadSelected  = vm.calidadSelected;

                if(variedadSelected !== null){
                  vm.showVariedad = variedadSelected;
                  showAll = false;
                }

                if(calidadSelected !== null){
                  vm.showCalidad = calidadSelected;
                  showAll = false;
                }

                angular.forEach(vm.equipos, function (equipo) {
                  angular.forEach(equipo.sector_riego, function (sector) {
                    sector.show = true;
                    if(!isSelectable(sector, variedadSelected, calidadSelected) && !showAll){
                      sector.show = false;
                    }
                  });
                });
                //vm.getSectoresSeleccionados();
              };


              vm.selectVariedad = function(variedad){
                vm.variedadSelected = variedad;
                vm.selectVariedadCalidad();
              }


              vm.selectCalidadByName = function(calidad){
                vm.calidadSelected = calidad;
                vm.selectVariedadCalidad();
              }


            vm.clear = function(equipos){
              vm.variedadSelected = null;
              vm.calidadSelected = null;

              vm.sistemaConduccionSelected = null;
              vm.clonSelected = null;
              vm.portaInjertoSelected = null;
              vm.especieSelected = null;

              angular.forEach(equipos, function (equipoE) {
                equipoE.selected = false;
                angular.forEach(equipoE.sector_riego, function (sectorE) {
                  sectorE.selected = false;
                });
              });
            };





              vm.isEquipoIndeterminate = function(equipo) {
                var allChecked = true;
                var nothingChecked = true;
                angular.forEach(equipo.sector_riego, function(sector) {
                  if (!sector.selected) {
                    allChecked = false
                  }
                  if (sector.selected) {
                    nothingChecked = false
                  }
                });
                return !allChecked && !nothingChecked;
              }

              vm.isEquipoChecked = function(equipo) {
                var allChecked = true;
                angular.forEach(equipo.sector_riego, function(sector) {
                  if (!sector.selected) {
                    allChecked = false
                  }
                });
                return allChecked;
              }

              $scope.cancel = function() {
                $mdDialog.cancel();
              };

              $scope.aceptar = function() {
                angular.forEach(vm.equipos, function(equipo) {
                  angular.forEach(equipo.sector_riego, function(sector) {
                      if (sector.selected && !vm.checkIsDisabled(sector)) {
                        sectoresSeleccionados.push(sector);
                      }
                  });
                });
                $mdDialog.hide({sectores: sectoresSeleccionados});
              };
            }];// end DialogController









            var showSelectSectores = function(params) {

              params = _.merge({
                sectoresDisabled:[]
              }, params);

              vm.refreshVarCal();
              var p = $mdDialog.show({
                controller          : DialogController,
                controllerAs        : "dd",
                templateUrl         : 'shared/timeTable/lightbox/selectSector.tmpl.html',
                parent              : angular.element(document.body),
                //targetEvent         : ev,
                clickOutsideToClose : true,
                locals             : {
                  equipos           : vm.equipos,
                  variedades        : vm.variedades,
                  calidades         : vm.calidades,
                  sectoresDisabled  : params.sectoresDisabled,
                  msjDisabled       : params.msjDisabled,
                }
              });
              var thenFn = function() {
                angular.forEach($scope.equipos, function(equipo) {
                  delete equipo.selected;
                  angular.forEach(equipo.sector_riego, function(cuartel) {
                    delete cuartel.selected;
                  });
                });
              }
              p.then(thenFn, thenFn);
              return p;
            }







            vm.refreshVarCal = function(){
              _.each(vm.equipos, function (equipo) {
                _.each(equipo.sector_riego, function (sector) {
                  var calidades = sector.resumen.calidades;
                  if (!_.isArray(calidades )){
                    calidades = [calidades]
                  }
                  _.each(calidades, function (cal) {

                    if (_.find(vm.variedades, {
                      id : cal.variedad_id
                    }) === undefined) {
                      //esto es porque variedad tiene calidades, y no queremos copiarlos
                      vm.variedades.push({
                        id     : cal.variedad_id,
                        nombre : cal.variedad_nombre
                      });
                    }

                    if(_.find(vm.calidades,  {
                      //id : calidad.id
                      id: cal.calidad_id
                    }) ===  undefined) {
                      vm.calidades.push({
                        id     : cal.calidad_id,
                        nombre : cal.calidad_nombre,
                      });
                    }

                  });
                });
              });
            };







    var isEstadoTemporada  = function(estado, temporada) {
      var mi = moment(temporada.inicio);
      var mf = moment(temporada.fin);
      var miEstado = moment.unix(estado.fecha_inicio);
      var mfEstado = moment.unix(estado.fecha_fin);
      if (mi.isBefore(miEstado) && mf.isAfter(mfEstado)){
        return true;
      }
      return false;
    }



    //usado en sidebar
    vm.estimarDelay = function(tipo, calidad, sectorParam,form, delay){
      if(form.$invalid){
        return;
      }
      if(_timeout[tipo] !== undefined){
        if(_timeout[tipo][sectorParam.id] !== undefined){
          if(_timeout[tipo][sectorParam.id]) { // if there is already a timeout in process cancel it
            $timeout.cancel(_timeout[tipo][sectorParam.id]);
          }
        }
      }else{
        _timeout[tipo]=[];
      }
      _timeout[tipo][sectorParam.id] = $timeout(function() {
        if(form.$valid){

          var v = "";
          sectorParam.estimacion.tipo = parseInt(sectorParam.estimacion.tipo);
          if(sectorParam.estimacion.tipo == 3){
            v = "dias";
          }
          if(sectorParam.estimacion.tipo == 2){
            v = "hh";
          }
          if(sectorParam.estimacion.tipo == 1) {
            v = "mm";
          }

          vm.estimar(tipo, calidad, sectorParam, v);
          _timeout[tipo][sectorParam.id] = null;
        }
      }, delay);
    }


    vm.estimarWindow = function(tipo, calidad, sectorParam){
      var sector = null;
      var v      = null;
      if(angular.isDefined(sectorParam)){
        sector = sectorParam;
      }else{
        sector = vm.cuartelWindow;
      }

      sector.estimacion.reposicion = sector.estimacion.reposicionEditable;
      sector.kc.teorico            = sector.estimacion.reposicion;
      sector.proximo.frecuencia    = sector.estimacion.dias;
      sector.estimacion.tipo       = parseInt(sector.estimacion.tipo);

      switch(sector.estimacion.tipo){
        case 3:
          v = "dias";
          break;
        case 2:
          v = "hh";
          break;
        case 1:
          default:
          v = "mm"
      }
      if(tipo == "sectores"){
        showSelectSectores({
          sectoresDisabled:[sector],
          msjDisabled      : "Sector Actual"
        }).then(function(res){
          var sectores_ids = _.map(res.sectores, "id");
          vm.estimar(tipo, calidad, sector, v, sectores_ids);
        })
      }else{
        vm.estimar(tipo, calidad, null, v);
      }

    }





    vm.estimar = function(tipo, calidad, sectorParam, type, sectoresArrayAplicar){

      vm.hidePopoverEstimacion()
      //var cantidad = 0;
      var sector   = null;
      var params   = {};

      if(sectorParam){
        sector                       = sectorParam;
        sector.estimacion.horas      = sector.proximo.horas;
        sector.estimacion.mm         = sector.proximo.mm; //>>
        sector.estimacion.reposicion = parseFloat(sector.kc.teorico); //innecesario para cuando se llama desde estimarWindow
        sector.loading               = true;
      } else {
        sector = vm.cuartelWindow;
      }

      if(type == "hh"){
        //sectorParam.estanque.riego_normal_hh =  moment.duration(moment(sectorParam.estanque.riego_normal_hh_formated).format("HH:mm")).asHours();
        sector.estanque.riego_normal_hh = sector.estimacion.horas;
        var mm = sector.estanque.riego_normal_hh * sector.precipitacion_sistema_mm;
        sector.estanque.riego_normal_mm = _.round(mm, 1);
      }
      if(type == "mm"){
        sector.estanque.riego_normal_mm = sector.estimacion.mm;
        var hh = sector.estanque.riego_normal_mm / sector.precipitacion_sistema_mm;
        sector.estanque.riego_normal_hh = _.round(hh, 2);
      }
      if(type == "dias"){
        params.frecuencia_riego = parseInt(sector.proximo.frecuencia);
      }


      if(sector.kc.ks){
        params.ks = parseFloat(sector.kc.ks);
      }

      if(sector.kc.cantidad_riegos){
        params.cantidad_riegos = parseInt(sector.kc.cantidad_riegos);
      }

      params.milimetros_riego           = sector.estanque.riego_normal_mm;
      params.tiempo_riego               = sector.estanque.riego_normal_hh;
      params.tipo_calculo_proximo_riego = sector.estimacion.tipo;



      switch (tipo) { //-¿esto es necesario?
        case "sector":
          params.sector_riego_id = sector.id;
          break;
        case "sectores":
          var sectores_id = [sector.id];
          if(sectoresArrayAplicar){
            sectores_id = sectores_id.concat(sectoresArrayAplicar);
          }
          params.sector_riego_id = sectores_id;
          break;
        case "equipo":
          params.equipo_id       = vm.equipoWindow.id;
          break;
        case "vinedo":
          params.vinedo_id       = $stateParams.id;
          break;
        case "calidad":
          params.calidad_id      = calidad.id;
          break;
        default:
          console.error("tipo sector no encontrado");
      }


      if(sector.estimacion.reposicion !== undefined){
        params.kr = parseFloat(sector.estimacion.reposicion) / 100;
      }else{
        params.kr = 1;
      }


      $http.post(urls.BASE+"/sector-riego/variables", params)
      .then(function(response){


        angular.forEach(response.data.data, function(cuartelId) {
          angular.forEach(vm.equipos, function(equipo) {
            angular.forEach(equipo.sector_riego, function(cuartel) {
              if (cuartel.id == cuartelId) {
                cuartel.loading = true;
                if (["equipo", "calidad"].indexOf(tipo) > -1) {
                  //cuartel.estimacion.reposicion = sectorParam.estimacion.reposicionEditable;
                  cuartel.kc.teorico            = cuartel.estimacion.reposicion / 100;
                  cuartel.riego_normal_hh       = sector.estimacion.horas;
                  cuartel.riego_normal_mm       = sector.estimacion.mm;
                }
              }
            });
          });
        });

        $timeout(function(){
          regenerarSectoresServer(response.data.data);
        });
      });

/*
      $http.post(urls.BASE+"/sector-riego/variables", paramsKr)
      .then(function(response) {
        $http.post(urls.BASE+"/sector-riego/variables", paramsMM)
            .then(function(response) {
              $http.post(urls.BASE+"/sector-riego/variables", paramsHH)
                  .then(function(response) {

                    angular.forEach(response.data.data, function(cuartelId) {
                      angular.forEach(vm.equipos, function(equipo) {
                        angular.forEach(equipo.sector_riego, function(cuartel) {
                          if (cuartel.id == cuartelId) {
                            cuartel.loading = true;
                            if (["equipo", "calidad"].indexOf(tipo) > -1) {
                              cuartel.estimacion.reposicion = sectorParam.estimacion.reposicionEditable;
                              cuartel.kr = cuartel.estimacion.reposicion / 100;
                              cuartel.riego_normal_hh = sectorParam.estimacion.horas;
                             cuartel.riego_normal_mm = sectorParam.estimacion.mm; //¿?¿?¿?
                            }
                          }
                        });
                      });
                    });

                    $timeout(function(){
                      regenerarSectoresServer(response.data.data);
                    });

                  }, function(response) {
                    //ERROR Horas-dias
                    //$log.error("guardar HH");
                  });
            }, function(response) {
          //ERROR Horas-dias
          //$log.error("guardar MM");
        });

      }, function(response) {
        //ERROR KR
        //$log.error("guardar KR");
      });
      */

    };












    vm.getSectoresPorometro = function(params){
      vm.sectoresPorometro= [];
      $http.get(urls.BASE+"/vinedo/sectores-porometro?vinedo_id=" + params.vinedo_id)
          .success(function(response){
            for(var i = 0; i < response.data.length; i++){
              var spor = angular.copy(response.data[i]);
              var cuarteles = [];
              angular.forEach(spor.sector_riego, function(cuartelId) {
                cuarteles.push(utils.getSectorById(vm.equipos, cuartelId));
              });
              spor.sector_riego = cuarteles;
              vm.sectoresPorometro.push(spor);
            }
          });
    }

    vm.getSectoresScholander = function(params){
      vm.sectoresScholander = [];
      $http.get(urls.BASE+"/vinedo/sectores-scholander?vinedo_id=" + params.vinedo_id)
          .success(function(response){
            for(var i = 0; i < response.data.length; i++){
              var ssch = angular.copy(response.data[i]);
              var cuarteles = [];
              angular.forEach(ssch.sector_riego, function(cuartelId) {
                cuarteles.push(utils.getSectorById(vm.equipos, cuartelId));
              });
              ssch.sector_riego = cuarteles;
              vm.sectoresScholander.push(ssch);
            }
          });
    }







    var getPrediccion = function(data){

      var params = {
        fecha_inicio : data.fecha_inicio,
        fecha_fin    : data.fecha_fin,
        vinedo_id    : $stateParams.id
      };

      //params.vinedo_id = $stateParams.id;
      if (angular.isDefined(vm.vinedo)) {
        vm.vinedo_nombre = vm.vinedo.data.nombre;
      }

      var defered = $q.defer();
      var promise = defered.promise;

      var prom = $http({
        //url    : urls.BASE+"/vinedo/prediccion",
        url    : urls.BASE+"/vinedo/resumen",
        params : params
      });


      prom.then(function(res) {

        vm.getSectoresScholander(params);
        vm.getSectoresPorometro(params);

        var length_days       = res.data.data.vinedo.equipos[0].sector_riego[0].dias.length;
        var unix_fecha_inicio = res.data.data.vinedo.equipos[0].sector_riego[0].dias[0].unix;
        var unix_fecha_fin    = res.data.data.vinedo.equipos[0].sector_riego[0].dias[length_days-1].unix;
        var promSensores      = null;
        var promCalicata      = null;
        var promTemperatura   = null;

        if(vm.config.vinedo['has-sensor-en-planilla']){
          promSensores = vm.getSectoresSensor({
            fecha_inicio : moment.unix(unix_fecha_inicio).format("DD-MM-YYYY"),
            fecha_fin    : moment.unix(unix_fecha_fin).format("DD-MM-YYYY"),
            vinedo_id    : $stateParams.id
          }).$promise;
        }

        if(vm.config.vinedo['conCalicata']){
          promCalicata = vm.getSectoresCalicata({
            fecha_inicio : moment.unix(unix_fecha_inicio).format("DD-MM-YYYY"),
            fecha_fin    : moment.unix(unix_fecha_fin).format("DD-MM-YYYY"),
            vinedo_id    : $stateParams.id
          }).$promise;
        }


        if(vm.config.vinedo.oidio &&
          res.data.data.vinedo.equipos.length > 0  &&
          res.data.data.vinedo.equipos[0].sector_riego.length > 0){

          var firstSector = res.data.data.vinedo.equipos[0].sector_riego[0];

          promTemperatura = VinedoRes.getTemp({
            vinedo_id    : $stateParams.id,
            fecha_inicio : data.fecha_inicio,
            fecha_fin    : data.fecha_fin
          }).$promise

        }

        Promise.all([promTemperatura , promSensores, promCalicata])
          .then(function(resp){

            var resT         = resp[0];
            var resSensores  = resp[1];
            var resCalicatas = resp[2];
            var t            = resT && resT.data ?  resT.data : [];

            defered.resolve([Object.assign(res.data, {temperaturaHora: t }), resSensores, resCalicatas]);

          }).catch(function(err){
            console.error(err);
            defered.reject(err);
          });



      }).catch(function(err){
        console.error(err);
        defered.reject(err);
      });
      return promise;
    };







    vm.addTodayLine = function() {
      vm.showTodayLine = false;
      if (moment().hours(0).isBetween(fechaInicio, fechaTermino)) {
        var unix = moment().hours(0).unix();
        var pos = utils.unixToPosition(fechaInicio, unix, r);
        vm.todayLeftPosition = pos + _.round(r/2) - 1;
        vm.todayLineHeight = cantidadSectores * r;
        vm.showTodayLine = true;
      }else{
        vm.todayLeftPosition = -1;
      }
    }









     vm.init = function() {
      var t0 = performance.now();

      //obtencion de temporadas, para llenar la lista visual
      // define las temporadas y la temporada Activa como seleccionada
      temporadaFac.getTemporadas().then(function(res) {
        vm.temporadas              = res.data.data;
        vm.temporadaFertSelected   = temporadaFac.getActiva();
        vm.temporadaSelectedWindow = temporadaFac.getActiva();
        vm.temporadaActiva         = temporadaFac.getActiva();
      }).then(() => {
        return getPrediccion({
          fecha_inicio : fechaInicio.format("DD-MM-YYYY"),
          fecha_fin    : fechaTermino.format("DD-MM-YYYY")
        })
      }).then(function(resPrediccion){
        var data = resPrediccion[0];
        var resSensores = resPrediccion[1];
        var resCalicatas = resPrediccion[2];

         vm.data                  = data.data;
         var unix_fecha_inicio    = null;
         var length_days          = null;
         var unix_fecha_fin       = null;

         //si la vista es para vinedo
         //if (angular.isDefined(vm.data.vinedo)) {
         et_semanales      = data.data.vinedo.et_semanales;
         temperaturasHora  = data.temperaturaHora;
         vm.equipos        = angular.copy( vm.data.vinedo.equipos);
         vm.casetas        = vm.data.vinedo.casetas;
         unix_fecha_inicio = vm.data.vinedo.equipos[0].sector_riego[0].dias[0].unix;
         length_days       = vm.data.vinedo.equipos[0].sector_riego[0].dias.length;
         unix_fecha_fin    = vm.data.vinedo.equipos[0].sector_riego[0].dias[length_days-1].unix;

         vm.refreshVarCal();

         fechaInicio      = moment.unix(unix_fecha_inicio).add(6, "hours");
         fechaTermino     = moment.unix(unix_fecha_fin).add(6, "hours");
         diffDays         = fechaTermino.diff(fechaInicio, 'days') -1;
         vm.lastPosition  = diffDays * r;
         vm.diasHeader    = utils.getDiasHeader(vm.equipos, et_semanales);
         vm.diasMesHeader = utils.getDiasMesHeader(vm.equipos, et_semanales);

         if(vm.config.vinedo.oidio){
           vm.diasMesHeader = utils.addOidio(vm.diasMesHeader, temperaturasHora); //data.temperaturaHora);
         }

         if(vm.config.vinedo.programacionfds){
           var tabProgramacion = _.find(vm.tabs,{tag: 'programacion'});
           if(tabProgramacion){
            tabProgramacion.alert = "Solo se puede programar Viernes, sabado, domingo y lunes";
             if(![4, 5,6, 0].includes(moment().weekday())){
               tabProgramacion.disabled = true;
             }
           }
         }
         vm.diasPrecip    = utils.getDiasPrecip(vm.equipos, et_semanales, fechaInicio, r);

         _.each(vm.equipos, function(equipo){
           _.each(vm.casetas, function(caseta){
             if(caseta.cantidad_sectores == undefined){
               caseta.cantidad_sectores = 0;
             }
             if(equipo.caseta_id == caseta.id){
               caseta.cantidad_sectores++;
             }
           });
         });

         vm.etx = _.round(vm.equipos[0].sector_riego[0].kc.etx, 1);



         //switch (vm.view) {
         //case 'equipo':
         //vm.et_semana_ant = data.data.equipo.et_sem_ant;
         //break;
         //case 'vinedo': // sea vinedo o no tenga valor
         //default:
         vm.et_semana_ant = data.data.vinedo.et_sem_ant;
         //break;
         //}

        // --- calicatas ---
        var sectoresCalicataOriginal = [];
        vm.sectoresCalicata = [];

         if(resCalicatas){
           resCalicatas.data.sectores.forEach(function(sectorCalicata){
             var cuarteles = [];
             sectorCalicata.sectores_riego.forEach(function(sectorRiego){
               var c = utils.getSectorById(vm.equipos, sectorRiego.id)
               if(c){
                //console.log("INIT sector "+c.nombre+" asignado sectorCalicata")
                 c.sectorCalicata = sectorCalicata;
                 cuarteles.push(c);
               }
             });
             sectorCalicata.cuarteles = cuarteles; // revisar
             sectoresCalicataOriginal.push(_.cloneDeep(sectorCalicata));
           });
           vm.sectoresCalicata = sectoresCalicataOriginal;
         }


        // --- sensores ---
        var sectoresSensorOriginal = [];
        vm.sectoresSensor = [];

         if(resSensores){
           resSensores.data.sectores.forEach(function(sectorSensor){
             var cuarteles = [];
             sectorSensor.sectores_riego.forEach(function(sectorRiego){
               var c = utils.getSectorById(vm.equipos, sectorRiego.id)
               if(c){
                //console.log("INIT sector "+c.nombre+" asignado sectorSensor")
                 c.sectorSensor = sectorSensor;
                 cuarteles.push(c);
               }
             });
             sectorSensor.cuarteles = cuarteles; // revisar
             sectoresSensorOriginal.push(_.cloneDeep(sectorSensor));
           });
           vm.sectoresSensor = sectoresSensorOriginal;
         }

         vm.generalLoading = false;
         vm.completeLoading = false;
         //calcularTotalSectores();
         calcularPosicionToggleSidebarButton();
         vm.calcularEspacioProgramacion();


         //parse a datos KR en cuarteles
         angular.forEach(vm.equipos, function(equipo){
           equipo.visible = true;
           angular.forEach(equipo.sector_riego, function(sector){
             prepareSector(sector);
           });
         });

         vm.applyFilter();
         var t1 = performance.now(); //para calculo de performance de carga de timeline
         vm.addTodayLine();
         vm.getEtapasFert();
       });
       vm.getFertilizacion();
     };
     vm.init();






    //inserta valor al sector en un dia especifico
    // antes de hacer la peticion a backend
    // acelerando la respuesta visual del guardado
     var insertVarSector = function (params) {
       var updated = false;
       var m2 = moment.unix(params.dia.unix);
       var mm_reales = null;
       var horas_reales = null;

       angular.forEach(params.sector.dias, function(diaData) {
         var m1 = moment.unix(diaData.unix).add(12, "hours");
         if(m1.isSame(m2, "day")){
           //iguala variables
           diaData[params.type] = params.dia[params.type];
           //recalcula variables
           if (params.type == "horas_reales") {
             if(vm.config.vinedo.conCaudalimetro){
               mm_reales = _.round(diaData.volumen / params.sector.ha / 10, 1);
             }else{
              mm_reales = diaData.horas_reales * params.sector.precipitacion_sistema_mm;
             }
           }
           if (params.type == "mm_reales ") {
             horas_reales = diaData.mm_reales / params.sector.precipitacion_sistema_mm;
           }
           if (diaData.hasSubriego) {
             diaData.subRiegoMM =mm_reales ;
             diaData.subRiegoHoras = horas_reales;
             //volumen se actualiza con regenerarSectorServer
           }else{
             diaData.mm_reales =mm_reales ;
             diaData.horas_reales = horas_reales;
           }
         }
       });

       angular.forEach(params.sector.diasData, function(diaData, i) {
         var m1 = moment.unix(diaData.unix).add(12, "hours");
         if(m1.isSame(m2, "day")){
           //iguala variables
           diaData[params.type] = params.dia[params.type];
           updated = true;
           //recalcula variables
           if(params.dia[params.type]  > 0){
             if (params.type == "horas_reales") {
               if(vm.config.vinedo.conCaudalimetro){
                 diaData.mm_reales = _.round(diaData.volumen / params.sector.ha / 10, 1);
               }else{
                 diaData.mm_reales = diaData.horas_reales * params.sector.precipitacion_sistema_mm;
               }
             }
             if (params.type == "mm_reales ") {
               diaData.horas_reales = diaData.mm_reales / params.sector.precipitacion_sistema_mm;
             }
           }
           //quita el dia de diasData si no tiene datos
           // OT: diasData es el array de dias con datos
           if(!utils.diaHasData(diaData, params.sector)){
             params.sector.diasData.splice(i, 1);
           }
         }
       });

       if (!updated) {
          params.dia.position = utils.unixToPosition(fechaInicio, params.dia.unix, r);
         if (params.type == "horas_reales") {
           if(vm.config.vinedo.conCaudalimetro){
             params.dia.mm_reales = _.round(params.dia.volumen / params.sector.ha / 10, 1);
           }else{
             params.dia.mm_reales =params.dia.horas_reales * params.sector.precipitacion_sistema_mm;
           }
         }
         if (params.type == "mm_reales ") {
           params.dia.horas_reales = params.dia.mm_reales / params.sector.precipitacion_sistema_mm;
         }
         //si el dia tiene datos
         //lo agrga a diasData
         params.sector.diasData.push(params.dia);
       }

     }






      //metodo que prepara el sector con las variables necesarias para iniciar el timeline
     var prepareSector = function(sector) {
       //console.log("prepare sector "+sector.nombre);

       var subriegos                   = [];
       sector.kc.teorico               = _.round(parseFloat(sector.kc.teorico), 1);
       //sector.rep                    = _.round(parseFloat(sector.kc.teorico)*100);
       sector.etAcumSemana             = vm.et_semana_ant;
       sector.precipitacion_sistema_mm = sector.precipitacion_sistema; // parche
       sector.visible                  = true;
       sector.estanque.riego_normal_hh_formated = moment(new Date(1970, 0, 1, 0, 0, 0))
         .add(sector.estanque.riego_normal_hh, "hours")
         .seconds(0).toDate();

       //calcularSugeridoSemanal(sector);
       //sector.horasSugMoment            = moment.duration(sector.prog.horas_sug, "hours");
       if (angular.isDefined(sector.ultimo)){
         if (angular.isDefined(sector.ultimo.unix)) {
           sector.ultimo.format  = moment.unix(sector.ultimo.unix).add(12,"hours").format("DD MMM");
         }else{
           sector.ultimo.format = "--";
         }
       }

       if( !_.isArray(sector.resumen.calidades) &&
         _.isObject(sector.resumen.calidades)){
         sector.resumen.calidades = [
           sector.resumen.calidades
         ];
       }

       //var tipo = 13;

       // 1- 11 : estimacion en Dias {default}
       // 2- 12 : estimacion en mm
       // 2- 13 : estimacion en Horas
       //if(sector.proximo !== undefined){
         //if (sector.proximo.tipo_calculo == 1) {
           //tipo = 11;
         //}else if (sector.proximo.tipo_calculo == 2) {
           //if(vm.config.vinedo.etimacionMM){
             //tipo = 12;
           //}
           //else tipo = 13
         //}
       //}



       //para ventana de estimacion
       sector.estimacion = {
         reposicion : Math.round((sector.kc.teorico * 100)*100)/100,
         dias       : sector.proximo.frecuencia,
         horas      : sector.proximo.horas,
         mm         : sector.proximo.mm,
         tipo       : sector.proximo.tipo_calculo,
         //varInt   : 0
       };


       //TODO revisar si es necesario hacer esto
       //ya que, aunque visualmente se muestra, no se guarda el cambio en backend
       /*
       if(sector.estanque.riego_normal_hh == 0 &&
          sector.estanque.riego_normal_mm != 0){
        var hh = sector.estanque.riego_normal_mm / sector.precipitacion_sistema_mm;
        sector.estanque.riego_normal_hh = _.round(hh, 1);
       }

       if(sector.estanque.riego_normal_hh != 0 &&
          sector.estanque.riego_normal_mm == 0){
        var mm = sector.estanque.riego_normal_hh * sector.precipitacion_sistema_mm;
        sector.estanque.riego_normal_mm = _.round(mm, 1);
       }
       */


       //sensores
       /*
       if(sector.sectorSensor && sector.sectorSensor.datos.length > 1 && false){
         _.forEach(sector.sectorSensor.datos, function(d, i){
           if( i > 0){ // la posicion 0 es un header
             var dia = _.find(sector.dias, {fecha: moment.unix(d[0]).format("YYYY-MM-DD")});
             if(dia){
               dia.datoSensor = _.without(_.map(d, function(prof, indexProf){
                 if(indexProf == 0) return null;
                 var r = {
                   prof: sector.sectorSensor.profundidades[indexProf-1][0],
                   value: prof,
                 }
                 return r;
               }), null);
             }
           }
         });
       }
       */


       if(sector.sectorSensor && sector.sectorSensor.datos.length > 1){
          //console.log("si ss");
          _.forEach(sector.dias, function(sectorDia){
            sectorDia.datoSensor = null;

            // sensorDiaData=> [[unix, prof1, prof2, prof3, ...], ...]
            // obtiene los datos de sensor del dia correspondiente --> sectorDia
            var sensorDiaData = _.filter(sector.sectorSensor.datos, function(datoSensor, indexDS){
              if(indexDS == 0) return false;
              return moment.unix(sectorDia.unix).isSame(moment.unix(datoSensor[0]), "day");
            });

            //reduce la lista de datos, sumando cada profundidad del sensor
            var sensorDiaParsed = _.reduce(sensorDiaData, function(coll, sdd){
              if(coll.length == 0) return sdd;
              coll = _.map(coll, function(prof, indexProf){
                if(indexProf == 0) return prof;
                prof += sdd[indexProf];
                return prof;
              })
              return coll;
            }, []);

            //promedia la suma de datos
            sensorDiaParsed = _.map( sensorDiaParsed , function(prof, indexProf){
                if(indexProf == 0) return prof;
                return prof / sensorDiaData.length;
            });

            //parsea los datos a un formato json
            if(sensorDiaParsed.length > 0){
              //sectorDia.datoSensor = sensorDiaParsed;
              sectorDia.datoSensor = _.orderBy(_.without(_.map(sensorDiaParsed, function(value, indexProf){
                if(indexProf){
                  var cc               = sector.sectorSensor.profundidades[indexProf-1][2];
                  var pmp              = sector.sectorSensor.pmp;
                  var valueNormalizado = value;
                  if(cc > 0){
                    valueNormalizado = 100 * ((value/cc)-1);
                  }
                  var light            = "red";
                  if(valueNormalizado > pmp){
                    light = "green";
                  }
                  if(valueNormalizado >  100){
                    light = "blue"
                  }
                  return {
                    id: sector.sectorSensor.profundidades[indexProf-1][1],
                    prof             : sector.sectorSensor.profundidades[indexProf-1][0],
                    cc               : cc,
                    isSum            : sector.sectorSensor.profundidades[indexProf-1][3],
                    value            : valueNormalizado,
                    valueNormalizado : valueNormalizado,
                    lightNormalizado : light
                  }
                }
                return null;
              }), null), "prof");

              if(sector.sectorSensor.sensor_ref){
                var sensorRef = _.find(sectorDia.datoSensor,  {prof: parseInt(sector.sectorSensor.sensor_ref)})
                sectorDia.lightNormalizado = sensorRef ? sensorRef.lightNormalizado : null;
              }
            }


          })

       }









       if(sector.sectorCalicata && sector.sectorCalicata.datos.length > 1){
          //console.log("si ss");
          _.forEach(sector.dias, function(sectorDia){
            sectorDia.datoCalicata = null;

            // sensorDiaData=> [[unix, prof1, prof2, prof3, ...], ...]
            // obtiene los datos de sensor del dia correspondiente --> sectorDia
            var sensorDiaData = _.find(sector.sectorCalicata.datos, function(datoCalicata , indexDS){
              if(indexDS == 0) return false; // header con strings
              var sd_moment = moment.unix(sectorDia.unix);
              var datoCalicata_moment = moment.unix(datoCalicata[0]);
              return sd_moment.isSame(datoCalicata_moment, "day");
            });

            //reduce la lista de datos, sumando cada profundidad del sensor
            //para casos con mas de una medicion diaria
            var sensorDiaParsed = _.cloneDeep(sensorDiaData);
            /*
            var sensorDiaParsed = _.reduce(sensorDiaData, function(coll, sdd){
              if(coll.length == 0) return sdd;
              coll = _.map(coll, function(prof, indexProf){
                if(indexProf == 0) return prof;
                prof += sdd[indexProf];
                return prof[];
              })
              return coll;
            }, []);

            //promedia la suma de datos
            sensorDiaParsed = _.map( sensorDiaParsed , function(prof, indexProf){
                if(indexProf == 0) return prof;
                return prof / sensorDiaData.length;
            });
            */

            //parsea los datos a un formato json
            if(sensorDiaParsed && sensorDiaParsed.length > 0){
              //sectorDia.datoCalicata = sensorDiaParsed;
              sectorDia.datoCalicata = _.without(_.map(sensorDiaParsed, function(prof, indexProf){
                  return (indexProf && prof) ? {
                                        prof: sector.sectorCalicata.profundidades[indexProf-1][0],
                                        value: prof[0],
                                        conductividad: prof[1],
                                      } : null;
              }), null);
              if(sectorDia.datoCalicata.length == 0){
                delete sectorDia.datoCalicata;
              }
            }


          })
       }


       //junta los estados fenologicos con los sectores de riego(sector) correspondiente
       if (angular.isDefined(vm.estadosVinedo)) {
         angular.forEach(vm.estadosVinedo.sectores, function(estadoSector) {
           if (estadoSector.id_sector_riego == sector.id) {
             sector.estados = estadoSector.etapas_sector_riego;
             angular.forEach(estadoSector.etapas_sector_riego, function(etapa) {
               if(etapa.nombre_estado){
                etapa.nombre       = etapa.nombre_estado;
               }
               etapa.fecha_inicio = moment.unix(etapa.fecha_inicio).add(6, "hours").unix();
               etapa.fecha_fin    = moment.unix(etapa.fecha_fin).add(6, "hours").unix();
               /*if (etapa.fecha_fin == null) {
                 sector.estadoActivo = etapa;
               }*/
             });
           }
         });
       }

       sector.estadoActual = vm.getEstadoByDate(null, sector);

       //verifica los dias del sector de riego con subriegos
       angular.forEach(sector.dias, function(dia) {
         dia.showTotalSubriego = false;
         if(dia.sub_riegos !== undefined){
           //console.log("sub_riegos is not undefined");
           angular.forEach(dia.sub_riegos, function(subriego) {
             subriegos.push(subriego);
             if(moment.unix(subriego.unix).isSame(moment.unix(dia.unix), "day")){
               dia.showTotalSubriego = true;
             }
           });
         }
       });



       angular.forEach(sector.dias, function(dia) {
         dia.hasSubriego = false;
         if(_.isArray(dia.mensaje) && dia.mensaje[0] == null){
           dia.mensaje = {};
         }
         angular.forEach(subriegos, function(subriego) {
           //add hack
           if(moment.unix(subriego.unix).isSame(moment.unix(dia.unix), "day")){
             dia.subRiegoHoras = subriego.horas_reales;
             dia.subRiegoMM = subriego.mm_reales;
             dia.subRiegoVol = subriego.volumen;
             //dia.subRiegoHoras = subriego.horas;
             //dia.subRiegoMM = subriego.milimetros;
             //dia.subRiegoVol = subriego.volumen_real;
             dia.hasSubriego = true;
           }
         });
         if (dia.horas_reales) {
           var mHora = floatToDuration(dia.horas_reales);
            dia.hReales = utils.durationToHour(mHora);
           }else{
            dia.hReales = null;
           }
         if (dia.horas_programadas) {
           var mHora = floatToDuration(dia.horas_programadas);
            dia.hProgramado  = utils.durationToHour(mHora);
           }else{
            dia.hProgramado = null;
           }
         //HACK
         dia.fecha_ingreso_unix = moment.unix(dia.fecha_ingreso_unix).add(12, "hours").unix();
         //horas nominales
         utils.verificarMM(dia, sector);
       });




       if(sector.diasData === undefined){
         sector.diasData = [];
       }else{
         sector.diasData.splice(0, sector.diasData.length);
       }


       angular.forEach(sector.dias, function(dia) {

          // esto sucede porque el array, cuando viene vacio, tiene un elemento null, como array de largo 1
          //se considera un bug a reportar
          // BUG
         if(_.first(dia.aplicacion) == null){
           dia.aplicacion = null;
         }

         if (utils.diaHasData(dia, sector)) {
           dia.position = utils.unixToPosition(fechaInicio, dia.unix, r);
           if(dia.riego){
             dia.horas_sug    = $filter("hours")(sector.proximo.horas);
             dia.riego_sug_mm = _.round(sector.proximo.mm, 1);
             dia.showTotalSug = !(utils.diaHasData(dia, sector, ["riego"]));
           }else{
             dia.horas_sug    = null;
             dia.riego_sug_mm = null;
             dia.showTotalSug = null;
           }
           sector.diasData.push(dia);
         }
       });


      var dias_riego = {};
       angular.forEach(sector.diasData, function(dd){
         angular.forEach(dd.sub_riegos, function(sr){
           dias_riego[sr.fecha] = {
             mm_reales    : dd.mm_reales ,
             horas_reales : dd.horas_reales,
             volumen      : dd.volumen,
             volumen_hora : dd.volumen_hora
             //hReal: utils.durationToHour(floatToDuration(dd.horas_reales)), //deprecado
           }
         });
       });

       angular.forEach(sector.diasData, function(dd){
         if(dias_riego[dd.fecha] !== undefined){
           dd.mm_reales    = dias_riego[dd.fecha].mm_reales ;
           dd.horas_reales = dias_riego[dd.fecha].horas_reales;
           dd.volumen      = dias_riego[dd.fecha].volumen;
           dd.volumen_hora = dias_riego[dd.fecha].volumen_hora;
           //dd.hReal = dias_riego[dd.fecha].hReal; //deprecado
         }

       });



       angular.forEach(sector.diasData, function(dd){
                  //verifica mensajes
                  if(dd.mensaje && dd.mensaje.mensaje && dd.mensaje.mensaje.includes("Se recalcularon los m3 desde")
                 && (dd.horas_reales || dd.subRiegoHoras )){

                    //Se recalcularon los m3 desde 147 m3, a 96.95184 m3. Habia una diferencia del 51.62%";
                    var modelStr = dd.mensaje.mensaje;
                    modelStr     = modelStr.split("m3").join("");
                    var numbers  = modelStr.match(/[+-]?\d+(?:\.\d+)?/g).map(Number);

                    var from         = _.round(numbers[0], 2);
                    var to           = _.round(numbers[1], 2);
                    var diff_percent = _.round(numbers[2], 2);
                    var from_hr, to_hr;

                    if(dd.horas_reales){
                      from_hr      = from / dd.horas_reales;
                      to_hr        = to   / dd.horas_reales;
                    }else if(dd.subRiegoHoras){
                      from_hr      = from / dd.subRiegoHoras;
                      to_hr        = to   / dd.subRiegoHoras;
                    }

                    dd.recalculo = {
                      from         : from,
                      from_hr      : from_hr,
                      to_hr        : to_hr,
                      to           : to,
                      diff_percent : diff_percent
                    }
                  }
       });



     };










     //TODO talves sea necesario hacer una version
     // light de este metodo, que actualice algunas cosas, no todas
    var regenerarSectorServer = function(sector) {
      sector.loading = true;
      var af = angular.copy(fechaTermino);

      return $http({
        url:urls.BASE+"/sector-riego/resumen",
        params:{
          fecha_inicio          : fechaInicio.format("DD-MM-YYYY"),
          fecha_fin             : af.add(1, "days").format("DD-MM-YYYY"),
          "sectores_riego_id[]" : [sector.id]
        }
      }).success(function(response){


        var promSensores = null;
        var promCalicata = null;

        if(true || vm.config.vinedo["has-sensor-en-planilla"]){

          promSensores = vm.getSectorSensor({
            fecha_inicio : fechaInicio.format("DD-MM-YYYY"),
            fecha_fin    : af.add(1, "days").format("DD-MM-YYYY"),
            sector_riego_id : sector.id
          }).$promise;

          promCalicata = vm.getSectorCalicata({
            fecha_inicio : fechaInicio.format("DD-MM-YYYY"),
            fecha_fin    : af.add(1, "days").format("DD-MM-YYYY"),
            sector_riego_id : sector.id
          }).$promise;

          Promise.all([promSensores, promCalicata]).then( function(res){
            var resSensores = res [0];
            var resCalicatas = res [1];

           //resSensores.data.sectores.forEach(function(sectorSensor){
             //var cuarteles = [];
             //resSensores.data.sector.sectores_riego.forEach(function(sectorRiego){
               var c = utils.getSectorById(vm.equipos, sector.id)
               if(c){
                 //console.log("regenerar sector "+sector.nombre+" asignado sectorSensor");
                 c.sectorSensor = resSensores.data.sector;
                 c.sectorCalicata = resCalicatas.data.sector;
                 //cuarteles.push(c);
               }

             //});
             //sectorSensor.cuarteles = cuarteles; // revisar
             //sectoresSensorOriginal.push(_.cloneDeep(sectorSensor));


              var sectorResponse = response.data.sector_riego[0];
              mergeSector(sector, sectorResponse);
              prepareSector(sector);
              sector.loading = false;

           });

          //});

        }else{
          var sectorResponse = response.data.sector_riego[0];
          mergeSector(sector, sectorResponse);
          prepareSector(sector);
          sector.loading = false;
        }


      });
    };





    var regenerarSectoresServer = function(sectores) {
      var af = angular.copy(fechaTermino);
      $http({
        url    : urls.BASE+"/sector-riego/resumen",
        params : {
          fecha_inicio          : fechaInicio.format("DD-MM-YYYY"),
          fecha_fin             : af.add(1, "days").format("DD-MM-YYYY"),
          "sectores_riego_id[]" : sectores
        }
      }).success(function(response){
        angular.forEach(response.data.sector_riego, function(sectorRes) {
          angular.forEach(vm.equipos, function(equipo) {
            angular.forEach(equipo.sector_riego, function(sector) {
              if (sector.id == sectorRes.id) {
                mergeSector(sector, sectorRes);
                prepareSector(sector);
                sector.loading = false;
              }
            });
          });
        });
      });
    };

    var mergeSector = function(sector, sectorNuevo) {

      //sector.diasFaltantes              = sectorNuevo.diasFaltantes;
      //sector.diasPR                     = sectorNuevo.diasPR;
      //sector.etc                        = sectorNuevo.etc;
      //sector.fechaPR                    = sectorNuevo.fechaPR;
      //sector.fecha_riego                = sectorNuevo.fecha_riego;
      //sector.kr                         = sectorNuevo.kr;
      //sector.rep                        = _.round(parseFloat(sectorNuevo.kr) * 100);
      //sector.prog                       = sectorNuevo.prog;

      sector.resumen      = sectorNuevo.resumen;
      sector.temporada    = sectorNuevo.estanque;
      sector.riego        = sectorNuevo.riego;
      sector.ultimo_riego = sectorNuevo.ultimo_riego;
      sector.kc           = sectorNuevo.kc;
      sector.estanque     = sectorNuevo.estanque;
      sector.proximo      = sectorNuevo.proximo;
      sector.mm_mai       = sectorNuevo.mm_mai;

      //sector.promedio_etb               = sectorNuevo.promedio_etb;
      //sector.promedio_et                = sectorNuevo.promedio_et;
      //sector.riego_normal_mm            = sectorNuevo.riego_normal_mm;
      //sector.riego_normal_hh            = sectorNuevo.riego_normal_hh;
      sector.sector_scholander_id       = sectorNuevo.sector_scholander_id;
      sector.sector_porometro_id        = sectorNuevo.sector_porometro_id;
      //sector.tipo_calculo_proximo_riego = sectorNuevo.tipo_calculo_proximo_riego;
      //sector.ultimo                     = sectorNuevo.ultimo;

      if (angular.isDefined(sector.ultimo_riego) ){
        if(angular.isDefined(sector.ultimo_riego.unix)) {
          sector.ultimo_riego.format = moment.unix(sector.ultimo_riego.unix).add(12,"hours").format("DD MMM");
        }else{
          sector.ultimo_riego.format = "--";
        }
      }else{
        sector.ultimo_riego = {
          format : "--"
        };
      }

      angular.forEach(sector.dias, function(dia) {
        var dia2              = getDiaSector(sectorNuevo, dia.unix);
        dia.aplicacion        = dia2.aplicacion;
        dia.hoy               = dia2.hoy;
        dia.regue             = dia2.regue;
        dia.riego             = dia2.riego;
        dia.scholander        = dia2.scholander;
        dia.porometro         = dia2.porometro;
        dia.horas_reales      = dia2.horas_reales;
        dia.mm_programadas    = dia2.mm_programadas; //backend typo
        dia.horas_programadas = dia2.horas_programadas;
        dia.mm_reales         = dia2.mm_reales ;
        dia.volumen_real      = dia2.volumen_real;
        dia.volumen           = dia2.volumen;
        dia.gramaje           = dia2.gramaje;
        dia.calibre           = dia2.calibre;


        if(dia2.sub_riegos !== undefined){
          dia.sub_riegos = dia2.sub_riegos;
        }



        if(dia2.delta_mai !== undefined){
          dia.delta_mai = dia2.delta_mai;
        }
        if(dia2.humedad_mai!== undefined){
          dia.humedad_mai= dia2.humedad_mai;
        }
        if(dia2.temperatura_mai !== undefined){
          dia.temperatura_mai = dia2.temperatura_mai;
        }



      });

       if(sector.diasData === undefined){
         sector.diasData = [];
       }else{
         sector.diasData.splice(0, sector.diasData.length);
       }
       angular.forEach(sector.dias, function(dia) {
         if (utils.diaHasData(dia, sector)) {
           dia.position = utils.unixToPosition(fechaInicio, dia.unix, r);
           sector.diasData.push(dia);
         }
       });
    };





    var mergeDays= function(dde, dor, haciaAtras){
      var inArray     = false;
      var daysDestiny = angular.copy(dde);
      var daysOrigin  = angular.copy(dor);
      if(haciaAtras){
        daysOrigin.reverse();
      }
      angular.forEach(daysOrigin, function(dayOr){
        inArray = false;
        angular.forEach(daysDestiny, function(daydes) {
          if(daydes.unix == dayOr.unix){
            inArray = true;
            //console.log("found "+dayOr.unix+" "+ dayOr.fecha);
            _.merge(daydes, dayOr);
          }
        });
        if(!inArray){
          if(haciaAtras){
            daysDestiny.unshift(dayOr);
          }else{
            daysDestiny.push(dayOr);
          }
          //console.log("push "+dayOr.unix+" "+ dayOr.fecha);
        }else{
          //console.log("inArray "+dayOr.unix+" "+ dayOr.fecha);
        }
      });
      return daysDestiny;
    }



    var concatCuarteles  = function(equipoN, equipo, sector, haciaAtras) {
      if(equipoN.id == equipo.id){
        angular.forEach(equipoN.sector_riego, function(sectorN){
          if(sectorN.id == sector.id){
            sector.dias = mergeDays(sector.dias, sectorN.dias, haciaAtras);
            if (sectorN.estados == undefined) {
              sectorN.estados = sector.estados;
            }
          }
        });
      }
    };



    //TODO: verficar y comparar con utils.getDayFromSector
    var getDiaSector = function(sector, unix) {
      var diaRetorno = null;
      var mu = moment.unix(unix).add(12, "hours");
      angular.forEach(sector.dias, function(dia) {
        var m = moment.unix(dia.unix).add(12,"hours");
        if (m.isSame(mu, "day")) {
          diaRetorno = dia;
        }
      });
      return diaRetorno;
    };



    vm.getMoreDays = function(haciaAtras){
      var t0              = performance.now();
      var cantidadSemanas = 1;
      var fFin            = null;
      var fInicio         = null;
      vm.generalLoading   = true;

      if(haciaAtras){
        vm.loadBack = true;
        fFin        = fechaInicio.add(3,"days").format("DD-MM-YYYY");
        fInicio     = fechaInicio.subtract(cantidadSemanas * 7,"days").format("DD-MM-YYYY");
        //$tlc.scrollLeft($(".hoy").parent().parent().position().left - 150);
        $tlc.scrollLeft(0);
      }else{
        vm.loadForward = true;
        fInicio        = fechaTermino.subtract(3,"days").format("DD-MM-YYYY");
        fFin           = fechaTermino.add(cantidadSemanas * 7 -1,"days").format("DD-MM-YYYY");
        $tlc.scrollLeft($tlc[0].scrollWidth);
      }

      getPrediccion({
        fecha_fin    : fFin,
        fecha_inicio : fInicio
      }).then(function(resPrediccion){
        var data = resPrediccion[0]
        var resSensores = resPrediccion[1];
        var t1 = performance.now(); //para calculo de performance de carga de timeline


        // --- sensores ---
        var sectoresSensorOriginal = [];
        //vm.sectoresSensor = [];
        if(resSensores){
          resSensores.data.sectores.forEach(function(sectorSensor){
            var cuarteles = [];
            sectorSensor.sectores_riego.forEach(function(sectorRiego){
              var c = utils.getSectorById(vm.equipos, sectorRiego.id)
              if(c){
                //c.sectorSensor = sectorSensor;
                //console.log("get more days sector "+c.nombre+" asignado sectorSensor")
                var s = utils.mergeSectorSensorData(c.sectorSensor, sectorSensor);
                console.dir(s);
                c.sectorSensor = s;
                cuarteles.push(c);
              }
            });
            sectorSensor.cuarteles = cuarteles; // revisar
            sectoresSensorOriginal.push(_.cloneDeep(sectorSensor));
          });
          //vm.sectoresSensor = sectoresSensorOriginal;
        }



        angular.forEach(vm.equipos, function(equipo){
          angular.forEach(equipo.sector_riego, function(cuartel){

            if (angular.isDefined(data.data.vinedo)) {
              angular.forEach(data.data.vinedo.equipos, function(equipoN){
                concatCuarteles(equipoN, equipo, cuartel, haciaAtras);
              });
            }
            if (angular.isDefined(data.data.equipo)) {
              concatCuarteles(data.data.equipo, equipo, cuartel, haciaAtras);
            }

          });
        });

        //concatena et_semanales si es peticion de vinedo
        if (angular.isDefined(data.data.vinedo)) {
          if (haciaAtras) {
            et_semanales     = data.data.vinedo.et_semanales.concat(et_semanales);
            temperaturasHora = data.temperaturaHora.concat(temperaturasHora);
          }else{
            et_semanales     = et_semanales.concat(data.data.vinedo.et_semanales);
            temperaturasHora = temperaturasHora.concat(data.temperaturaHora);
          }
        }

        //concatena et_semanales si es peticion de equipo
        //deprecated
        /*
        if (angular.isDefined(data.data.equipo)) {
          if (haciaAtras) {
            et_semanales = data.data.equipo.et_semanales.concat(et_semanales);
          }else{
            et_semanales = et_semanales.concat(data.data.equipo.et_semanales);
          }
        }
        */

        var unix_fecha_inicio = vm.equipos[0].sector_riego[0].dias[0].unix;
        var length_days       = vm.equipos[0].sector_riego[0].dias.length;
        var unix_fecha_fin    = vm.equipos[0].sector_riego[0].dias[length_days-1].unix;
        fechaInicio           = moment.unix(unix_fecha_inicio).add(5, "hours");
        fechaTermino          = moment.unix(unix_fecha_fin).add(6, "hours");
        diffDays              = fechaTermino.diff(fechaInicio, 'days');
        vm.lastPosition       = diffDays * r;
        vm.diasHeader         = utils.getDiasHeader(vm.equipos, et_semanales);
        vm.diasMesHeader      = utils.getDiasMesHeader(vm.equipos, et_semanales);
         if(vm.config.vinedo.oidio){
           vm.diasMesHeader = utils.addOidio(vm.diasMesHeader, temperaturasHora);
         }
        vm.diasPrecip         = utils.getDiasPrecip(vm.equipos, et_semanales, fechaInicio, r);
        vm.loadBack           = false;
        vm.loadForward        = false;
        vm.generalLoading     = false;
        vm.calcularEspacioProgramacion();
        vm.addTodayLine();

        angular.forEach(vm.equipos, function(equipo){
          angular.forEach(equipo.sector_riego, function(cuartel){
            prepareSector(cuartel);
          });
        });

        //imprime el performance
        var t2 = performance.now();

        drawBoard({
          width: diffDays * r + r,
          height: calcularTotalSectores() * r,
          square:{
            width: r,
            height: r
          }
        });

      });
    }; // END getMoreDays()















    //-- Sidebar

    vm.ocultarSidebarRight = function() {
      vm.visibleSidebarRight = false;
    }

    vm.mostrarSidebarRight = function() {
      vm.visibleSidebarRight = true;
    }

    vm.toggleSidebarRight = function() {
      if (vm.visibleSidebarRight) {
        vm.ocultarSidebarRight();
      }else{
        vm.mostrarSidebarRight();
      }
      vm.positionArrow();
    }

    vm.ocultarDetalles = function() {
      vm.visibleSidebarDetails = false;
    }

    vm.mostrarDetalles = function() {
      vm.visibleSidebarDetails = true;
    }

    vm.toggleSidebarExtended = function() {
      if (vm.visibleSidebarDetails) {
        vm.ocultarDetalles();
      }else{
        vm.mostrarDetalles();
      }
      vm.positionArrow();
    }
    //-- END Sidebar







    vm.tlMouseOver = function(ev) {
      var position   = vm.eventToPosition(ev);
      var sector     = utils.positionToSector(vm.equipos, position.top);
      var dia_moment = utils.positionToMoment(fechaInicio, position.left);
      var dia        = null;
      if (sector === null || dia_moment === null) {
        vm.diaHover      = null;
        vm.sectorHover   = null;
        position.left    = 0;
        position.display = "none";
        $hoverCursor.css(position);
        $dayDetail.css(position);
      }else{
        dia = utils.getDayFromSector(sector, dia_moment);
        if(dia === null){
          vm.diaHover      = null;
          vm.sectorHover   = null;
          position.left    = 0;
          position.display = "none";
          $hoverCursor.css(position);
          $dayDetail.css(position);
        }else{
          position.left   += parseInt($tlc.css("padding-left"));//correccion de position
          position.display = "block";
          $hoverCursor.css(position);
          if (dia != null && utils.diaHasData(dia, sector)) {
            prepararDiaMouseOver(sector, dia)
            $dayDetail.css(position);
          }else{
            $dayDetail.css({display:"none"});
          }
          vm.diaHover = dia;
          vm.sectorHover = sector;
        }
      }
    }


    function prepararDiaMouseOver (sector, dia) {
      if (dia.horas_programadas) {
        var mHora = floatToDuration(dia.horas_programadas);
        dia.hProgramado  = utils.durationToHour(mHora);
      }else{
        dia.hProgramado = null;
      }

      dia.elementos = [];
      if(dia.aplicacion){
        _.forEach(dia.aplicacion, function(apl){
          apl.elementos = getElementsByProductName(apl.producto_nombre, null, apl.cantidad)
        });

        dia.elementos = _.flatMap(dia.aplicacion, function(apl){
          return apl.elementos;
        });

        /*
          //para testing de elementos repetidos
      dia.elementos.push({
        nombre: "falso",
        simbologia: "fa",
        real: 2
      });

      dia.elementos.push({
        nombre: "falso",
        simbologia: "fa",
        real: 2
      });
      */

        //junta los elementos iguales
        dia.elementos =  _(dia.elementos)
          .groupBy('simbologia')
          .map((objs, key) => {
            var newEl = objs[0] || {};
            newEl.real = _.sumBy(objs, 'real');
            return newEl;
          })
          .value();
        //elementos por ha
        dia.elementos =  _.map(dia.elementos, function(el){
          el.real_ha = _.round(el.real / sector.ha, 2);
          return el;
        });

      }
      if(dia.riego && (dia.mm_reales === 0 || angular.isUndefined(dia.mm_reales))){
        dia.horas_sug = sector.proximo.horas;
        dia.riego_sug_mm = sector.proximo.mm;
      }else{
        delete dia.horas_sug;
        delete dia.riego_sug_mm;
      }
    }

    function floatToDuration(num){
      var h = _.round(num, 0);
      var m = _.round((num - h)*60, 0);
      var mHora = moment.duration(h, "hours");
      mHora.add(m, "minutes");
      return mHora;
    }




    vm.eventToPosition = function(ev) {
      var target = $(ev.currentTarget);
      var t = parseInt(target.css("padding-left")) + parseInt(target.offset().left);
      var a = ev.clientX + target.scrollLeft() - t;
      //a = a >= 0 ? a : 0;
      var left = a - Math.abs(a%r);

      var y = parseInt(target.css("padding-top")) + parseInt(target.offset().top);
      var b = ev.clientY + target.scrollTop() - y;
      //b = b >= 0 ? b : 0;
      var top = b - Math.abs(b%r);

      var position = {
        left:left,
        top:top,
        real:{
          left:a,
          top:b
        }
      }
      return position;
    }






    vm.showListBottomSheet = function () {
      $mdBottomSheet.show({
        templateUrl : 'components/vinedo/newtimeline/bottomSheet/bottom-sheet-add-mobile.html',
        controller  : 'ListBottomSheetCtrl',
        controllerAs: 'lb'
      }).then(function (clickedItem, ev) {
        vm.enableMobileSelection(clickedItem);

        if(vm.mobileEditableType.tag === 'riego'){
          selectionToolbar.showToolbar({
            text: vm.diasSeleccionados.length,
            options:[
              {
                textButton: 'Agregar Riego',
                ariaLabel: "riego",
                onClick: function(ev){
                  //vm.cancelarMultiInputMobile();
                  showDialogMIRiegoReal();
                }
              },
              {
                icon: 'message', //sacado de material icons
                ariaLabel: "agregar mensaje",
                onClick: function(ev){
                  //TODO ventana para agregar mensaje
                  alert("mensaje");
                }
              }],
            backFn : function () {
              vm.cancelarMultiInputMobile();
            }
          });
        }
        if(vm.mobileEditableType.tag === 'scholander'){
          selectionToolbar.showToolbar({
            text: vm.diasSeleccionados.length,
            options:[
              {
                textButton: 'Agregar Scholander',
                ariaLabel: "scholander",
                onClick: function(ev){
                  showDialogMIScholander();
                }
              },
              {
                icon: 'message', //sacado de material icons
                ariaLabel: "agregar mensaje",
                onClick: function(ev){
                  alert("mensaje");
                }
              }],
            backFn : function () {
              vm.cancelarMultiInputMobile();
            }
          });
        }
        if(vm.mobileEditableType.tag === 'cancelar'){
          vm.cancelarMultiInputMobile();
        }

      }).catch(function (error) {
        console.error(error);
      });
    };


    vm.enableMobileSelection = function(clickedItem) {
      vm.mobileEditableMode = true;
      vm.mobileEditableType = clickedItem;
    };

    vm.disableMobileSelection = function() {
      vm.cancelarMultiInputMobile();
    };

    vm.cancelarMultiInputMobile = function(){
      vm.mobileEditableMode = false;
      vm.mobileEditableType = null;
      limpiarMultiInput();
      selectionToolbar.clearOptions();
      selectionToolbar.hideToolbar();
    };

    function showDialogMIRiegoReal(ev) {
      var promMI = dialogMultiInput.show(ev, {
        title           : "Agregar Riego Real",
        type            : 'riego',
        metric          : 'horas',
        conCaudalimetro : true
      });
      promMI.then(function(res){
        if(res.milimetros !== undefined){
          vm.MImm   = res.milimetros;
        }
        if(res.horas !== undefined || res.minutos !== undefined){
          vm.MIHora = res.horas;
          vm.MIMin  = res.minutos;
        }
        vm.guardarMultiInput();
        vm.cancelarMultiInputMobile();
      });
      return promMI;
    }


    function showDialogMIScholander(ev) {
      var promMI = dialogMultiInput.show(ev, {
        title  : "Agregar Scholander",
        type   : 'scholander'
      });
      promMI.then(function(res){
        if(res.scholander !== undefined){
          vm.newScholander = res.scholander ;
        }
        vm.guardarMultiInputScholander();
        selectionToolbar.clearOptions();
        selectionToolbar.hideToolbar();
      });
      return promMI;
    }






    vm.selectDay = function(ev) {

      if(vm.isMobile && !vm.mobileEditableMode || !vm.editable){
        return;
      }

      var position   = vm.eventToPosition(ev);
      var momentDate = utils.positionToMoment(fechaInicio, position.left);
      var sector     = utils.positionToSector(vm.equipos, position.top);
      if (sector == null || momentDate === null) {
        return;
      }
      var dia = utils.getDayFromSector(sector,momentDate);
      if (dia === null) {
        return;
      }
      var sm  = {
        moment         : momentDate,
        sector         : sector,
        equipo         : vm.getEquipoBySector(sector),
        dia            : dia,
        position       : position,
        positionOffset : {
          left : position.left, // + parseInt($tlc.css("padding-left")),
          top  : position.top + topOffset
        }
      }
      var selectedPosition    = vm.isSelected(sm);
      var cuartelesScholander = getSectorScholanderBySector(sector);
      var cuartelesPorometro  = getSectorPorometroBySector(sector);
      var cuartelesSectorSensor = getSectorSensorBySector(sector, momentDate);
      var cuartelesCalicata = getSectorCalicataBySector(sector, momentDate); //XXX

      sm.sectorScholander = null;
      sm.sectorPorometro = null;

      if(cuartelesScholander.sectorScholander !== null){
        sm.sectorScholander = cuartelesScholander.sectorScholander.id;
      }
      if(cuartelesPorometro.sectorPorometro !== null){
        sm.sectorPorometro = cuartelesPorometro.sectorPorometro;
      }
      if(cuartelesSectorSensor.sectorSensor !== null){
        sm.sectorSensor = cuartelesSectorSensor.sectorSensor;
      }
      if(cuartelesCalicata.sectorCalicata !== null){
        sm.sectorCalicata = cuartelesCalicata.sectorCalicata ; //XXX
      }

      if ( selectedPosition === -1) { // si no esta seleccionado

        if (vm.selectedTab === vm.cons.TAB_SCHOLANDER ) {
          angular.forEach(cuartelesScholander.cuarteles, function(cuartelSch) {
            if(cuartelSch !== null){
              var cd                = angular.copy(sm);
              cd.sector             = cuartelSch;
              cd.sectorScholander   = cuartelesScholander.sectorScholander.id;
              cd.position.top       = utils.sectorToPosition(vm.equipos, cuartelSch);
              cd.positionOffset.top = utils.sectorToPosition(vm.equipos, cuartelSch) + topOffset;
              if (cd.sector.id !== sector.id) {
                vm.diasSeleccionados.push(cd);
              }
            }
          });
          if (cuartelesScholander.cuarteles.length === 0) {
            $mdToast.show(
              $mdToast.simple()
              .content("Sector de Riego sin Sector Scholander")
              .position(CONSTANTES.TOAST_POSITION)
              .hideDelay(3000)
            );
          }
        }

      //agrega los sectores de riego que comparten el sector porometro (calicata)
        if (vm.selectedTab === vm.cons.TAB_POROMETRIA ) {
          //console.log("cuartelesPorometro");
          //console.dir(cuartelesPorometro);
          angular.forEach(cuartelesPorometro.cuarteles, function(cuartelPor) {
            var cd                = angular.copy(sm);
            cd.sector             = cuartelPor;
            cd.sectorPorometro    = cuartelesPorometro.sectorPorometro;
            cd.position.top       = utils.sectorToPosition(vm.equipos, cuartelPor);
            cd.positionOffset.top = utils.sectorToPosition(vm.equipos, cuartelPor) + topOffset;
            if (cd.sector.id !== sector.id) {
              vm.diasSeleccionados.push(cd);
            }
          });
          if (cuartelesPorometro.cuarteles.length === 0) {
            $mdToast.show(
                $mdToast.simple()
                    .content("Sector de Riego sin Sector Calicata") //porometro
                    .position(CONSTANTES.TOAST_POSITION)
                    .hideDelay(3000)
            );
          }
        }





        if (vm.selectedTab === vm.cons.TAB_CALICATA) {
          angular.forEach(cuartelesCalicata.cuarteles, function(cuartelCalicata) {
            var cd                = angular.copy(sm);
            cd.sector             = cuartelCalicata;
            cd.sectorCalicata     = cuartelesCalicata.sectorCalicata; //XXX
            cd.position.top       = utils.sectorToPosition(vm.equipos, cuartelCalicata);
            cd.positionOffset.top = utils.sectorToPosition(vm.equipos, cuartelCalicata) + topOffset;
            if (cd.sector.id !== sector.id) {
              vm.diasSeleccionados.push(cd);
            }
          });
          if (cuartelesCalicata.cuarteles.length === 0) {
            $mdToast.show(
                $mdToast.simple()
                    .content("Sector de Riego sin Sector Calicata") //porometro
                    .position(CONSTANTES.TOAST_POSITION)
                    .hideDelay(3000)
            );
          }
        }


        if (vm.selectedTab === vm.cons.TAB_SENSOR) {
          angular.forEach(cuartelesSectorSensor.cuarteles, function(cuartelSensor) {
            var cd                = angular.copy(sm);
            cd.sector             = cuartelSensor;
            cd.sectorSensor       = cuartelesSectorSensor.sectorSensor;
            cd.position.top       = utils.sectorToPosition(vm.equipos, cuartelSensor);
            cd.positionOffset.top = utils.sectorToPosition(vm.equipos, cuartelSensor) + topOffset;
            if (cd.sector.id !== sector.id) {
              vm.diasSeleccionados.push(cd);
            }
          });
          if (cuartelesSectorSensor.cuarteles.length === 0) {
            $mdToast.show(
                $mdToast.simple()
                    .content("Sector de Riego sin Sector sensor") //porometro
                    .position(CONSTANTES.TOAST_POSITION)
                    .hideDelay(3000)
            );
          }
        }




        if (vm.diasSeleccionados.length === 0){
          if(angular.isDefined(dia.mensaje.mensaje)){
            vm.mensajeInput = dia.mensaje.mensaje;
          }else{
            vm.mensajeInput = "";
          }
          vm.mensajeInputDirty = false;
        }

        vm.diasSeleccionados.push(sm);

      }else{ //Deselecciona

        if (vm.selectedTab == vm.cons.TAB_SCHOLANDER ) {
          angular.forEach(cuartelesScholander.cuarteles, function(cuartelSch) {
            var cd = getCuartelDia(cuartelSch, dia.unix)
            cd.sectorScholander = cuartelesScholander.sectorScholander;
            var j = vm.isSelected({
              sector: cuartelSch,
              moment: momentDate
            });
            if (j > -1) {
              vm.diasSeleccionados.splice(j, 1);
            }
          });
        }

        if (vm.selectedTab == vm.cons.TAB_POROMETRIA) {
          angular.forEach(cuartelesPorometro.cuarteles, function(cuartelPor) {
            var cd = getCuartelDia(cuartelPor, dia.unix)
            cd.sectorPorometro = cuartelesPorometro.sectorPorometro;
            var j = vm.isSelected({
              sector: cuartelPor,
              moment: momentDate
            });
            if (j > -1) {
              vm.diasSeleccionados.splice(j, 1);
            }
          });
        }


        if (vm.selectedTab == vm.cons.TAB_CALICATA) {
          angular.forEach(cuartelesCalicata.cuarteles, function(cuartelCalicata) {
            var cd = getCuartelDia(cuartelCalicata, dia.unix)
            cd.sectorCalicata = cuartelesCalicata.sectorCalicata;
            var j = vm.isSelected({
              sector: cuartelCalicata,
              moment: momentDate
            });
            if (j > -1) {
              vm.diasSeleccionados.splice(j, 1);
            }
          });
        }

        if (vm.selectedTab == vm.cons.TAB_SENSOR) {
          angular.forEach(cuartelesSectorSensor.cuarteles, function(cuartelSensor) {
            var cd = getCuartelDia(cuartelSensor, dia.unix)
            cd.sectorSensor = cuartelesSectorSensor.sectorSensor;
            var j = vm.isSelected({
              sector: cuartelSensor,
              moment: momentDate
            });
            if (j > -1) {
              vm.diasSeleccionados.splice(j, 1);
            }
          });
        }

        vm.diasSeleccionados.splice(selectedPosition, 1);
      }


      if(vm.isMobile){ // IF mobile
          selectionToolbar.setTextToolbar(vm.diasSeleccionados.length);
      }else{ //IF no mobile
        if (vm.diasSeleccionados.length > 0) {
          vm.mostrarSidebarRight();
        }else{
          vm.ocultarSidebarRight();
        }

        //setea las variables de sidebar right
        var mhora = null;
        if (vm.selectedTab === vm.cons.TAB_RIEGO && vm.diasSeleccionados.length === 1 && selectedPosition === -1){
          vm.MIVol = sm.dia.volumen;
          vm.MImm = sm.dia.mm_reales ;
          if (vm.usaMM) {
            if(sm.dia.hasSubriego){
              vm.MImm = sm.dia.subRiegoMM;
              vm.MIVol = sm.dia.subRiegoVol;
            }
          }else{
            if(sm.dia.hasSubriego){
              //mhora = moment.duration(parseFloat(sm.dia.subRiegoHoras), "hours");
              mhora = floatToDuration(parseFloat(sm.dia.subRiegoHoras));
              vm.MIVol = sm.dia.subRiegoVol;
            }else{
              //mhora = moment.duration(parseFloat(sm.dia.horas_reales), "hours");
              mhora = floatToDuration(parseFloat(sm.dia.horas_reales));
            }
            vm.MIHora = Math.floor(mhora.asHours());
            vm.MIMin = Math.floor(mhora.minutes());
          }



          if(sm.dia.aplicacion){
            vm.conFertilizacion = true;
            _.forEach(sm.dia.aplicacion, function(apl){
              _.forEach(vm.fertInputProductos, function(pro){
                //TODO debe ser comparacion por id
                if(pro.nombre == apl.producto_nombre &&
                  pro.abreviacion == apl.producto_abr){
                    if(apl.tipo_aplicacion == 3){
                      pro.value = apl.concentracion;
                      vm.litrosFertiriego = apl.litros;
                    }else if(apl.tipo_aplicacion == 2){
                      pro.value = apl.cantidad / sm.sector.ha;
                    }else{
                      pro.value = apl.cantidad;
                    }
                    vm.tipoFertilizacionSelected = _.find(vm.tiposFertilizacion, {id: apl.tipo_aplicacion});
                  }
                });
              });
            }else{
              vm.conFertilizacion = false;
            }


          }

        if (vm.selectedTab === vm.cons.TAB_PROGRAMACION && vm.diasSeleccionados.length === 1 && selectedPosition === -1){
          //mhora = moment.duration(parseFloat(sm.dia.horas_programadas), "hours");
          mhora = floatToDuration(parseFloat(sm.dia.horas_programadas));
          vm.hrsProgramado = Math.floor(mhora.asHours());
          vm.minProgramado = Math.floor(mhora.minutes());
          vm.mmProgramado = sm.dia.mm_programadas;
        }

        if (vm.selectedTab === vm.cons.TAB_SCHOLANDER && vm.diasSeleccionados.length === 1 && selectedPosition === -1){
          vm.newScholander = dia.scholander;

          if (dia.humedad_mai) {
            vm.inputHumedadRiego = dia.humedad_mai;
          }

          if (dia.temperatura_mai) {
            vm.inputTempRiego = dia.temperatura_mai;
          }

        }

        if (vm.selectedTab === vm.cons.TAB_POROMETRIA && vm.diasSeleccionados.length === 1 && selectedPosition === -1){
          vm.newScholander = dia.porometro;
        }

        /*
         if (vm.selectedTab === vm.cons.TAB_SENSOR && vm.diasSeleccionados.length === 1 && selectedPosition === -1){
          vm.profundidadesInput = dia.sectorSensor.profundidades;
        }
        */

        if (vm.selectedTab === vm.cons.TAB_CRECIMIENTO && vm.diasSeleccionados.length === 1 && selectedPosition === -1){
          if(dia.gramaje > 0){
            vm.newGramos = dia.gramaje;
          }
          if(dia.calibre > 0){
            vm.newCalibre = dia.calibre;
          }
        }



        if (vm.selectedTab === vm.cons.TAB_PROGRAMACION &&
            vm.diasSeleccionados.length > 0 &&
            selectedPosition === -1){
          focus("inputHorasProgramacion");
        }

        if (vm.selectedTab === vm.cons.TAB_SCHOLANDER &&
            vm.diasSeleccionados.length > 0 &&
            selectedPosition === -1){
          focus("inputNewScholander");
        }

        if (vm.selectedTab === vm.cons.TAB_POROMETRIA &&
            vm.diasSeleccionados.length > 0 &&
            selectedPosition === -1){
          focus("inputNewPorometro");
        }


        if (vm.selectedTab === vm.cons.TAB_CALICATA&&
            vm.diasSeleccionados.length > 0 &&
            selectedPosition === -1){
          focus("inputNewCalicatas");
        }

        if (vm.selectedTab === vm.cons.TAB_SENSOR &&
            vm.diasSeleccionados.length > 0 &&
            selectedPosition === -1){
          focus("inputNewSensores");
        }




        if (vm.selectedTab === vm.cons.TAB_RIEGO &&
            vm.diasSeleccionados.length > 0 &&
            selectedPosition === -1){
          if (vm.usaMM) {
            focus("inputMMRiego");
          }else{
            focus("inputHorasRiegoDia");
          }
        }
      } //END no if mobile



      el.scrollLeft(0);
        $timeout(function(){
          el.scrollLeft(0);
        }, 50);


    };








    var getCuartelDia =  function(cuartelId, unix){
      var cuartelSelected = null;
      var diaSelected = null;
      angular.forEach(vm.equipos, function(equipo){
        angular.forEach(equipo.sector_riego, function(cuartel){
          if(cuartel.id == cuartelId){
            cuartelSelected = cuartel;
            angular.forEach(cuartel.dias, function(dia){
              if(dia.unix == unix){
                diaSelected = dia;
              }
            });
          }
        });
      });
      return {cuartel: cuartelSelected, dia: diaSelected};
    };



    function getSectorPorometroBySector(cuartel) {
      var cuarteles                   = [];
      var cuartelesIds                = [];
      var sectorPorometroSeleccionado = null;
      angular.forEach(vm.sectoresPorometro , function(sectorPor) {
        angular.forEach(sectorPor.cuarteles, function(cuartelPor) {
          if(cuartel.id == cuartelPor){
            cuartelesIds = sectorPor.cuarteles;
            _.each(sectorPor.cuarteles, function(cuartelId){
              cuarteles.push(utils.getSectorById(vm.equipos, cuartelId));
            });
            sectorPorometroSeleccionado = sectorPor;
          }
        })
      });
      return {
                cuarteles        : cuarteles,
                cuartelesIds     : cuartelesIds,
                sectorPorometro :sectorPorometroSeleccionado
            };
    }


    function getSectorScholanderBySector(cuartel) {
      var cuartelesSeleccionados       = [];
      var cuarteles                    = [];
      var cuartelesIds                 = [];
      var sectorScholanderSeleccionado = null;
      angular.forEach(vm.sectoresScholander, function(sectorSch) {
        angular.forEach(sectorSch.cuarteles, function(cuartelSch) {
          if(cuartel.id == cuartelSch){
            cuartelesIds = sectorSch.cuarteles;
            _.each(sectorSch.cuarteles, function(cuartelId){
              cuarteles.push(utils.getSectorById(vm.equipos, cuartelId));
            });
            sectorScholanderSeleccionado = sectorSch;
          }
        })
      });
      return {
                cuarteles        : cuarteles,
                cuartelesIds     : cuartelesIds,
                sectorScholander : sectorScholanderSeleccionado
            };
    }


    vm.isSelected = function(sm){
      var isSelected = -1;
      angular.forEach(vm.diasSeleccionados, function(sms, index) {
        if (sms.sector.id == sm.sector.id && sms.moment.isSame(sm.moment)) {
          isSelected = index;
        }
      });
      return isSelected;
    }





    var fixedTable = function() {
      $tlc.scroll(function() {
        $sidebar.css('transform', "translateY(-"+ $($tlc).scrollTop()+"px)");
        $sidebarExtended.css('transform', "translateY(-"+ $($tlc).scrollTop()+"px)");
        //$sidebarRight.css('margin-top', "-"+ $($tlc).scrollTop()+"px");

        $header.css('transform', "translateX(-"+ $($tlc).scrollLeft()+"px)");
        $header.find(".before").css('transform', "translateX("+ $($tlc).scrollLeft()+"px)");
        $header.find(".after").css('transform', "translateX("+ $($tlc).scrollLeft()+"px)");
        //$headerRight.css('transform', "translateY("+ $($tlc).scrollTop()+"px)");
      });
    };

    fixedTable();


    vm.showHeaderInputs = function() {
      vm.showedHeaderInputs = true;
    }

    vm.hideHeaderInputs = function() {
      vm.showedHeaderInputs = false;
    }

    vm.toggleHeaderInputs = function() {
      if (vm.showedHeaderInputs) {
        vm.hideHeaderInputs();
      }else{
        vm.showHeaderInputs();
      }
      calcularPosicionToggleSidebarButton();
    }






    vm.showSelectDate = function() {
      vm.showPopoverDate = true;
      vm.showBackdrop(function() {
        vm.showPopoverDate = false;
      });
    };

    vm.cancelSelectDate = function() {
      vm.showPopoverDate = false;
    };


    vm.dateSelected = new Date(); //new moment().set('minute', 0).set('second', 0).toDate();
    vm.weekSelected = ""; //new moment().set('minute', 0).set('second', 0).toDate();

    vm.dateToToday = function() {
      vm.dateSelected = new Date(); // new moment().set('minute', 0).set('second', 0).toDate();
    };

    vm.dateToToday();

    vm.changeDateSelected = function(o, n) {
        if(o == n) return false;;
        vm.hideBackdrop();
        var inicioSemana  = moment(vm.dateSelected).startOf('isoWeek');
        fechaInicio       = _.cloneDeep(inicioSemana).subtract(2, "weeks");
        fechaTermino      = _.cloneDeep(inicioSemana).add(1, "month");
        vm.generalLoading = true;
        vm.init();
    };

    vm.changeWeekSelected = function(){
      if (vm.weekSelected) {
        vm.hideBackdrop();
        var inicioSemana = moment(vm.weekSelected).startOf('isoWeek');
        fechaInicio = _.cloneDeep(inicioSemana);
        fechaTermino = _.cloneDeep(inicioSemana).add(1.5, "month");
        vm.generalLoading = true;
        vm.init();
      }
    }

    $scope.$watch(function() {
      return vm.dateSelected;
    }, vm.changeDateSelected);


    vm.openMenu = function($mdOpenMenu, ev) {
      //originatorEv = ev;
      $mdOpenMenu(ev);
    };


    vm.showBackdrop = function(fn) {
      if (fn !== undefined && fn !== null) {
        hideBackdropCallback = fn;
      }
      vm.showedBackdrop = true;
    }

    vm.hideBackdrop = function() {
      if (hideBackdropCallback !== null) {
        hideBackdropCallback();
        hideBackdropCallback = null;
      }
      vm.showedBackdrop = false;
    }












    //--------------------------------------------------------
    //--------------------------------------------------------
    //    Subida de archivos
    //--------------------------------------------------------
    //--------------------------------------------------------


    vm.showDialogSensorNetafim = function(evt) {
      $mdDialog.show({
            templateUrl         : 'components/vinedo/sensores/sensor_netafim.dialog.html',
            parent              : angular.element(document.body),
            targetEvent         : evt,
            clickOutsideToClose : true,
            controllerAs        : "d",
            bindToController    : true,
            locals              : {
              sectoresSensor: vm.sectoresSensor,
              subirXlsSensorNetafim: vm.subirXlsSensorNetafim
            },
            controller : ["$scope", function($scope) {
              var vm = this;
              vm.loading = false;

              function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function filterFn(sectorsensor) {
                  return (angular.lowercase(sectorsensor.nombre).indexOf(lowercaseQuery) >= 0);
                };
              }

              vm.querySearch = function(query) {
                var r = query ? vm.sectoresSensor.filter( createFilterFor(query) ) : vm.sectoresSensor
                r.push({
                  nombre: query,
                  new: true
                });
                return r;
              }

              vm.hide = function() {
                $mdDialog.hide();
              };
              vm.cancel = function() {
                $mdDialog.cancel();
              };
              vm.answer = function(answer) {
                $mdDialog.hide(answer);
              };
              vm.subirXlsSensores = function(file, query) {
                vm.loading = true;
                vm.subirXlsSensorNetafim(file, {

                  nombre_sector: query,
                  vinedo_id: $stateParams.id
                }).then(function(res) {
                  vm.loading = false;
                  vm.answer("ready");
                  $mdToast.show(
                      $mdToast.simple()
                          .textContent(res.data.msj)
                          .position(CONSTANTES.TOAST_POSITION)
                  );
                }, function(err) {
                  vm.loading = false;
                });
              }
            }],
          })
          .then(function(answer) {

          }, function() {

          });
    }

    vm.subirXlsSensorNetafim = function (file, data) {
      if (file !== null) {
        vm.xlsSensorNetafimLoading = true;
        vm.uploading = true;
      }
      var prom = tlFac.upload.netafim.sensor(file,data);
      if(prom !== null){
        prom.then(function(){
          vm.xlsSensorNetafimLoading = false;
          vm.uploading = false;
        }, function(){
          vm.xlsSensorNetafimLoading = false;
          vm.uploading = false;
        });
      }
      return prom;
    };













    vm.showDialogProgramadorNetafim = function(evt) {
      $mdDialog.show({
            templateUrl         : 'components/vinedo/sensores/programador_netafim.dialog.html',
            parent              : angular.element(document.body),
            targetEvent         : evt,
            clickOutsideToClose : true,
            controllerAs        : "d",
            bindToController    : true,
            locals              : {
              //sectoresSensor: vm.sectoresSensor,
              equipos: vm.equipos,
              subirXlsProgramadorNetafim: vm.subirXlsProgramadorNetafim
            },
            controller : ["$scope", function($scope) {
              var vm = this;
              vm.equipoSelected = null;
              vm.loading = false;

              vm.hide = function() {
                $mdDialog.hide();
              };
              vm.cancel = function() {
                $mdDialog.cancel();
              };
              vm.answer = function(answer) {
                $mdDialog.hide(answer);
              };
              vm.subirXls = function(file, query) {
                vm.loading = true;
                vm.subirXlsProgramadorNetafim(file, {
                  equipo_id : vm.equipoSelected.id
                }).then(function(res) {
                  vm.loading = false;
                  vm.answer("ready");
                  $mdToast.show(
                      $mdToast.simple()
                          .textContent(res.data.msj)
                          .position(CONSTANTES.TOAST_POSITION)
                  );
                }, function(err) {
                  vm.loading = false;
                });
              }
            }],
          })
          .then(function(answer) {

          }, function() {

          });
    }

    vm.subirXlsProgramadorNetafim = function (file, data) {
      if (file !== null) {
        vm.xlsProgramadorNetafimLoading = true;
        vm.uploading = true;
      }
      var prom = tlFac.upload.netafim.programador(file,data);
      if(prom !== null){
        prom.then(function(){
          vm.xlsProgramadorNetafimLoading = false;
          vm.uploading = false;
        }, function(){
          vm.xlsProgramadorNetafimLoading = false;
          vm.uploading = false;
        });
      }
      return prom;
    };


    vm.xlsClima = function (file, invalidFiles) {
        vm.xlsClimaLoading = true;
        vm.uploading = true;
        tlFac.upload.clima.xls(file, invalidFiles,{
          vinedo_id: vm.vinedo_id
        }).then(function(){
          vm.xlsClimaLoading = false;
          vm.uploading = false;
          //vm.redraw();
        });
    };

    vm.xlsSensores= function (file, invalidFiles) {
        if (file !== null) {
          vm.xlsSensoresLoading = true;
          vm.uploading = true;
        }
        var fuPromise = tlFac.upload.sensores.xls(file, invalidFiles,{
          vinedo_id: vm.vinedo_id
        });
        if (fuPromise !== null) {
          fuPromise.then(function(res) {
            vm.xlsSensoresLoading = false;
            vm.uploading = false;
          }, function(res_error) {
            vm.xlsSensoresLoading = false;
            vm.uploading = false;
          });
        }
      };










    vm.xlsScholanderSR = function (file, invalidFiles) {
      if (file !== null) {
        vm.xlsScholanderSRLoading = true;
        vm.uploading = true;
      }
      var fuPromise = tlFac.upload.SR.xls(file, invalidFiles, {
        vinedo_id: vm.vinedo_id
      });
      if (fuPromise !== null) {
        fuPromise.then(function(res) {
          vm.xlsScholanderSRLoading = false;
          vm.uploading = false;
        }, function(res_error) {
          vm.xlsScholanderSRLoading = false;
          vm.uploading = false;
        });
      }
    };











    vm.xlsSensoresAtec = function (file, invalidFiles) {
      if (file !== null) {
        vm.xlsSensoresAtecLoading = true;
        vm.uploading = true;
      }
      var fuPromise = tlFac.upload.atec.xls(file, invalidFiles, {
         vinedo_id: vm.vinedo_id
      });
      if (fuPromise !== null) {
        fuPromise.then(function(res) {
          vm.xlsSensoresLoading = false;
          vm.uploading = false;
        }, function(res_error) {
          vm.xlsSensoresAtecLoading = false;
          vm.uploading = false;
        });
      }
    };











    vm.showDialogIrrimax = function(evt) {
        $mdDialog.show({
          templateUrl         : 'components/vinedo/sensores/irrimax.dialog.html',
          parent              : angular.element(document.body),
          targetEvent         : evt,
          clickOutsideToClose : true,
          controllerAs        : "d",
          bindToController    : true,
          locals              : {
            sectoresSensor: vm.sectoresSensor,
            subirXlsIrrimax: vm.xlsIrrimax
          },
          controller : ["$scope", function($scope) {
            var vm = this;
            vm.loading = false;

            function createFilterFor(query) {
              var lowercaseQuery = angular.lowercase(query);
              return function filterFn(sectorsensor) {
                return (angular.lowercase(sectorsensor.nombre).indexOf(lowercaseQuery) >= 0);
              };
            }

            vm.querySearch = function(query) {
              var r = query ? vm.sectoresSensor.filter( createFilterFor(query) ) : vm.sectoresSensor
              r.push({
                nombre: query,
                new: true
              });
              return r;
            }

            vm.hide = function() {
              $mdDialog.hide();
            };
            vm.cancel = function() {
              $mdDialog.cancel();
            };
            vm.answer = function(answer) {
              $mdDialog.hide(answer);
            };
            vm.subirXlsSensores = function(file, query) {
              vm.loading = true;
              vm.subirXlsIrrimax(file, {
                nombre_sector: query,
                vinedo_id: $stateParams.id
              }).then(function(res) {
                vm.loading = false;
                vm.answer("ready");
                $mdToast.show(
                  $mdToast.simple()
                  .textContent(res.data.msj)
                  .position(CONSTANTES.TOAST_POSITION)
                );
              }, function(err) {
                vm.loading = false;
              });
            }
          }],
        })
        .then(function(answer) {

        }, function() {

        });
      }

    vm.xlsIrrimax = function (file, data) {
      if (file !== null) {
        vm.xlsIrrimaxLoading = true;
        vm.uploading = true;
      }
      var fuPromise = tlFac.upload.irrimax.xls(file, data);

      var fnRes = function(res_error) {
        vm.xlsIrrimaxLoading = false;
        vm.uploading = false;
      }
      if (fuPromise !== null) {
        fuPromise.then(fnRes, fnRes);
        return fuPromise;
      }
    };

    vm.subirCsvEt = function (file, invalidFiles) {
      vm.loadingEtCsv = true;
      vm.uploading = true;
      var fnRes = function(){
        vm.loadingEtCsv = false;
        vm.uploading = false;
      }
      tlFac.upload.et.csv(file, invalidFiles,{
        vinedo_id: vm.vinedo_id,
      })
      .then(fnRes, fnRes);
    };

    vm.subirCsvTemp = function (file, invalidFiles) {
      vm.loadingTempCsv = true;
      vm.uploading = true;
      var fnRes = function (resp) {
        vm.loadingTempCsv = false;
        vm.uploading = false;
      }
      tlFac.upload.temperatura.csv(file, invalidFiles, {
        vinedo_id: vm.vinedo_id,
      })
      .then(fnRes, fnRes);
    };

    vm.subirCsvPrecip = function (file, invalidFiles) {
      vm.loadingPrecipCsv = true;
      vm.uploading = true;
      var fnRes =
        function (resp) {
        vm.loadingPrecipCsv = false;
        vm.uploading = false;
      };
      tlFac.upload.precipitacion.csv(file, invalidFiles,{
        vinedo_id: vm.vinedo_id,
      })
      .then(fnRes, fnRes);
    };


    vm.subirXlsMai = function (file, invalidFiles) {
      vm.loadingXlsMai = true;
      vm.uploading = true;
      var fnRes =

      function (resp) {
        $mdToast.show(
          $mdToast.simple()
          .content("XLS subido satisfactoriamente")
          .position(CONSTANTES.TOAST_POSITION)
          .hideDelay(3000)
        );
        vm.loadingXlsMai = false;
        vm.uploading = false;
      };

      tlFac.upload.mai.xls(file, invalidFiles,{
        vinedo_id: vm.vinedo_id,
      })
      .then(fnRes,function(res_error){
        console.error(res_error);
      });

    };


    vm.xlsClimaFormato = function(event){
      var p = vm.dialogTemporadas(event);
      p.then(function(temporadaSelected){
        var fnRes = function(){
          vm.formatoClimaLoading = false;
          vm.downloading = false;
        }
      tlFac.download.clima.xls({
        vinedo_id: vm.vinedo_id,
        vinedo_nombre: vm.vinedo_nombre,
        periodo : temporadaSelected.periodo
      }).then(fnRes, fnRes);
      });
    };

    vm.xlsRR = function (file, invalidFiles) {
      vm.xlsRRLoading = true;
      vm.uploading = true;
      var fnRes = function(){
          vm.xlsRRLoading = false;
          vm.uploading = false;
      };
      tlFac.upload.riego.xls(file, invalidFiles)
      .then(fnRes, fnRes);
    };

    vm.xlsRRTantehue = function (file, invalidFiles) {
      vm.xlsRRTantehueLoading = true;
      vm.uploading = true;
      var fnRes = function(){
            vm.xlsRRTantehueLoading = false;
            vm.uploading = false;
          };
      tlFac.upload.riego.tantehueXls(file, invalidFiles)
          .then(fnRes, fnRes);
    };

    vm.xlsScholander = function (file, invalidFiles) {
      vm.xlsScholanderLoading = true;
      vm.uploading = true;
      var fnRes = function(){
        vm.xlsScholanderLoading = false;
        vm.uploading = false;
      }
      tlFac.upload.scholander.xls(file, invalidFiles)
      .then(fnRes, fnRes);
    };

    vm.xlsRRFormato = function(event){
      var p = vm.dialogTemporadas(event);
      p.then(function(temporadaSelected) {
        var fnRes = function () {
            vm.formatoRRLoading = false;
            vm.downloading      = false;
          };
        tlFac.download.riego.xls(
            {
              vinedo_id    : vm.vinedo_id,
              vinedo_nombre: vm.vinedo_nombre,
              periodo : temporadaSelected.periodo
            }).then(fnRes, fnRes);
      });
    };

    vm.xlsScholanderFormato = function(event){
      var p = vm.dialogTemporadas(event);
      p.then(function(temporadaSelected) {
        var fnRes = function () {
          vm.formatoScholanderLoading = false;
          vm.downloading              = false;
        };
        tlFac.download.scholander.xls(
            {
              vinedo_id    : vm.vinedo_id,
              vinedo_nombre: vm.vinedo_nombre,
              periodo : temporadaSelected.periodo
            }).then(fnRes, fnRes);
      });
    };


    vm.loadingLfeXls = false;
    vm.downloadLFEXls = function(){
      /*
      fecha -- mm riego -- reposicion -- scholander (3 dias antes a la fecha de riego)
      */

      vm.loadingLfeXls = true;

      var fecha_fin    = moment().format("DD-MM-YYYY");
      var fecha_fin_str    = moment().format("DD MM YYYY");
      var fecha_inicio = moment().subtract(15, "days").format("DD-MM-YYYY");
      var fecha_inicio_str = moment().subtract(15, "days").format("DD MM YYYY");
      var prom = $http({
        url    : urls.BASE+"/vinedo/resumen",
        params :{
          fecha_fin: fecha_fin, //moment().format("DD-MM-YYYY"),
          fecha_inicio :fecha_inicio, // moment().subtract(15, "days").format("DD-MM-YYYY"),
          vinedo_id    : $stateParams.id
        }
      });
      prom.then(function(res){
        var equipos = res.data.data.vinedo.equipos;
        if(equipos){
          var sectores = _.flatMap(equipos, function(e){
            return _.map(e.sector_riego, function(s){
              var dias = _.map(_.filter(s.dias, {regue: true}), function(d){
                return {
                  sector : s.nombre,
                  fecha  : d.fecha,
                  mm     : _.round(d.mm_reales,2),
                  rep    : _.round(d.reposicion_real, 2)
                }
              });

              var diasScholander = _.filter(s.dias, function(d){return d.scholander != 0});

              _.forEach(dias, function(d){
                d.scholander = 0;
                var diasPrevios = _.filter(diasScholander, function(dsch){
                  return moment(dsch.fecha).isBetween(moment(d.fecha).subtract(3, "days"), moment(d.fecha), "day", "[]");
                });
                if(diasPrevios && diasPrevios.length > 0){
                  d.scholander = _.last(diasPrevios).scholander;
                }
              });
              /*
              get mm & rep
              filter regue
              */
              return dias
            });
          });
          //console.log(sectores);
          vm.toXls(_.flatten(sectores), { header:[
            {
              label: "Sector",
              var: "sector",
            },
            {
              label: "Fecha de riego",
              var: "fecha",
            },
            {
              label: "mm riego",
              var: "mm",
            },
            {
              label: "Reposición",
              var: "rep",
            },
            {
              label: "Scholander",
              var: "scholander",
            },
          ]}, "informe_lfe_"+vm.vinedo_nombre + " "+fecha_inicio_str+" al "+fecha_fin_str);


        }
      })
      .catch(function(resError){
        console.error(resError);
      })
      .finally(function(){
        vm.loadingLfeXls = false;
      });


    }


    vm.toXls = function(data, props, fileName){

      var fileName   = fileName || "archivo";
      var workbook   = XLSX.utils.book_new();
      var xlsDefault = {wpx:100};
      var headerVars = props.header || [];
      var rowsTop    = props.rowsTop || [];

      /*
      var headerVars = [{
          label:"Nombre",
          var:"Name",
          xls:{wpx:250}
        },
      {
        label: "indice",
          var:"Index"
      }];
      */

         var header = _.map(headerVars, h => h.label);
         /*
        var  data = [
            { Name: "Bill Clinton", Index: 42 },
            { Name: "GeorgeW Bush", Index: 43 },
            { Name: "Barack Obama", Index: 44 },
            { Name: "Donald Trump", Index: 45 }
          ];
          */

        //AoA == Array of Arrays
        var dataAoA = _.map(data, function(d){
          return _.map(headerVars, function(h){
            var r = _.get(d, h.var);
            r = h.round ? _.round(r, h.round) : r;
            return r;
          });
        });

        dataAoA.unshift(header);
        dataAoA = rowsTop.concat(dataAoA);

        var sheet = XLSX.utils.aoa_to_sheet(dataAoA);

        sheet["!cols"] = _.map(headerVars, h => h.xls || xlsDefault);
        XLSX.utils.book_append_sheet(workbook,sheet,"sheet name");

      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }


    //--------------------------------------------------------
    //    END Subida de archivos
    //--------------------------------------------------------





    //--------------------------------------------------------
    //    Multi inputs
    //--------------------------------------------------------




    var limpiarMultiInput = function() {
      vm.MIHora                = 0;
      vm.MIMin                 = 0;
      vm.MIVol                 = 0;
      vm.newScholander         = 0;
      vm.inputTempRiego        = 0;
      vm.inputHumedadRiego     = 0;
      vm.newPorometro          = 0;
      vm.newCalibre            = null;
      vm.newGramos             = null;
      vm.showMultiInput        = false;
      vm.validandoProgramacion = false;
      vm.litrosFertiriego      = 0 ;
      vm.conFertilizacion      = false;

      _.forEach(vm.calicataAlturas , function(altura){
        altura.value = "";
        altura.conductividad = "";
      });
      _.forEach(vm.profundidades, function(prof){
        prof.value = "";
      });
      _.forEach(vm.fertInputProductos, function(pro){
        pro.value = "";
      });
      vm.diasSeleccionados.splice(0, vm.diasSeleccionados.length);
      vm.ocultarSidebarRight();
    }

    /*
    vm.changeFertInputProductos = function(){
      _.forEach(vm.fertInputProductos, function(pro){
        pro.value = "";
      });
    }
    */





    vm.guardarMultiInput = function(){
      if (vm.usaMM) {
        //cuartelDia.sector existe
        angular.forEach(vm.diasSeleccionados, function(cuartelDia) {
          if (cuartelDia.dia.hasSubriego) {
            cuartelDia.dia.subRiegoMM = vm.MImm;
            cuartelDia.dia.subRiegoHoras = time;
          }
          cuartelDia.dia.mm_reales = vm.MImm;
          guardarReal(cuartelDia.dia, cuartelDia.sector, function() {
            regenerarSectorServer(cuartelDia.sector);
          });
        });
      }else{
        vm.MIHora = parseFloat(vm.MIHora);
        vm.MIMin = parseFloat(vm.MIMin);

        if(_.isNaN(vm.MIHora)){
          vm.MIHora = 0;
        }
        if(_.isNaN(vm.MIMin)){
          vm.MIMin = 0;
        }

        //var mHora = moment.duration(parseFloat(vm.MIHora), "hours");
        var mHora = floatToDuration(parseFloat(vm.MIHora));
        mHora.add(parseFloat(vm.MIMin), "minutes");

        var time = mHora.asHours();
        angular.forEach(vm.diasSeleccionados, function(cuartelDia) {
          /*
          if (cuartelDia.dia.hasSubriego) {
            cuartelDia.dia.subRiegoMM = vm.MImm;
            cuartelDia.dia.subRiegoHoras = time;
          }
          */
          cuartelDia.dia.horas_reales = time;
          guardarReal(cuartelDia.dia, cuartelDia.sector, function() {
            regenerarSectorServer(cuartelDia.sector);
          });

           insertVarSector({
            sector : cuartelDia.sector,
            dia    : cuartelDia.dia,
            type   : "horas_reales"
          });

        });
      }
      vm.guardarMensaje();
      limpiarMultiInput();
    }







    var guardarReal = function(dia, cuartel, callback){

          if(vm.usaMM){
            dia.horas_reales = dia.mm_reales / cuartel.precipitacion_sistema_mm;
            dia.mm_reales = dia.mm_reales ;
          }else{
            dia.mm_reales = dia.horas_reales * cuartel.precipitacion_sistema_mm;
            dia.horas_reales = dia.horas_reales;
          }

          if(vm.config.vinedo.conCaudalimetro && vm.diasSeleccionados.length == 1){
            dia.volumen_real = parseFloat(vm.MIVol);//obtiene vol de multiInput
            dia.volumen      = parseFloat(vm.MIVol);
            if (!vm.usaMM) {
                delete dia.mm_reales ; // asi el riego real se recalcula en backend
            }
          }else{
            //si no tiene caudalimetro, se recalcula el volumen
            dia.volumen_real = dia.mm_reales * cuartel.ha * 10;
            dia.volumen = dia.mm_reales * cuartel.ha * 10;
          }

          var data = {
            sector_riego_id : cuartel.id,
            //mm_reales       : dia.mm_reales ,
            horas_reales    : dia.horas_reales,
            volumen         : dia.volumen_real,
            fecha           : moment.unix(dia.unix).format("YYYY-MM-DD")
          };
          var dataFert = [];


          if(vm.conFertilizacion){
            _.forEach(vm.fertInputProductos, function(producto){
              if(parseInt(producto.value) > -1){
                var d = {
                  sector_riego_id : cuartel.id,
                  //cantidad        : producto.value,
                  fecha           : moment.unix(dia.unix).format("YYYY-MM-DD"),
                  producto_id     : producto.id,
                  tipo_aplicacion : vm.tipoFertilizacionSelected.id,
                  litros          : 0,
                  concentracion   : 0
                };

                if ( vm.tipoFertilizacionSelected.id == 3 && vm.litrosFertiriego) {
                  d.litros = parseFloat(vm.litrosFertiriego);
                }

                if(vm.tipoFertilizacionSelected.id == 3){
                  d.concentracion = parseFloat(producto.value);
                  d.cantidad = ( parseFloat(producto.value) * vm.litrosFertiriego) / 1000;
                }else if(vm.tipoFertilizacionSelected.id == 2){
                  //transforma unidad /ha a unidad total
                  d.cantidad = parseFloat(producto.value) * cuartel.ha;
                }else{
                  d.cantidad = producto.value;
                }

                dataFert.push(d);
              }
            });
          }



          if (dia.mm_reales  !== undefined) {
              dia.mm_reales  = _.round(dia.mm_reales , 1);
              data.mm_reales = dia.mm_reales ;
          }




          var saveFn = function(){
              if(dataFert.length > 0){
                var promises = [];
                _.forEach(dataFert, function(dataF){
                  promises.push(fertilizacionRes.postAplicacion(dataF).$promise);
                })
                $q.all(promises).then(function(){
                  CuartelRes.riegoDia(data, function (res) {
                    if(angular.isDefined(callback)){
                      callback(res);
                    }
                  })
                })
                //vm.conFertilizacion = false;
              }else{
                CuartelRes.riegoDia(data, function (res) {
                  if(angular.isDefined(callback)){
                    callback(res);
                  }
                });
              }
          }




          if(Offline.state == "up"){
            saveFn();
          }else{
            Offline.on("confirmed-up", function(){
              saveFn();
            });
          }

        }// END guardarReal










    vm.guardarMultiInputProgramacion = function(){
      var horas = 0;
      var mm = 0;

      angular.forEach(vm.diasSeleccionados, function(cuartelDia) {

        if(vm.usaMM){
          mm = parseFloat(vm.mm_programadas);
          horas = vm.mmProgramado / cuartelDia.sector.precipitacion_sistema_mm;
        }else{
          var mHoras = moment.duration(parseFloat(vm.hrsProgramado), "hours");
          mHoras.add(parseFloat(vm.minProgramado), "minutes");
          horas =  mHoras.asHours();
          mm = horas * cuartelDia.sector.precipitacion_sistema_mm;
          mm = _.round(mm, 2);
        }

        cuartelDia.dia.mm_programadas = mm;
        cuartelDia.dia.horas_programadas = horas;

        guardarProgramacion(cuartelDia.dia, cuartelDia.sector);
        verificarTotalHorasProgramadas(cuartelDia.equipo);
      });
      vm.guardarMensaje();
      limpiarMultiInput();
    }


    var verificarTotalHorasProgramadas = function(equipo){
      //TODO verificar total de horas de riego programado en un equipo, por dia
      // alertar si es mayor a 24
    }



    var guardarProgramacion = function(dia, cuartel){

      var data = {
        sector_riego_id   : cuartel.id,
        mm_programados    : dia.mm_programadas,
        horas_programadas : dia.horas_programadas,
        fecha             : moment.unix(dia.unix).format("YYYY-MM-DD")
      };

      var saveFn = function(){
        CuartelRes.riegoDia(data, function () {
          regenerarSectorServer(cuartel);
        });
      }

      if(Offline.state == "up"){
        saveFn();
      }else{
        Offline.on("confirmed-up", function(){
          saveFn();
        });
      }
    };


    vm.cancelarMultiInputProgramacion = function(){
      limpiarMultiInput();
    }

    //metodo generico
    vm.cancelarMultiInput = function(){
      limpiarMultiInput();
    }
    vm.cancelarMultiInputScholander = function(){
      limpiarMultiInput();
    }
    vm.cancelarMultiInputPorometro = function(){
      limpiarMultiInput();
    }
    vm.cancelarMultiInputCrecimiento = function(){
      limpiarMultiInput();
    }
    vm.cancelarMultiInputSensores = function(){
      limpiarMultiInput();
    }
    vm.cancelarMultiInputCalicata = function(){
      limpiarMultiInput();
    }



    vm.guardarMultiInputPorometro = function(){
      angular.forEach(vm.diasSeleccionados, function(cuartelDia) {
        cuartelDia.dia.porometro = vm.newPorometro;
        guardarPorometro(cuartelDia);
      });
      vm.guardarMensaje();
      limpiarMultiInput();
    }

    function guardarPorometro(cuartelDia) {
      var saveFn = function(){
        EquipoRes.porometro({
          fecha: moment.unix(cuartelDia.dia.unix).format("YYYY-MM-DD"),
          sector_id: cuartelDia.sectorPorometro.id,
          cantidad: cuartelDia.dia.porometro,
        }, function(){
          regenerarSectorServer(cuartelDia.sector)
        });
      }
      if(Offline.state == "up"){
        saveFn();
      }else{
        Offline.on("confirmed-up", function(){
          saveFn();
        });
      }

    }

    vm.guardarMultiInputScholander = function(){
      var promises = [];
      angular.forEach(vm.diasSeleccionados, function(cuartelDia) {
        cuartelDia.dia.scholander = vm.newScholander;
        promises.push(guardarScholander(cuartelDia).$promise);
      });
      Promise.all(promises).then(function(){
        vm.guardarMensaje();
        limpiarMultiInput();
      })
    }





    function guardarScholander (cuartelDia) {
      var saveFn = function(){
        return EquipoRes.schol({
          fecha: moment.unix(cuartelDia.dia.unix).format("YYYY-MM-DD"),
          sector_id: cuartelDia.sectorScholander,
          cantidad: parseFloat(cuartelDia.dia.scholander),
        }, function(){
          //done
          if(vm.config.vinedo.mai){
            //guardar mai
            $http.post(urls.BASE+"/mai/datos", {
              sector_riego_id : cuartelDia.sector.id,
              fecha           : moment.unix(cuartelDia.dia.unix).format("YYYY-MM-DD"),
              temperatura     : vm.inputTempRiego,
              humedad         : vm.inputHumedadRiego,
              scholander      : parseFloat(cuartelDia.dia.scholander)
            }).then(function(res){
              //devuelve delta_mai
              return regenerarSectorServer(cuartelDia.sector)
            }, function(res_error){
              console.error(res_error);
            })
          }else{
            return regenerarSectorServer(cuartelDia.sector)
          }
        });
      }
      if(Offline.state == "up"){
        return saveFn();
      }else{
        Offline.on("confirmed-up", function(){
          saveFn();
        });
      }
  }





    vm.guardarMultiInputCrecimiento = function(){
      angular.forEach(vm.diasSeleccionados, function(cuartelDia) {
        cuartelDia.dia.gramos = vm.newGramos;
        cuartelDia.dia.calibre = vm.newCalibre;
        guardarCrecimiento(cuartelDia);
      });
      vm.guardarMensaje();
      limpiarMultiInput();
    }

    function guardarCrecimiento(cuartelDia) {
      var data = {
        fecha     : moment.unix(cuartelDia.dia.unix).format("YYYY-MM-DD"),
        sector_riego_id : cuartelDia.sectorScholander,
      };

      if(cuartelDia.dia.gramos >= 0){
        data.gramos = cuartelDia.dia.gramos;
      }

      if(cuartelDia.dia.calibre >= 0){
        data.calibre = cuartelDia.dia.calibre ;
      }

      var saveFn = function(){
        CuartelRes.crecimiento(data, function(){
          regenerarSectorServer(cuartelDia.sector)
        });
      }

      if(Offline.state == "up"){
        saveFn();
      }else{
        Offline.on("confirmed-up", function(){
          saveFn();
        });
      }
    }






    //--------------------------------------------------------
    //   END Multi inputs
    //--------------------------------------------------------


    vm.addPrecip = function (dia, num) {
      if(num > 100 || num < 0){
        $mdToast.show($mdToast.simple().position('top right').textContent('ingrese precipitacion valida'));
      }else{
        vm.generalLoading = true;

        var thenFn = function(){
          vm.generalLoading = false;
        };

        var type = "precipitacion";
        var saveFn = function(){
          VinedoFac[type]({
            vinedo_id : $stateParams.id,
            //fecha     : moment(dia.unix).utc().hours(0).format(), // aun da problemas con horas
            fecha     : moment(dia.unix).add(12, "hours").utc().hours(0).format(),
            cantidad  : parseFloat(num),
          }, thenFn, thenFn);
        };

        if(Offline.state == "up"){
          saveFn();
        }else{
          Offline.on("confirmed-up", function(){
            saveFn();
          });
        }

        //TODO manejar fondo con precipitacion
        /*
        if (num > 0) {
          $("div[id$='"+$scope.diaEdit.unix+"']").addClass("con-precip");
        }else{
          $("div[id$='"+$scope.diaEdit.unix+"']").removeClass("con-precip");
        }
        */
        utils.setDiaPrecip(et_semanales, dia.unix / 1000, num);
        vm.diasPrecip = utils.getDiasPrecip(vm.equipos, et_semanales, fechaInicio, r);

      }
    };



    vm.addEt = function (dia, num, type) {

      if(num > 15 ){
        $mdToast.show($mdToast.simple().position('top right').textContent('ingrese et valida'));
      }else{

        vm.generalLoading = true;
        var thenFn = function(){
          vm.generalLoading = false;
        };

        var saveFn = function(){
          VinedoFac[type]({
            vinedo_id : $stateParams.id,
            //fecha     : moment(dia.unix).utc().hours(0).format(),
            fecha     : moment(dia.unix).add(12, "hours").utc().hours(0).format(),
            cantidad  : num,
          }, thenFn, thenFn);
        };

        if(Offline.state == "up"){
          saveFn();
        }else{
          Offline.on("confirmed-up", function(){
            saveFn();
          });
        }

      }
    };



    vm.addTMin = function(dia, num) {
      vm.addTemp(dia, num, "min");
    }
    vm.addTMax= function(dia, num) {
      vm.addTemp(dia, num, "max");
    }
    vm.addTMed = function(dia, num) {
      vm.addTemp(dia, num, "med");
    }


    vm.addTemp = function (dia, num, typeTemp) {
      if(num > 50  || num < -30){
        $mdToast.show($mdToast.simple().position('top right').textContent('ingrese temperatura valida'));
      }else{
        vm.generalLoading = true;

        var thenFn = function(){
          vm.generalLoading = false;
        };

        var type = "temperatura"+typeTemp;
        var saveFn = function(){
          var a = VinedoFac[type]({
            vinedo_id : $stateParams.id,
            //fecha     : moment(dia.unix).utc().hours(0).format(),
            fecha     : moment(dia.unix).add(12, "hours").utc().hours(0).format(),
            cantidad  : num,
          }, thenFn, thenFn);
        };

        if(Offline.state == "up"){
          saveFn();
        }else{
          Offline.on("confirmed-up", function(){
            saveFn();
          });
        }

      }
    };

    //--------------------------------------------------------
    //--------------------------------------------------------


      vm.agregarNuevoSectorSensor = function(res) {
        var nuevoSectorSensor = {
          id:0,
          nombre:"",
          _sensores:[
            {
              id:0,
              altura:30,
              datos: [{
                fecha: 12345,
                cantidad: 12.34
              }]
            }
          ]
        };
        _.forEach(res.data.data, function(dato, index){
          /*
              30_cm:0.292356014251709
              60_cm:0.1562439948320389
              cc:0.21
              fecha:{date: "2016-11-22 20:00:00.000000", timezone_type: 3, timezone: "America/Santiago"}
              pmp:0.074
              umbral:0.142
          * */
        });
      }


vm.showDialogAAContinuo = function(evt) {

  VinedoRes.getSensores({vinedo_id: $stateParams.id, fecha: new Date(), periodo:vm.temporadaActiva.periodo},
    function(estadisticas){
      var estadisticas = estadisticas.data;
      var sectores     = estadisticas.sectores;

      $mdDialog.show({
        templateUrl         : 'components/vinedo/sensores/AAContinuo.dialog.html',
        parent              : angular.element(document.body),
        targetEvent         : evt,
        clickOutsideToClose : true,
        controllerAs        : "d",
        bindToController    : true,
        locals              : {
          sectoresSensor: sectores,
          subirXlsAAContinuo: vm.subirXlsAAContinuo,
          agregarNuevoSectorSensor: vm.agregarNuevoSectorSensor
        },
        controller : ["$scope", function($scope) {
          var vm     = this;
          vm.loading = false;

          function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(sectorsensor) {
              return (angular.lowercase(sectorsensor.nombre).indexOf(lowercaseQuery) >= 0);
            };
          }

          vm.querySearch = function(query) {
            var r = query !=="" ? vm.sectoresSensor.filter( createFilterFor(query) ) : vm.sectoresSensor
            if(query !== ""){
              r.push({
                nombre: query,
                new: true
              });
            }
            return r;
          }

          vm.hide = function() {
            $mdDialog.hide();
          };
          vm.cancel = function() {
            $mdDialog.cancel();
          };
          vm.answer = function(answer) {
            $mdDialog.hide(answer);
          };
          vm.subirXlsSensores = function(file, query) {
            vm.loading = true;
            vm.subirXlsAAContinuo(file, {
              nombre_sector: query,
              vinedo_id: $stateParams.id
            }).then(function(res) {
              vm.loading = false;
              vm.answer("ready");
              //vm.agregarNuevoSectorSensor(res); //TODO refrescar con tadtos de respuesta
              //vm.selectSectorSensor();
              $mdToast.show(
                $mdToast.simple()
                .textContent("Subido XLS de manera exitosa")
                .position(CONSTANTES.TOAST_POSITION)
              );
            }, function(err) {
              vm.loading = false;
            });
          }
        }],
      })
        .then(function(answer) {

        }, function() {

        });
    });
}

      vm.subirXlsAAContinuo = function (file, data) {
        if (file !== null) {
          vm.xlsSensorAALoading = true;
        }
        var fileProgress = 0;
        var fuPromise = File.upload(file, null, 'vinedo/excel-sensores-acevedo', 'archivo', data, false);
        if (fuPromise !== null) {
          fuPromise.then(function(res) {
            vm.xlsSensorAALoading = false;
            vm.fileProgress = null;
          }, function(res_error) {
            vm.xlsSensorAALoading = false;
            console.error(res_error);
          }, function(evt) {
            // Math.min is to fix IE which reports 200% sometimes
            fileProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });
          return fuPromise;
        }
      };




      vm.subirXlsAADiscontinuo = function (file, invalidFiles) {
        if (file !== null) {
          vm.xlsSensorAALoading = true;
        }
        var fuPromise = File.upload(file, invalidFiles, 'vinedo/sensores-aaa', 'archivo');
        if (fuPromise !== null) {
          fuPromise.then(function(res) {
            vm.xlsSensorAALoading = false;
            vm.fileProgress = null;
            $mdToast.show(
                $mdToast.simple()
                    .textContent("Subido XLS de manera exitosa")
                    .position(CONSTANTES.TOAST_POSITION)
            );
          }, function(res_error) {
            vm.xlsSensorAALoading = false;
            console.error(res_error);
          }, function(evt) {
            // Math.min is to fix IE which reports 200% sometimes
            vm.fileProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });
        }
      };



    vm.changeMensaje = function(){
      vm.mensajeInputDirty = true;
    }

    vm.guardarMensaje = function(){
      if(!vm.mensajeInputDirty) return;
      var cuartel = {};
      var dia     = {};

      angular.forEach(vm.diasSeleccionados, function(cuartelDia){

        cuartel = cuartelDia.sector;
        angular.forEach(cuartel.dias, function(diaC) {
          if (moment.unix(diaC.unix).add(6, "hours")
              .isSame(moment.unix(cuartelDia.dia.unix), "day")) {
            dia = diaC;
          }
        })

        /*
        if($scope.mensajeInput == ""){
          $("#"+cuartel.id+"-"+dia.unix+"").removeClass("has-msj");
        }else{
          $("#"+cuartel.id+"-"+dia.unix+"").addClass("has-msj");
        }
        */

          var mensaje = {
            mensaje            : vm.mensajeInput,
            fecha_editado      : new Date(),
            fecha_editado_unix : moment().unix(),
            usuario            : global.me.user.email
          }
        if (angular.isUndefined(dia.mensaje.id)) {
          dia.mensaje = mensaje;
        }else{
          mensaje.id = dia.mensaje.id;
          dia.mensaje = mensaje;
        }

        var data = {
          sector_riego_id : cuartel.id,
          mensaje         : vm.mensajeInput,
          fecha           : moment.unix(dia.unix).add(6, "hours").format()
        };
        if (angular.isDefined(dia.mensaje) && angular.isDefined(dia.mensaje.id)) {
          data.id = dia.mensaje.id;
        }
        CuartelRes.mensaje(data).$promise.then(function(res){
          dia.mensaje.id = res.mensaje.id;
        });
        prepareSector(cuartel);
      });
      vm.cancelarMultiInput();//metodo del estado riego,
      vm.mensajeInput = "";
      vm.mensajeInputDirty = false;

    };








    vm.dialogTemporadas = function(event){
      return temporadaFac.dialogSelectTemporada(event);
    }








    vm.dialogPdfEquipo = function(event){
      if (vm.view == 'vinedo'){
          $mdDialog.show({
            controller          : "dialogTimetablePdfEquipoCtrl",
            templateUrl         : 'shared/timeTable/lightbox/dialogPdfEquipo.tmpl.html',
            parent              : angular.element(document.body),
            targetEvent         : event,
            clickOutsideToClose : true,
            locals              : {
              vinedo: vm.data.vinedo
            }
          });
      }else{
        vm.pdfLoading = true;
        var fecha = moment(new Date()).startOf('week').toDate().cleanHour();
        File.download(
          urls.BASE+'/pdf/orden-riego',
          {
            equipo_id: vm.equipos[0].id,
            filename: vm.equipos[0].nombre+"_"+moment(fecha).format('DD MMM YYYY')+".pdf",
            fecha: fecha
          },
          function(){
            vm.pdfLoading = true;
          },
          function(){
            //success
            vm.pdfLoading = false;
          },
          function(){
            //error
            vm.pdfLoading = false;
          }
        );
      }
    };



    //eventos para scroll en sidebar
    $sidebar
    .add($sidebarExtended)
    .add($header)
    .on("mousewheel", function(e) {
      var x = e.deltaX;
      var y = e.deltaY;
      var a = $tlc.scrollTop();
      var l = $tlc.scrollLeft();
      $tlc.scrollLeft(l + x);
      $tlc.scrollTop(a - y);
      return false;
    });

    var isDragging = false;
    var lastNumberX = 0;
    var lastNumberY = 0;
    var diffX = 0;
    var diffY = 0;
    $sidebar
        .add($sidebarExtended)
        .add($header)
        .on("mousedown touchstart", function(e) {
          isDragging = true;
          if(e.touches){
            var touch = e.touches[0];
            lastNumberX = touch.clientX;
            lastNumberY = touch.clientY;
          }
        })
        .on("touchmove mousemove", function(e) {
          if(isDragging || e.touches){
            var touch = e.touches[0];//BUG
            var clientX = e.clientX || touch.clientX;
            var clientY = e.clientY || touch.clientY;

            diffX = clientX - lastNumberX;
            diffY = clientY - lastNumberY;

            lastNumberX = clientX;
            lastNumberY = clientY;

            var l = $tlc.scrollLeft();
            $tlc.scrollLeft(l - diffX);
            var a = $tlc.scrollTop();
            $tlc.scrollTop(a - diffY);
          }
        })
        .on("mouseup touchend", function() {
          isDragging = false;
        });



    function drawBoard(p){

      //grid width and height
      var bw = p.width;
      var bh = p.height;
      var sw = p.square.width;
      var sh = p.square.height;

      //padding around grid
      var p = 0;

      //size of canvas
      var cw = bw + (p*2) + 1;
      var ch = bh + (p*2) + 1;

      var canvas = $canvas.attr({width: cw, height: ch}).appendTo($tlc);
      vm.canvasWidth = cw;

      var context = canvas.get(0).getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);

      var colorVar = "";
      switch (vm.selectedTab) {
        case vm.cons.TAB_SCHOLANDER:
          colorVar="scholander";
          break;
        case vm.cons.TAB_POROMETRIA:
          colorVar="porometro";
          break;
        case vm.cons.TAB_PROGRAMACION:
          colorVar="riegoProgramado";
          break;
        case vm.cons.TAB_FENOLOGIA:
          colorVar="fenologia";
          break;
        case vm.cons.TAB_RIEGO:
          colorVar="riegoReal";
          break;
        case vm.cons.TAB_SENSORES:
          colorVar="sensores";
          break;
        case vm.cons.TAB_CRECIMIENTO:
          colorVar="crecimientoFruto";
          break;
        default:
          colorVar="riegoReal";
      }

      context.fillStyle = Config.colors[colorVar].weekend;

      for (var x = 0; x <= bw; x += sw) {
        //context.moveTo(0.5 + x + p, p);
        if (x != 0) {
          if (x%(7*sw) == 0) {
            context.fillRect(0.5+x + p - 2*sw, p, sw*2,bh);
          }
        }
      }

      for (var x = 0; x <= bw; x += sw) {
        context.moveTo(0.5 + x + p, p);
        context.lineTo(0.5 + x + p, bh + p);
      }
      for (var x = 0; x <= bh; x += sh) {
        context.moveTo(p, 0.5 + x + p);
        context.lineTo(bw + p, 0.5 + x + p);
      }

      context.strokeStyle = "rgba(0, 0, 0, 0.3)";
      context.stroke();
    }

  }













//------------------------------------------------------------------------------

  /**
    * @ngdoc directive
    * @name irricrops.timeTable
    * @module irricrops
    * @restrict E
    * @scope view si es vinedo o equipo
    * @scope volumenes volumenes para mostrar en la tabla inferior del timetable
    * @description
    * Directiva de timeTable
    *
  **/
  angular.module('irricrops')
  .directive('newTimeline', function(){
    return {
      restrict: "E",
      templateUrl: "components/vinedo/newtimeline/newtimeline.tmpl.html",
      scope:{
        view      : '@',
        volumenes : '=',
        estadosVinedo : '=',
        vinedo    : '=',
        //sectoresSensor:'='
      },
      controller: "newtimelineCtrl",
      bindToController: true,
      controllerAs: 'tl'
    };
  })//Fin directive newtimeline


//DIRECTIVES-----

.directive('timeOnlyNumbers', function () {
    return  {
        restrict: 'A',
        link: function (scope, elm, attrs, ctrl) {
            elm.on('keydown', function (event) {
                if ([8, 9, 13, 16, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {
                    // backspace, tab, enter, shift, escape, arrows
                    return true;
                } else if (event.which >= 48 && event.which <= 57) {
                    // numbers 0 to 9
                    return true;
                } else if (event.which >= 96 && event.which <= 105) {
                    // numpad number
                    return true;
                }
                // else if ([110, 190].indexOf(event.which) > -1) {
                //     // dot and numpad dot
                //     return true;
                // }
                else {
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
})

.directive('selectOnClick', ['$window', function ($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function () {
                if (!$window.getSelection().toString()) {
                  // Required for mobile Safari
                   if(this.setSelectionRange){
                    this.setSelectionRange(0, this.value.length)
                   }
                }
            });
        }
    };
}])

  .directive('duration', function() {
    return {
      restrict: 'E',
      scope: {
        duration: '=',
        onChange:'&'
      },
      controller: ["$scope", "$element", "$timeout", function($scope, $element, $timeout) {

        var vm         = $scope;
        vm.hh          = "";
        vm.mm          = "";
        vm.newDuration = _.clone(vm.duration);
        var debounced  = null;



        $scope.$watchCollection(function(){return vm.duration}, function(a, b, c) {
          if(vm.duration != vm.newDuration){
           vm.init()
          }
         });




        vm.init = function(){
          var duration = vm.duration;
          var mmNum = Math.round((duration - parseInt(duration))*60);
          var hhNum = Math.round(duration - (mmNum/60));

          //--round time
          vm.hhStr = (hhNum < 10 ? "0" : "") + (hhNum) + "";
          vm.mmStr = (mmNum < 10 ? "0" : "") + (mmNum) + "";

          vm.hh = vm.hhStr;
          vm.mm = vm.mmStr;

          vm.newDuration = duration;

          if(vm.onChange){
            if(debounced){
              debounced.cancel();
            }
            debounced = _.debounce(function(){
              vm.newDuration = _.round(vm.newDuration, 2);
              vm.duration = vm.newDuration;
              vm.$apply();
              if(vm.onChange){
                  vm.onChange();
              }
            }, 2000);
          }
        }
        vm.init();






        vm.change = function(a, b, c){
          var hhNum = parseFloat(vm.hh || 0);
          var mmNum = parseFloat(vm.mm || 0);
          //--round time
          vm.hhStr = (hhNum < 10 ? "0":"") + (hhNum)+"";
          vm.mmStr = (mmNum < 10 ? "0":"") + (mmNum)+"";

          var duration = hhNum + mmNum/60;

          vm.hh = vm.hhStr;
          vm.mm = vm.mmStr;
          vm.newDuration = duration;
          if(debounced){
            debounced();
          }
        }





        /*
        vm.blur = function(a, b, c){
          console.log("blur");
          var hhNum = parseFloat(vm.hh || 0);
          var mmNum = parseFloat(vm.mm || 0);

          var duration = hhNum + mmNum/60;
          mmNum = Math.round((duration - parseInt(duration))*60);
          hhNum = Math.round(duration - (mmNum/60));

          //--round time
          vm.hhStr = (hhNum < 10 ? "0":"") + (hhNum)+"";
          vm.mmStr = (mmNum < 10 ? "0":"") + (mmNum)+"";

          vm.hh = vm.hhStr;
          vm.mm = vm.mmStr;
          vm.newDuration = duration;
            if(debounced){
              debounced();
             }
        }
        */






      }],
      template:
      '<div class="duration-container">'+
        '<input type="text" placeholder="00" time-only-numbers select-on-click ng-model="hh" ng-change="change()" ng-blur="blur()" style="width:{{hhStr.length*10}}px">:'+
        '<input type="text" placeholder="00" time-only-numbers select-on-click ng-model="mm" ng-change="change()" ng-blur="blur()" style="width:{{mmStr.length*10}}px">'+
      '</div>',
      replace: true
    };
  })




      .controller("ListBottomSheetCtrl", ["$mdBottomSheet",
        function ($mdBottomSheet) {
        var vmLB   = this;
        vmLB.items = [
          {name : 'Riego Real', icon : 'format_color_fill', tag:'riego'},
          {name : 'Scholander', icon : 'slow_motion_video', tag:'scholander'},
          {name : 'Cancelar', icon : 'cancel', tag:'cancelar'},
        ];
        vmLB.listItemClick = function ($index, ev) {
          var clickedItem = vmLB.items[$index];
          $mdBottomSheet.hide(clickedItem, ev);
        };
      }]);

})();
